var map = {
	"./": [
		81418,
		9
	],
	"./App": [
		1441,
		9
	],
	"./App.scss": [
		55436,
		9
	],
	"./App.tsx": [
		1441,
		9
	],
	"./assets/configs/constants": [
		36851,
		9
	],
	"./assets/configs/constants.ts": [
		36851,
		9
	],
	"./assets/image/common/GradientImages": [
		87037,
		3,
		87037
	],
	"./assets/image/common/GradientImages.json": [
		87037,
		3,
		87037
	],
	"./assets/image/common/GradientImages.png": [
		8440,
		1,
		8440
	],
	"./assets/image/common/GradientImages.scss": [
		26369,
		9,
		26369
	],
	"./assets/image/common/andarbahar/abCard1": [
		86082,
		3,
		86082
	],
	"./assets/image/common/andarbahar/abCard1.json": [
		86082,
		3,
		86082
	],
	"./assets/image/common/andarbahar/abCard1.png": [
		39393,
		1,
		39393
	],
	"./assets/image/common/andarbahar/abCard1.scss": [
		56878,
		9,
		56878
	],
	"./assets/image/common/andarbahar/abCard2": [
		88595,
		3,
		88595
	],
	"./assets/image/common/andarbahar/abCard2.json": [
		88595,
		3,
		88595
	],
	"./assets/image/common/andarbahar/abCard2.png": [
		90410,
		1,
		90410
	],
	"./assets/image/common/andarbahar/abCard2.scss": [
		39623,
		9,
		39623
	],
	"./assets/image/common/andarbahar/andarBaharSheet": [
		20063,
		3,
		20063
	],
	"./assets/image/common/andarbahar/andarBaharSheet.json": [
		20063,
		3,
		20063
	],
	"./assets/image/common/andarbahar/andarBaharSheet.png": [
		31806,
		1,
		31806
	],
	"./assets/image/common/andarbahar/andarBaharSheet.scss": [
		78775,
		9,
		78775
	],
	"./assets/image/common/andarbahar/andarbahar_betarea": [
		39357,
		3,
		39357
	],
	"./assets/image/common/andarbahar/andarbahar_betarea.json": [
		39357,
		3,
		39357
	],
	"./assets/image/common/andarbahar/andarbahar_betarea.png": [
		33160,
		1,
		33160
	],
	"./assets/image/common/andarbahar/andarbahar_betarea.scss": [
		43033,
		9,
		43033
	],
	"./assets/image/common/andarbahar/andarbahar_text": [
		75582,
		3,
		75582
	],
	"./assets/image/common/andarbahar/andarbahar_text.json": [
		75582,
		3,
		75582
	],
	"./assets/image/common/andarbahar/andarbahar_text.png": [
		45413,
		1,
		45413
	],
	"./assets/image/common/andarbahar/andarbahar_text.scss": [
		59586,
		9,
		37205
	],
	"./assets/image/common/baccarat/top_black.png": [
		17521,
		1,
		17521
	],
	"./assets/image/common/baccarat/tradbaccBg": [
		84108,
		3,
		84108
	],
	"./assets/image/common/baccarat/tradbaccBg.json": [
		84108,
		3,
		84108
	],
	"./assets/image/common/baccarat/tradbaccBg.png": [
		74791,
		1,
		74791
	],
	"./assets/image/common/baccarat/tradbaccBg.scss": [
		59400,
		9,
		59400
	],
	"./assets/image/common/baccarat/tradbaccRoadmapBg": [
		60370,
		3,
		60370
	],
	"./assets/image/common/baccarat/tradbaccRoadmapBg.json": [
		60370,
		3,
		60370
	],
	"./assets/image/common/baccarat/tradbaccRoadmapBg.png": [
		94065,
		1,
		94065
	],
	"./assets/image/common/baccarat/tradbaccRoadmapBg.scss": [
		93434,
		9,
		93434
	],
	"./assets/image/common/betlog/cardrank": [
		87269,
		3,
		87269
	],
	"./assets/image/common/betlog/cardrank.json": [
		87269,
		3,
		87269
	],
	"./assets/image/common/betlog/cardrank.png": [
		90160,
		1,
		90160
	],
	"./assets/image/common/betlog/cardrank.scss": [
		45045,
		9,
		45045
	],
	"./assets/image/common/betlog/cardrankred": [
		97384,
		3,
		97384
	],
	"./assets/image/common/betlog/cardrankred.json": [
		97384,
		3,
		97384
	],
	"./assets/image/common/betlog/cardrankred.png": [
		24603,
		1,
		24603
	],
	"./assets/image/common/betlog/cardrankred.scss": [
		71756,
		9,
		71756
	],
	"./assets/image/common/betlog/cardsuit": [
		17110,
		3,
		17110
	],
	"./assets/image/common/betlog/cardsuit.json": [
		17110,
		3,
		17110
	],
	"./assets/image/common/betlog/cardsuit.png": [
		7949,
		1,
		7949
	],
	"./assets/image/common/betlog/cardsuit.scss": [
		53706,
		9,
		53706
	],
	"./assets/image/common/blackjack/bj_icon": [
		61738,
		3,
		61738
	],
	"./assets/image/common/blackjack/bj_icon.json": [
		61738,
		3,
		61738
	],
	"./assets/image/common/blackjack/bj_icon.png": [
		80697,
		1,
		80697
	],
	"./assets/image/common/blackjack/bj_icon.scss": [
		53686,
		9,
		53686
	],
	"./assets/image/common/blackjack/bj_seats": [
		57231,
		3,
		57231
	],
	"./assets/image/common/blackjack/bj_seats.json": [
		57231,
		3,
		57231
	],
	"./assets/image/common/blackjack/bj_seats.png": [
		28510,
		1,
		28510
	],
	"./assets/image/common/blackjack/bj_seats.scss": [
		30431,
		9
	],
	"./assets/image/common/blackjack/bj_seats2": [
		78479,
		3,
		78479
	],
	"./assets/image/common/blackjack/bj_seats2.json": [
		78479,
		3,
		78479
	],
	"./assets/image/common/blackjack/bj_seats2.png": [
		51054,
		1,
		51054
	],
	"./assets/image/common/blackjack/bj_seats2.scss": [
		85903,
		9
	],
	"./assets/image/common/blackjack/chip_black_white.png": [
		75561,
		1
	],
	"./assets/image/common/cert_logo.png": [
		13672,
		1,
		13672
	],
	"./assets/image/common/chip": [
		61481,
		3,
		61481
	],
	"./assets/image/common/chip.json": [
		61481,
		3,
		61481
	],
	"./assets/image/common/chip.png": [
		54620,
		1,
		54620
	],
	"./assets/image/common/chip.scss": [
		82589,
		9,
		82589
	],
	"./assets/image/common/commonUI": [
		18776,
		3,
		18776
	],
	"./assets/image/common/commonUI.json": [
		18776,
		3,
		18776
	],
	"./assets/image/common/commonUI.png": [
		13339,
		1,
		13339
	],
	"./assets/image/common/commonUI.scss": [
		12428,
		9,
		12428
	],
	"./assets/image/common/dt/betAreaDtBorder.png": [
		88947,
		1
	],
	"./assets/image/common/lobby/lobby": [
		44802,
		3,
		44802
	],
	"./assets/image/common/lobby/lobby.json": [
		44802,
		3,
		44802
	],
	"./assets/image/common/lobby/lobby.png": [
		12753,
		1,
		12753
	],
	"./assets/image/common/lobby/lobby.scss": [
		70902,
		9,
		70902
	],
	"./assets/image/common/lobby/star_anim_active": [
		13741,
		3,
		13741
	],
	"./assets/image/common/lobby/star_anim_active.json": [
		13741,
		3,
		13741
	],
	"./assets/image/common/lobby/star_anim_active.png": [
		86024,
		1,
		86024
	],
	"./assets/image/common/lobby/star_anim_active.scss": [
		80953,
		9,
		80953
	],
	"./assets/image/common/lobby/star_anim_inactive": [
		96162,
		3,
		96162
	],
	"./assets/image/common/lobby/star_anim_inactive.json": [
		96162,
		3,
		96162
	],
	"./assets/image/common/lobby/star_anim_inactive.png": [
		94993,
		1,
		94993
	],
	"./assets/image/common/lobby/star_anim_inactive.scss": [
		76614,
		9,
		76614
	],
	"./assets/image/common/multibet/multibet_game": [
		34995,
		3,
		34995
	],
	"./assets/image/common/multibet/multibet_game.json": [
		34995,
		3,
		34995
	],
	"./assets/image/common/multibet/multibet_game.png": [
		44074,
		1,
		44074
	],
	"./assets/image/common/multibet/multibet_game.scss": [
		18647,
		9,
		18647
	],
	"./assets/image/common/poker": [
		37828,
		3,
		37828
	],
	"./assets/image/common/poker.json": [
		37828,
		3,
		37828
	],
	"./assets/image/common/poker.png": [
		57247,
		1,
		57247
	],
	"./assets/image/common/poker.scss": [
		50400,
		9,
		50400
	],
	"./assets/image/common/promotionTool/event_splash_preload_bg.jpg": [
		18346,
		1
	],
	"./assets/image/common/promotionTool/promotion_tool": [
		2543,
		3,
		2543
	],
	"./assets/image/common/promotionTool/promotion_tool.json": [
		2543,
		3,
		2543
	],
	"./assets/image/common/promotionTool/promotion_tool.png": [
		9998,
		1,
		9998
	],
	"./assets/image/common/promotionTool/promotion_tool.scss": [
		25791,
		9
	],
	"./assets/image/common/promotionTool/promotion_tool_figures": [
		95757,
		3,
		95757
	],
	"./assets/image/common/promotionTool/promotion_tool_figures.json": [
		95757,
		3,
		95757
	],
	"./assets/image/common/promotionTool/promotion_tool_figures.png": [
		33512,
		1,
		33512
	],
	"./assets/image/common/promotionTool/promotion_tool_figures.scss": [
		41049,
		9
	],
	"./assets/image/common/promotionTool/scratch_card": [
		34514,
		3,
		34514
	],
	"./assets/image/common/promotionTool/scratch_card.json": [
		34514,
		3,
		34514
	],
	"./assets/image/common/promotionTool/scratch_card.png": [
		71425,
		1,
		71425
	],
	"./assets/image/common/promotionTool/scratch_card.scss": [
		96602,
		9
	],
	"./assets/image/common/roulette/roulette": [
		16636,
		3,
		16636
	],
	"./assets/image/common/roulette/roulette.json": [
		16636,
		3,
		16636
	],
	"./assets/image/common/roulette/roulette.png": [
		96535,
		1,
		96535
	],
	"./assets/image/common/roulette/roulette.scss": [
		15120,
		9
	],
	"./assets/image/common/sedie/sedie_betarea": [
		97767,
		3,
		97767
	],
	"./assets/image/common/sedie/sedie_betarea.json": [
		97767,
		3,
		97767
	],
	"./assets/image/common/sedie/sedie_betarea.png": [
		15462,
		1,
		15462
	],
	"./assets/image/common/sedie/sedie_betarea.scss": [
		70275,
		9,
		70275
	],
	"./assets/image/common/sedie/sedie_sheet": [
		31434,
		3,
		31434
	],
	"./assets/image/common/sedie/sedie_sheet.json": [
		31434,
		3,
		31434
	],
	"./assets/image/common/sedie/sedie_sheet.png": [
		24105,
		1,
		24105
	],
	"./assets/image/common/sedie/sedie_sheet.scss": [
		3958,
		9,
		3958
	],
	"./assets/image/common/sicbo/dices_stroke": [
		8465,
		3,
		8465
	],
	"./assets/image/common/sicbo/dices_stroke.json": [
		8465,
		3,
		8465
	],
	"./assets/image/common/sicbo/dices_stroke.png": [
		98340,
		1,
		98340
	],
	"./assets/image/common/sicbo/dices_stroke.scss": [
		40977,
		9,
		40977
	],
	"./assets/image/common/sicbo/double": [
		95609,
		3,
		95609
	],
	"./assets/image/common/sicbo/double.json": [
		95609,
		3,
		95609
	],
	"./assets/image/common/sicbo/double.png": [
		12540,
		1,
		12540
	],
	"./assets/image/common/sicbo/double.scss": [
		35069,
		9,
		35069
	],
	"./assets/image/common/sicbo/feature": [
		63282,
		3,
		63282
	],
	"./assets/image/common/sicbo/feature.json": [
		63282,
		3,
		63282
	],
	"./assets/image/common/sicbo/feature.png": [
		87457,
		1,
		87457
	],
	"./assets/image/common/sicbo/feature.scss": [
		19942,
		9,
		19942
	],
	"./assets/image/common/sicbo/popular": [
		75361,
		3,
		75361
	],
	"./assets/image/common/sicbo/popular.json": [
		75361,
		3,
		75361
	],
	"./assets/image/common/sicbo/popular.png": [
		24292,
		1,
		24292
	],
	"./assets/image/common/sicbo/popular.scss": [
		10601,
		9,
		10601
	],
	"./assets/image/common/sicbo/sicbo": [
		13286,
		3,
		13286
	],
	"./assets/image/common/sicbo/sicbo.json": [
		13286,
		3,
		13286
	],
	"./assets/image/common/sicbo/sicbo.png": [
		55469,
		1,
		55469
	],
	"./assets/image/common/sicbo/sicbo.scss": [
		29290,
		9,
		29290
	],
	"./assets/image/common/teenpatti/teenPatti": [
		81838,
		3,
		81838
	],
	"./assets/image/common/teenpatti/teenPatti.json": [
		81838,
		3,
		81838
	],
	"./assets/image/common/teenpatti/teenPatti.png": [
		63205,
		1,
		63205
	],
	"./assets/image/common/teenpatti/teenPatti.scss": [
		15122,
		9,
		15122
	],
	"./assets/image/common/video/bg_andar_bahar_mtable.jpg": [
		93645,
		1
	],
	"./assets/image/common/video/bg_baccarat_atable.jpg": [
		6847,
		1
	],
	"./assets/image/common/video/bg_baccarat_ctable.jpg": [
		40877,
		1
	],
	"./assets/image/common/video/bg_blackjack_atable.jpg": [
		90536,
		1
	],
	"./assets/image/common/video/bg_blackjack_atable_zoom.jpg": [
		63144,
		1
	],
	"./assets/image/common/video/bg_blackjack_mtable.jpg": [
		26972,
		1
	],
	"./assets/image/common/video/bg_blackjack_mtable_zoom.jpg": [
		59956,
		1
	],
	"./assets/image/common/video/bg_dragontiger_atable.jpg": [
		19814,
		1
	],
	"./assets/image/common/video/bg_dragontiger_mtable.jpg": [
		79562,
		1
	],
	"./assets/image/common/video/bg_pokdeng_atable.jpg": [
		20202,
		1
	],
	"./assets/image/common/video/bg_pokdeng_mtable.jpg": [
		60454,
		1
	],
	"./assets/image/common/video/bg_roulette_atable.jpg": [
		81686,
		1
	],
	"./assets/image/common/video/bg_roulette_ctable.jpg": [
		26792,
		1
	],
	"./assets/image/common/video/bg_roulette_mtable.jpg": [
		31610,
		1
	],
	"./assets/image/common/video/bg_sedie_atable.jpg": [
		86438,
		1
	],
	"./assets/image/common/video/bg_sedie_mtable.jpg": [
		4906,
		1
	],
	"./assets/image/common/video/bg_sicbo_atable.jpg": [
		64302,
		1
	],
	"./assets/image/common/video/bg_sicbo_mtable.jpg": [
		87714,
		1
	],
	"./assets/image/common/video/bg_teen_patti_mtable.jpg": [
		67979,
		1
	],
	"./assets/image/common/video/video": [
		37526,
		3,
		37526
	],
	"./assets/image/common/video/video.json": [
		37526,
		3,
		37526
	],
	"./assets/image/common/video/video.png": [
		76413,
		1,
		76413
	],
	"./assets/image/common/video/video.scss": [
		1538,
		9,
		1538
	],
	"./assets/image/common/video/video_liveVerification": [
		50154,
		3,
		50154
	],
	"./assets/image/common/video/video_liveVerification.json": [
		50154,
		3,
		50154
	],
	"./assets/image/common/video/video_liveVerification.png": [
		10745,
		1,
		10745
	],
	"./assets/image/common/video/video_liveVerification.scss": [
		37205,
		9,
		59586
	],
	"./assets/image/language/ar-001/andarbahar/andarbahar_text": [
		92689,
		3,
		92689
	],
	"./assets/image/language/ar-001/andarbahar/andarbahar_text.json": [
		92689,
		3,
		92689
	],
	"./assets/image/language/ar-001/andarbahar/andarbahar_text.png": [
		67172,
		1,
		67172
	],
	"./assets/image/language/ar-001/andarbahar/andarbahar_text.scss": [
		11233,
		9,
		11233
	],
	"./assets/image/language/ar-001/baccarat/bacc_betarea_label": [
		7493,
		3,
		7493
	],
	"./assets/image/language/ar-001/baccarat/bacc_betarea_label.json": [
		7493,
		3,
		7493
	],
	"./assets/image/language/ar-001/baccarat/bacc_betarea_label.png": [
		36688,
		1,
		36688
	],
	"./assets/image/language/ar-001/baccarat/bacc_betarea_label.scss": [
		49189,
		9,
		49189
	],
	"./assets/image/language/ar-001/dt/betAreaLabel_dt": [
		90982,
		3,
		90982
	],
	"./assets/image/language/ar-001/dt/betAreaLabel_dt.json": [
		90982,
		3,
		90982
	],
	"./assets/image/language/ar-001/dt/betAreaLabel_dt.png": [
		25933,
		1,
		25933
	],
	"./assets/image/language/ar-001/dt/betAreaLabel_dt.scss": [
		21262,
		9,
		21262
	],
	"./assets/image/language/ar-001/lobby/menu": [
		58906,
		3,
		58906
	],
	"./assets/image/language/ar-001/lobby/menu.json": [
		58906,
		3,
		58906
	],
	"./assets/image/language/ar-001/lobby/menu.png": [
		10169,
		1,
		10169
	],
	"./assets/image/language/ar-001/lobby/menu.scss": [
		2850,
		9,
		2850
	],
	"./assets/image/language/ar-001/multibet/multibet_betarea": [
		28632,
		3,
		28632
	],
	"./assets/image/language/ar-001/multibet/multibet_betarea.json": [
		28632,
		3,
		28632
	],
	"./assets/image/language/ar-001/multibet/multibet_betarea.png": [
		22859,
		1,
		22859
	],
	"./assets/image/language/ar-001/multibet/multibet_betarea.scss": [
		69496,
		9,
		69496
	],
	"./assets/image/language/ar-001/pokdeng/pokdeng_betarea": [
		26758,
		3,
		26758
	],
	"./assets/image/language/ar-001/pokdeng/pokdeng_betarea.json": [
		26758,
		3,
		26758
	],
	"./assets/image/language/ar-001/pokdeng/pokdeng_betarea.png": [
		26397,
		1,
		26397
	],
	"./assets/image/language/ar-001/pokdeng/pokdeng_betarea.scss": [
		88646,
		9,
		88646
	],
	"./assets/image/language/ar-001/promotiontool/event_title": [
		59237,
		3,
		59237
	],
	"./assets/image/language/ar-001/promotiontool/event_title.json": [
		59237,
		3,
		59237
	],
	"./assets/image/language/ar-001/promotiontool/event_title.png": [
		61024,
		1,
		61024
	],
	"./assets/image/language/ar-001/promotiontool/event_title.scss": [
		34925,
		9,
		34925
	],
	"./assets/image/language/ar-001/roulette/roul_betarea": [
		45834,
		3,
		45834
	],
	"./assets/image/language/ar-001/roulette/roul_betarea.json": [
		45834,
		3,
		45834
	],
	"./assets/image/language/ar-001/roulette/roul_betarea.png": [
		98265,
		1,
		98265
	],
	"./assets/image/language/ar-001/roulette/roul_betarea.scss": [
		53306,
		9,
		53306
	],
	"./assets/image/language/ar-001/sedie/sedie_betarea": [
		3110,
		3,
		3110
	],
	"./assets/image/language/ar-001/sedie/sedie_betarea.json": [
		3110,
		3,
		3110
	],
	"./assets/image/language/ar-001/sedie/sedie_betarea.png": [
		18973,
		1,
		18973
	],
	"./assets/image/language/ar-001/sedie/sedie_betarea.scss": [
		74614,
		9,
		74614
	],
	"./assets/image/language/ar-001/sicbo/feature": [
		73679,
		3,
		73679
	],
	"./assets/image/language/ar-001/sicbo/feature.json": [
		73679,
		3,
		73679
	],
	"./assets/image/language/ar-001/sicbo/feature.png": [
		28046,
		1,
		28046
	],
	"./assets/image/language/ar-001/sicbo/feature.scss": [
		59031,
		9,
		59031
	],
	"./assets/image/language/ar-001/sicbo/popular": [
		34920,
		3,
		34920
	],
	"./assets/image/language/ar-001/sicbo/popular.json": [
		34920,
		3,
		34920
	],
	"./assets/image/language/ar-001/sicbo/popular.png": [
		41227,
		1,
		41227
	],
	"./assets/image/language/ar-001/sicbo/popular.scss": [
		85108,
		9,
		85108
	],
	"./assets/image/language/ar-001/teenpatti/teenPatti_betArea": [
		44114,
		3,
		44114
	],
	"./assets/image/language/ar-001/teenpatti/teenPatti_betArea.json": [
		44114,
		3,
		44114
	],
	"./assets/image/language/ar-001/teenpatti/teenPatti_betArea.png": [
		977,
		1,
		977
	],
	"./assets/image/language/ar-001/teenpatti/teenPatti_betArea.scss": [
		54866,
		9,
		54866
	],
	"./assets/image/language/ar-001/trial/trial_image": [
		57301,
		3,
		57301
	],
	"./assets/image/language/ar-001/trial/trial_image.json": [
		57301,
		3,
		57301
	],
	"./assets/image/language/ar-001/trial/trial_image.png": [
		94320,
		1,
		94320
	],
	"./assets/image/language/ar-001/trial/trial_image.scss": [
		24925,
		9,
		24925
	],
	"./assets/image/language/bn-BN/andarbahar/andarbahar_text": [
		35567,
		3,
		35567
	],
	"./assets/image/language/bn-BN/andarbahar/andarbahar_text.json": [
		35567,
		3,
		35567
	],
	"./assets/image/language/bn-BN/andarbahar/andarbahar_text.png": [
		3854,
		1,
		3854
	],
	"./assets/image/language/bn-BN/andarbahar/andarbahar_text.scss": [
		38511,
		9,
		38511
	],
	"./assets/image/language/bn-BN/baccarat/bacc_betarea_label": [
		79123,
		3,
		79123
	],
	"./assets/image/language/bn-BN/baccarat/bacc_betarea_label.json": [
		79123,
		3,
		79123
	],
	"./assets/image/language/bn-BN/baccarat/bacc_betarea_label.png": [
		42378,
		1,
		42378
	],
	"./assets/image/language/bn-BN/baccarat/bacc_betarea_label.scss": [
		49779,
		9,
		49779
	],
	"./assets/image/language/bn-BN/dt/betAreaLabel_dt": [
		48632,
		3,
		48632
	],
	"./assets/image/language/bn-BN/dt/betAreaLabel_dt.json": [
		48632,
		3,
		48632
	],
	"./assets/image/language/bn-BN/dt/betAreaLabel_dt.png": [
		71531,
		1,
		71531
	],
	"./assets/image/language/bn-BN/dt/betAreaLabel_dt.scss": [
		92504,
		9,
		92504
	],
	"./assets/image/language/bn-BN/lobby/menu": [
		22156,
		3,
		22156
	],
	"./assets/image/language/bn-BN/lobby/menu.json": [
		22156,
		3,
		22156
	],
	"./assets/image/language/bn-BN/lobby/menu.png": [
		7639,
		1,
		7639
	],
	"./assets/image/language/bn-BN/lobby/menu.scss": [
		81108,
		9,
		81108
	],
	"./assets/image/language/bn-BN/multibet/multibet_betarea": [
		5674,
		3,
		5674
	],
	"./assets/image/language/bn-BN/multibet/multibet_betarea.json": [
		5674,
		3,
		5674
	],
	"./assets/image/language/bn-BN/multibet/multibet_betarea.png": [
		75689,
		1,
		75689
	],
	"./assets/image/language/bn-BN/multibet/multibet_betarea.scss": [
		11138,
		9,
		11138
	],
	"./assets/image/language/bn-BN/pokdeng/pokdeng_betarea": [
		61088,
		3,
		61088
	],
	"./assets/image/language/bn-BN/pokdeng/pokdeng_betarea.json": [
		61088,
		3,
		61088
	],
	"./assets/image/language/bn-BN/pokdeng/pokdeng_betarea.png": [
		72755,
		1,
		72755
	],
	"./assets/image/language/bn-BN/pokdeng/pokdeng_betarea.scss": [
		68920,
		9,
		68920
	],
	"./assets/image/language/bn-BN/promotiontool/event_title": [
		45067,
		3,
		45067
	],
	"./assets/image/language/bn-BN/promotiontool/event_title.json": [
		45067,
		3,
		45067
	],
	"./assets/image/language/bn-BN/promotiontool/event_title.png": [
		6882,
		1,
		6882
	],
	"./assets/image/language/bn-BN/promotiontool/event_title.scss": [
		15467,
		9,
		15467
	],
	"./assets/image/language/bn-BN/roulette/roul_betarea": [
		28372,
		3,
		28372
	],
	"./assets/image/language/bn-BN/roulette/roul_betarea.json": [
		28372,
		3,
		28372
	],
	"./assets/image/language/bn-BN/roulette/roul_betarea.png": [
		14623,
		1,
		14623
	],
	"./assets/image/language/bn-BN/roulette/roul_betarea.scss": [
		73404,
		9,
		73404
	],
	"./assets/image/language/bn-BN/sedie/sedie_betarea": [
		3952,
		3,
		3952
	],
	"./assets/image/language/bn-BN/sedie/sedie_betarea.json": [
		3952,
		3,
		3952
	],
	"./assets/image/language/bn-BN/sedie/sedie_betarea.png": [
		12163,
		1,
		12163
	],
	"./assets/image/language/bn-BN/sedie/sedie_betarea.scss": [
		19800,
		9,
		19800
	],
	"./assets/image/language/bn-BN/sicbo/feature": [
		21317,
		3,
		21317
	],
	"./assets/image/language/bn-BN/sicbo/feature.json": [
		21317,
		3,
		21317
	],
	"./assets/image/language/bn-BN/sicbo/feature.png": [
		88960,
		1,
		88960
	],
	"./assets/image/language/bn-BN/sicbo/feature.scss": [
		52949,
		9,
		52949
	],
	"./assets/image/language/bn-BN/sicbo/popular": [
		8662,
		3,
		8662
	],
	"./assets/image/language/bn-BN/sicbo/popular.json": [
		8662,
		3,
		8662
	],
	"./assets/image/language/bn-BN/sicbo/popular.png": [
		26381,
		1,
		26381
	],
	"./assets/image/language/bn-BN/sicbo/popular.scss": [
		12386,
		9,
		12386
	],
	"./assets/image/language/bn-BN/teenpatti/teenPatti_betArea": [
		99452,
		3,
		99452
	],
	"./assets/image/language/bn-BN/teenpatti/teenPatti_betArea.json": [
		99452,
		3,
		99452
	],
	"./assets/image/language/bn-BN/teenpatti/teenPatti_betArea.png": [
		92535,
		1,
		92535
	],
	"./assets/image/language/bn-BN/teenpatti/teenPatti_betArea.scss": [
		45764,
		9,
		45764
	],
	"./assets/image/language/bn-BN/trial/trial_image": [
		23867,
		3,
		23867
	],
	"./assets/image/language/bn-BN/trial/trial_image.json": [
		23867,
		3,
		23867
	],
	"./assets/image/language/bn-BN/trial/trial_image.png": [
		61010,
		1,
		61010
	],
	"./assets/image/language/bn-BN/trial/trial_image.scss": [
		88987,
		9,
		88987
	],
	"./assets/image/language/en-US/andarbahar/andarbahar_text": [
		65180,
		3,
		65180
	],
	"./assets/image/language/en-US/andarbahar/andarbahar_text.json": [
		65180,
		3,
		65180
	],
	"./assets/image/language/en-US/andarbahar/andarbahar_text.png": [
		57703,
		1,
		57703
	],
	"./assets/image/language/en-US/andarbahar/andarbahar_text.scss": [
		6296,
		9,
		6296
	],
	"./assets/image/language/en-US/baccarat/bacc_betarea_label": [
		56302,
		3,
		56302
	],
	"./assets/image/language/en-US/baccarat/bacc_betarea_label.json": [
		56302,
		3,
		56302
	],
	"./assets/image/language/en-US/baccarat/bacc_betarea_label.png": [
		78277,
		1,
		78277
	],
	"./assets/image/language/en-US/baccarat/bacc_betarea_label.scss": [
		8642,
		9,
		8642
	],
	"./assets/image/language/en-US/dt/betAreaLabel_dt": [
		25187,
		3,
		25187
	],
	"./assets/image/language/en-US/dt/betAreaLabel_dt.json": [
		25187,
		3,
		25187
	],
	"./assets/image/language/en-US/dt/betAreaLabel_dt.png": [
		80394,
		1,
		80394
	],
	"./assets/image/language/en-US/dt/betAreaLabel_dt.scss": [
		20903,
		9,
		20903
	],
	"./assets/image/language/en-US/lobby/menu": [
		18911,
		3,
		18911
	],
	"./assets/image/language/en-US/lobby/menu.json": [
		18911,
		3,
		18911
	],
	"./assets/image/language/en-US/lobby/menu.png": [
		26686,
		1,
		26686
	],
	"./assets/image/language/en-US/lobby/menu.scss": [
		38651,
		9,
		38651
	],
	"./assets/image/language/en-US/multibet/multibet_betarea": [
		72503,
		3,
		72503
	],
	"./assets/image/language/en-US/multibet/multibet_betarea.json": [
		72503,
		3,
		72503
	],
	"./assets/image/language/en-US/multibet/multibet_betarea.png": [
		21014,
		1,
		21014
	],
	"./assets/image/language/en-US/multibet/multibet_betarea.scss": [
		48515,
		9,
		48515
	],
	"./assets/image/language/en-US/pokdeng/pokdeng_betarea": [
		3569,
		3,
		3569
	],
	"./assets/image/language/en-US/pokdeng/pokdeng_betarea.json": [
		3569,
		3,
		3569
	],
	"./assets/image/language/en-US/pokdeng/pokdeng_betarea.png": [
		15844,
		1,
		15844
	],
	"./assets/image/language/en-US/pokdeng/pokdeng_betarea.scss": [
		99101,
		9,
		99101
	],
	"./assets/image/language/en-US/promotiontool/event_title": [
		2434,
		3,
		2434
	],
	"./assets/image/language/en-US/promotiontool/event_title.json": [
		2434,
		3,
		2434
	],
	"./assets/image/language/en-US/promotiontool/event_title.png": [
		34913,
		1,
		34913
	],
	"./assets/image/language/en-US/promotiontool/event_title.scss": [
		72697,
		9,
		95078
	],
	"./assets/image/language/en-US/roulette/roul_betarea": [
		19865,
		3,
		19865
	],
	"./assets/image/language/en-US/roulette/roul_betarea.json": [
		19865,
		3,
		19865
	],
	"./assets/image/language/en-US/roulette/roul_betarea.png": [
		86575,
		1,
		8956
	],
	"./assets/image/language/en-US/roulette/roul_betarea.scss": [
		6285,
		9,
		6285
	],
	"./assets/image/language/en-US/sedie/sedie_betarea": [
		68289,
		3,
		68289
	],
	"./assets/image/language/en-US/sedie/sedie_betarea.json": [
		68289,
		3,
		68289
	],
	"./assets/image/language/en-US/sedie/sedie_betarea.png": [
		48628,
		1,
		48628
	],
	"./assets/image/language/en-US/sedie/sedie_betarea.scss": [
		35101,
		9,
		35101
	],
	"./assets/image/language/en-US/sicbo/feature": [
		96144,
		3,
		96144
	],
	"./assets/image/language/en-US/sicbo/feature.json": [
		96144,
		3,
		96144
	],
	"./assets/image/language/en-US/sicbo/feature.png": [
		45635,
		1,
		45635
	],
	"./assets/image/language/en-US/sicbo/feature.scss": [
		59380,
		9,
		59380
	],
	"./assets/image/language/en-US/sicbo/popular": [
		56087,
		3,
		56087
	],
	"./assets/image/language/en-US/sicbo/popular.json": [
		56087,
		3,
		56087
	],
	"./assets/image/language/en-US/sicbo/popular.png": [
		7910,
		1,
		7910
	],
	"./assets/image/language/en-US/sicbo/popular.scss": [
		93191,
		9,
		93191
	],
	"./assets/image/language/en-US/teenpatti/teenPatti_betArea": [
		50829,
		3,
		50829
	],
	"./assets/image/language/en-US/teenpatti/teenPatti_betArea.json": [
		50829,
		3,
		50829
	],
	"./assets/image/language/en-US/teenpatti/teenPatti_betArea.png": [
		78104,
		1,
		78104
	],
	"./assets/image/language/en-US/teenpatti/teenPatti_betArea.scss": [
		38489,
		9,
		38489
	],
	"./assets/image/language/en-US/trial/trial_image": [
		44386,
		3,
		44386
	],
	"./assets/image/language/en-US/trial/trial_image.json": [
		44386,
		3,
		44386
	],
	"./assets/image/language/en-US/trial/trial_image.png": [
		91169,
		1,
		91169
	],
	"./assets/image/language/en-US/trial/trial_image.scss": [
		57350,
		9,
		57350
	],
	"./assets/image/language/es-ES/andarbahar/andarbahar_text": [
		59487,
		3,
		59487
	],
	"./assets/image/language/es-ES/andarbahar/andarbahar_text.json": [
		59487,
		3,
		59487
	],
	"./assets/image/language/es-ES/andarbahar/andarbahar_text.png": [
		80062,
		1,
		80062
	],
	"./assets/image/language/es-ES/andarbahar/andarbahar_text.scss": [
		25679,
		9,
		25679
	],
	"./assets/image/language/es-ES/baccarat/bacc_betarea_label": [
		36483,
		3,
		36483
	],
	"./assets/image/language/es-ES/baccarat/bacc_betarea_label.json": [
		36483,
		3,
		36483
	],
	"./assets/image/language/es-ES/baccarat/bacc_betarea_label.png": [
		76922,
		1,
		76922
	],
	"./assets/image/language/es-ES/baccarat/bacc_betarea_label.scss": [
		15603,
		9,
		15603
	],
	"./assets/image/language/es-ES/dt/betAreaLabel_dt": [
		97480,
		3,
		97480
	],
	"./assets/image/language/es-ES/dt/betAreaLabel_dt.json": [
		97480,
		3,
		97480
	],
	"./assets/image/language/es-ES/dt/betAreaLabel_dt.png": [
		81883,
		1,
		81883
	],
	"./assets/image/language/es-ES/dt/betAreaLabel_dt.scss": [
		37720,
		9,
		37720
	],
	"./assets/image/language/es-ES/lobby/menu": [
		59836,
		3,
		59836
	],
	"./assets/image/language/es-ES/lobby/menu.json": [
		59836,
		3,
		59836
	],
	"./assets/image/language/es-ES/lobby/menu.png": [
		34669,
		1,
		79431
	],
	"./assets/image/language/es-ES/lobby/menu.scss": [
		69716,
		9,
		69716
	],
	"./assets/image/language/es-ES/multibet/multibet_betarea": [
		16250,
		3,
		16250
	],
	"./assets/image/language/es-ES/multibet/multibet_betarea.json": [
		16250,
		3,
		16250
	],
	"./assets/image/language/es-ES/multibet/multibet_betarea.png": [
		60217,
		1,
		60217
	],
	"./assets/image/language/es-ES/multibet/multibet_betarea.scss": [
		35330,
		9,
		35330
	],
	"./assets/image/language/es-ES/pokdeng/pokdeng_betarea": [
		66960,
		3,
		66960
	],
	"./assets/image/language/es-ES/pokdeng/pokdeng_betarea.json": [
		66960,
		3,
		66960
	],
	"./assets/image/language/es-ES/pokdeng/pokdeng_betarea.png": [
		53571,
		1,
		53571
	],
	"./assets/image/language/es-ES/pokdeng/pokdeng_betarea.scss": [
		36952,
		9,
		36952
	],
	"./assets/image/language/es-ES/promotiontool/event_title": [
		50779,
		3,
		50779
	],
	"./assets/image/language/es-ES/promotiontool/event_title.json": [
		50779,
		3,
		50779
	],
	"./assets/image/language/es-ES/promotiontool/event_title.png": [
		40626,
		1,
		40626
	],
	"./assets/image/language/es-ES/promotiontool/event_title.scss": [
		23307,
		9,
		23307
	],
	"./assets/image/language/es-ES/roulette/roul_betarea": [
		22276,
		3,
		22276
	],
	"./assets/image/language/es-ES/roulette/roul_betarea.json": [
		22276,
		3,
		22276
	],
	"./assets/image/language/es-ES/roulette/roul_betarea.png": [
		77775,
		1,
		77775
	],
	"./assets/image/language/es-ES/roulette/roul_betarea.scss": [
		91868,
		9,
		91868
	],
	"./assets/image/language/es-ES/sedie/sedie_betarea": [
		54560,
		3,
		54560
	],
	"./assets/image/language/es-ES/sedie/sedie_betarea.json": [
		54560,
		3,
		54560
	],
	"./assets/image/language/es-ES/sedie/sedie_betarea.png": [
		42515,
		1,
		42515
	],
	"./assets/image/language/es-ES/sedie/sedie_betarea.scss": [
		56952,
		9,
		56952
	],
	"./assets/image/language/es-ES/sicbo/feature": [
		34581,
		3,
		34581
	],
	"./assets/image/language/es-ES/sicbo/feature.json": [
		34581,
		3,
		34581
	],
	"./assets/image/language/es-ES/sicbo/feature.png": [
		25360,
		1,
		25360
	],
	"./assets/image/language/es-ES/sicbo/feature.scss": [
		73717,
		9,
		73717
	],
	"./assets/image/language/es-ES/sicbo/popular": [
		22918,
		3,
		22918
	],
	"./assets/image/language/es-ES/sicbo/popular.json": [
		22918,
		3,
		22918
	],
	"./assets/image/language/es-ES/sicbo/popular.png": [
		1853,
		1,
		1853
	],
	"./assets/image/language/es-ES/sicbo/popular.scss": [
		33154,
		9,
		33154
	],
	"./assets/image/language/es-ES/teenpatti/teenPatti_betArea": [
		22604,
		3,
		22604
	],
	"./assets/image/language/es-ES/teenpatti/teenPatti_betArea.json": [
		22604,
		3,
		22604
	],
	"./assets/image/language/es-ES/teenpatti/teenPatti_betArea.png": [
		263,
		1,
		263
	],
	"./assets/image/language/es-ES/teenpatti/teenPatti_betArea.scss": [
		11588,
		9,
		11588
	],
	"./assets/image/language/es-ES/trial/trial_image": [
		56427,
		3,
		56427
	],
	"./assets/image/language/es-ES/trial/trial_image.json": [
		56427,
		3,
		56427
	],
	"./assets/image/language/es-ES/trial/trial_image.png": [
		64578,
		1,
		64578
	],
	"./assets/image/language/es-ES/trial/trial_image.scss": [
		12571,
		9,
		12571
	],
	"./assets/image/language/fa-IR/andarbahar/andarbahar_text": [
		10931,
		3,
		10931
	],
	"./assets/image/language/fa-IR/andarbahar/andarbahar_text.json": [
		10931,
		3,
		10931
	],
	"./assets/image/language/fa-IR/andarbahar/andarbahar_text.png": [
		89482,
		1,
		89482
	],
	"./assets/image/language/fa-IR/andarbahar/andarbahar_text.scss": [
		91659,
		9,
		91659
	],
	"./assets/image/language/fa-IR/baccarat/bacc_betarea_label": [
		78679,
		3,
		78679
	],
	"./assets/image/language/fa-IR/baccarat/bacc_betarea_label.json": [
		78679,
		3,
		78679
	],
	"./assets/image/language/fa-IR/baccarat/bacc_betarea_label.png": [
		46950,
		1,
		46950
	],
	"./assets/image/language/fa-IR/baccarat/bacc_betarea_label.scss": [
		22767,
		9,
		22767
	],
	"./assets/image/language/fa-IR/dt/betAreaLabel_dt": [
		94404,
		3,
		94404
	],
	"./assets/image/language/fa-IR/dt/betAreaLabel_dt.json": [
		94404,
		3,
		94404
	],
	"./assets/image/language/fa-IR/dt/betAreaLabel_dt.png": [
		70735,
		1,
		70735
	],
	"./assets/image/language/fa-IR/dt/betAreaLabel_dt.scss": [
		29468,
		9,
		29468
	],
	"./assets/image/language/fa-IR/lobby/menu": [
		77024,
		3,
		77024
	],
	"./assets/image/language/fa-IR/lobby/menu.json": [
		77024,
		3,
		77024
	],
	"./assets/image/language/fa-IR/lobby/menu.png": [
		44563,
		1,
		44563
	],
	"./assets/image/language/fa-IR/lobby/menu.scss": [
		65632,
		9,
		65632
	],
	"./assets/image/language/fa-IR/multibet/multibet_betarea": [
		99494,
		3,
		99494
	],
	"./assets/image/language/fa-IR/multibet/multibet_betarea.json": [
		99494,
		3,
		99494
	],
	"./assets/image/language/fa-IR/multibet/multibet_betarea.png": [
		93085,
		1,
		93085
	],
	"./assets/image/language/fa-IR/multibet/multibet_betarea.scss": [
		96022,
		9,
		96022
	],
	"./assets/image/language/fa-IR/pokdeng/pokdeng_betarea": [
		68348,
		3,
		68348
	],
	"./assets/image/language/fa-IR/pokdeng/pokdeng_betarea.json": [
		68348,
		3,
		68348
	],
	"./assets/image/language/fa-IR/pokdeng/pokdeng_betarea.png": [
		55348,
		1,
		32967
	],
	"./assets/image/language/fa-IR/pokdeng/pokdeng_betarea.scss": [
		21228,
		9,
		21228
	],
	"./assets/image/language/fa-IR/promotiontool/event_title": [
		13559,
		3,
		13559
	],
	"./assets/image/language/fa-IR/promotiontool/event_title.json": [
		13559,
		3,
		13559
	],
	"./assets/image/language/fa-IR/promotiontool/event_title.png": [
		33654,
		1,
		33654
	],
	"./assets/image/language/fa-IR/promotiontool/event_title.scss": [
		50431,
		9,
		50431
	],
	"./assets/image/language/fa-IR/roulette/roul_betarea": [
		34624,
		3,
		34624
	],
	"./assets/image/language/fa-IR/roulette/roul_betarea.json": [
		34624,
		3,
		34624
	],
	"./assets/image/language/fa-IR/roulette/roul_betarea.png": [
		38723,
		1,
		38723
	],
	"./assets/image/language/fa-IR/roulette/roul_betarea.scss": [
		26112,
		9,
		26112
	],
	"./assets/image/language/fa-IR/sedie/sedie_betarea": [
		52284,
		3,
		52284
	],
	"./assets/image/language/fa-IR/sedie/sedie_betarea.json": [
		52284,
		3,
		52284
	],
	"./assets/image/language/fa-IR/sedie/sedie_betarea.png": [
		46631,
		1,
		46631
	],
	"./assets/image/language/fa-IR/sedie/sedie_betarea.scss": [
		4588,
		9,
		4588
	],
	"./assets/image/language/fa-IR/sicbo/feature": [
		96881,
		3,
		96881
	],
	"./assets/image/language/fa-IR/sicbo/feature.json": [
		96881,
		3,
		96881
	],
	"./assets/image/language/fa-IR/sicbo/feature.png": [
		56724,
		1,
		56724
	],
	"./assets/image/language/fa-IR/sicbo/feature.scss": [
		62649,
		9,
		62649
	],
	"./assets/image/language/fa-IR/sicbo/popular": [
		93730,
		3,
		93730
	],
	"./assets/image/language/fa-IR/sicbo/popular.json": [
		93730,
		3,
		93730
	],
	"./assets/image/language/fa-IR/sicbo/popular.png": [
		11281,
		1,
		11281
	],
	"./assets/image/language/fa-IR/sicbo/popular.scss": [
		40950,
		9,
		40950
	],
	"./assets/image/language/fa-IR/teenpatti/teenPatti_betArea": [
		7224,
		3,
		7224
	],
	"./assets/image/language/fa-IR/teenpatti/teenPatti_betArea.json": [
		7224,
		3,
		7224
	],
	"./assets/image/language/fa-IR/teenpatti/teenPatti_betArea.png": [
		94571,
		1,
		94571
	],
	"./assets/image/language/fa-IR/teenpatti/teenPatti_betArea.scss": [
		43416,
		9,
		43416
	],
	"./assets/image/language/fa-IR/trial/trial_image": [
		85559,
		3,
		85559
	],
	"./assets/image/language/fa-IR/trial/trial_image.json": [
		85559,
		3,
		85559
	],
	"./assets/image/language/fa-IR/trial/trial_image.png": [
		50294,
		1,
		50294
	],
	"./assets/image/language/fa-IR/trial/trial_image.scss": [
		37007,
		9,
		37007
	],
	"./assets/image/language/hi-IN/andarbahar/andarbahar_text": [
		17897,
		3,
		17897
	],
	"./assets/image/language/hi-IN/andarbahar/andarbahar_text.json": [
		17897,
		3,
		17897
	],
	"./assets/image/language/hi-IN/andarbahar/andarbahar_text.png": [
		57052,
		1,
		57052
	],
	"./assets/image/language/hi-IN/andarbahar/andarbahar_text.scss": [
		73333,
		9,
		73333
	],
	"./assets/image/language/hi-IN/baccarat/bacc_betarea_label": [
		40570,
		3,
		18189
	],
	"./assets/image/language/hi-IN/baccarat/bacc_betarea_label.json": [
		40570,
		3,
		18189
	],
	"./assets/image/language/hi-IN/baccarat/bacc_betarea_label.png": [
		88843,
		1,
		11224
	],
	"./assets/image/language/hi-IN/baccarat/bacc_betarea_label.scss": [
		70057,
		9,
		70057
	],
	"./assets/image/language/hi-IN/dt/betAreaLabel_dt": [
		27022,
		3,
		27022
	],
	"./assets/image/language/hi-IN/dt/betAreaLabel_dt.json": [
		27022,
		3,
		27022
	],
	"./assets/image/language/hi-IN/dt/betAreaLabel_dt.png": [
		94133,
		1,
		94133
	],
	"./assets/image/language/hi-IN/dt/betAreaLabel_dt.scss": [
		42490,
		9,
		42490
	],
	"./assets/image/language/hi-IN/lobby/menu": [
		8546,
		3,
		8546
	],
	"./assets/image/language/hi-IN/lobby/menu.json": [
		8546,
		3,
		8546
	],
	"./assets/image/language/hi-IN/lobby/menu.png": [
		17825,
		1,
		17825
	],
	"./assets/image/language/hi-IN/lobby/menu.scss": [
		73174,
		9,
		73174
	],
	"./assets/image/language/hi-IN/multibet/multibet_betarea": [
		30960,
		3,
		30960
	],
	"./assets/image/language/hi-IN/multibet/multibet_betarea.json": [
		30960,
		3,
		30960
	],
	"./assets/image/language/hi-IN/multibet/multibet_betarea.png": [
		63395,
		1,
		63395
	],
	"./assets/image/language/hi-IN/multibet/multibet_betarea.scss": [
		78772,
		9,
		78772
	],
	"./assets/image/language/hi-IN/pokdeng/pokdeng_betarea": [
		84702,
		3,
		84702
	],
	"./assets/image/language/hi-IN/pokdeng/pokdeng_betarea.json": [
		84702,
		3,
		84702
	],
	"./assets/image/language/hi-IN/pokdeng/pokdeng_betarea.png": [
		11349,
		1,
		11349
	],
	"./assets/image/language/hi-IN/pokdeng/pokdeng_betarea.scss": [
		26178,
		9,
		26178
	],
	"./assets/image/language/hi-IN/promotiontool/event_title": [
		46813,
		3,
		46813
	],
	"./assets/image/language/hi-IN/promotiontool/event_title.json": [
		46813,
		3,
		46813
	],
	"./assets/image/language/hi-IN/promotiontool/event_title.png": [
		95928,
		1,
		95928
	],
	"./assets/image/language/hi-IN/promotiontool/event_title.scss": [
		42710,
		9,
		20329
	],
	"./assets/image/language/hi-IN/roulette/roul_betarea": [
		10594,
		3,
		10594
	],
	"./assets/image/language/hi-IN/roulette/roul_betarea.json": [
		10594,
		3,
		10594
	],
	"./assets/image/language/hi-IN/roulette/roul_betarea.png": [
		89297,
		1,
		89297
	],
	"./assets/image/language/hi-IN/roulette/roul_betarea.scss": [
		50806,
		9,
		50806
	],
	"./assets/image/language/hi-IN/sedie/sedie_betarea": [
		55006,
		3,
		55006
	],
	"./assets/image/language/hi-IN/sedie/sedie_betarea.json": [
		55006,
		3,
		55006
	],
	"./assets/image/language/hi-IN/sedie/sedie_betarea.png": [
		77077,
		1,
		77077
	],
	"./assets/image/language/hi-IN/sedie/sedie_betarea.scss": [
		20290,
		9,
		20290
	],
	"./assets/image/language/hi-IN/sicbo/feature": [
		471,
		3,
		471
	],
	"./assets/image/language/hi-IN/sicbo/feature.json": [
		471,
		3,
		471
	],
	"./assets/image/language/hi-IN/sicbo/feature.png": [
		46038,
		1,
		46038
	],
	"./assets/image/language/hi-IN/sicbo/feature.scss": [
		1216,
		9,
		78835
	],
	"./assets/image/language/hi-IN/sicbo/popular": [
		15728,
		3,
		15728
	],
	"./assets/image/language/hi-IN/sicbo/popular.json": [
		15728,
		3,
		15728
	],
	"./assets/image/language/hi-IN/sicbo/popular.png": [
		71187,
		1,
		71187
	],
	"./assets/image/language/hi-IN/sicbo/popular.scss": [
		55312,
		9,
		55312
	],
	"./assets/image/language/hi-IN/teenpatti/teenPatti_betArea": [
		32746,
		3,
		32746
	],
	"./assets/image/language/hi-IN/teenpatti/teenPatti_betArea.json": [
		32746,
		3,
		32746
	],
	"./assets/image/language/hi-IN/teenpatti/teenPatti_betArea.png": [
		10697,
		1,
		10697
	],
	"./assets/image/language/hi-IN/teenpatti/teenPatti_betArea.scss": [
		52350,
		9,
		52350
	],
	"./assets/image/language/hi-IN/trial/trial_image": [
		99629,
		3,
		99629
	],
	"./assets/image/language/hi-IN/trial/trial_image.json": [
		99629,
		3,
		99629
	],
	"./assets/image/language/hi-IN/trial/trial_image.png": [
		14856,
		1,
		14856
	],
	"./assets/image/language/hi-IN/trial/trial_image.scss": [
		33225,
		9,
		33225
	],
	"./assets/image/language/id-ID/andarbahar/andarbahar_text": [
		20701,
		3,
		20701
	],
	"./assets/image/language/id-ID/andarbahar/andarbahar_text.json": [
		20701,
		3,
		20701
	],
	"./assets/image/language/id-ID/andarbahar/andarbahar_text.png": [
		90520,
		1,
		90520
	],
	"./assets/image/language/id-ID/andarbahar/andarbahar_text.scss": [
		81709,
		9,
		81709
	],
	"./assets/image/language/id-ID/baccarat/bacc_betarea_label": [
		84529,
		3,
		84529
	],
	"./assets/image/language/id-ID/baccarat/bacc_betarea_label.json": [
		84529,
		3,
		84529
	],
	"./assets/image/language/id-ID/baccarat/bacc_betarea_label.png": [
		29796,
		1,
		29796
	],
	"./assets/image/language/id-ID/baccarat/bacc_betarea_label.scss": [
		18065,
		9,
		18065
	],
	"./assets/image/language/id-ID/dt/betAreaLabel_dt": [
		71642,
		3,
		71642
	],
	"./assets/image/language/id-ID/dt/betAreaLabel_dt.json": [
		71642,
		3,
		71642
	],
	"./assets/image/language/id-ID/dt/betAreaLabel_dt.png": [
		64297,
		1,
		64297
	],
	"./assets/image/language/id-ID/dt/betAreaLabel_dt.scss": [
		43234,
		9,
		43234
	],
	"./assets/image/language/id-ID/lobby/menu": [
		99686,
		3,
		99686
	],
	"./assets/image/language/id-ID/lobby/menu.json": [
		99686,
		3,
		99686
	],
	"./assets/image/language/id-ID/lobby/menu.png": [
		82781,
		1,
		82781
	],
	"./assets/image/language/id-ID/lobby/menu.scss": [
		33886,
		9,
		33886
	],
	"./assets/image/language/id-ID/multibet/multibet_betarea": [
		19772,
		3,
		19772
	],
	"./assets/image/language/id-ID/multibet/multibet_betarea.json": [
		19772,
		3,
		19772
	],
	"./assets/image/language/id-ID/multibet/multibet_betarea.png": [
		94935,
		1,
		94935
	],
	"./assets/image/language/id-ID/multibet/multibet_betarea.scss": [
		11596,
		9,
		11596
	],
	"./assets/image/language/id-ID/pokdeng/pokdeng_betarea": [
		84474,
		3,
		84474
	],
	"./assets/image/language/id-ID/pokdeng/pokdeng_betarea.json": [
		84474,
		3,
		84474
	],
	"./assets/image/language/id-ID/pokdeng/pokdeng_betarea.png": [
		28313,
		1,
		28313
	],
	"./assets/image/language/id-ID/pokdeng/pokdeng_betarea.scss": [
		39930,
		9,
		39930
	],
	"./assets/image/language/id-ID/promotiontool/event_title": [
		51577,
		3,
		51577
	],
	"./assets/image/language/id-ID/promotiontool/event_title.json": [
		51577,
		3,
		51577
	],
	"./assets/image/language/id-ID/promotiontool/event_title.png": [
		89932,
		1,
		89932
	],
	"./assets/image/language/id-ID/promotiontool/event_title.scss": [
		57249,
		9,
		57249
	],
	"./assets/image/language/id-ID/roulette/roul_betarea": [
		8958,
		3,
		8958
	],
	"./assets/image/language/id-ID/roulette/roul_betarea.json": [
		8958,
		3,
		8958
	],
	"./assets/image/language/id-ID/roulette/roul_betarea.png": [
		58549,
		1,
		58549
	],
	"./assets/image/language/id-ID/roulette/roul_betarea.scss": [
		50222,
		9,
		50222
	],
	"./assets/image/language/id-ID/sedie/sedie_betarea": [
		34586,
		3,
		34586
	],
	"./assets/image/language/id-ID/sedie/sedie_betarea.json": [
		34586,
		3,
		34586
	],
	"./assets/image/language/id-ID/sedie/sedie_betarea.png": [
		62489,
		1,
		62489
	],
	"./assets/image/language/id-ID/sedie/sedie_betarea.scss": [
		98394,
		9,
		98394
	],
	"./assets/image/language/id-ID/sicbo/feature": [
		71987,
		3,
		71987
	],
	"./assets/image/language/id-ID/sicbo/feature.json": [
		71987,
		3,
		71987
	],
	"./assets/image/language/id-ID/sicbo/feature.png": [
		97194,
		1,
		97194
	],
	"./assets/image/language/id-ID/sicbo/feature.scss": [
		80507,
		9,
		80507
	],
	"./assets/image/language/id-ID/sicbo/popular": [
		66524,
		3,
		66524
	],
	"./assets/image/language/id-ID/sicbo/popular.json": [
		66524,
		3,
		66524
	],
	"./assets/image/language/id-ID/sicbo/popular.png": [
		79239,
		1,
		79239
	],
	"./assets/image/language/id-ID/sicbo/popular.scss": [
		48536,
		9,
		48536
	],
	"./assets/image/language/id-ID/teenpatti/teenPatti_betArea": [
		91830,
		3,
		91830
	],
	"./assets/image/language/id-ID/teenpatti/teenPatti_betArea.json": [
		91830,
		3,
		91830
	],
	"./assets/image/language/id-ID/teenpatti/teenPatti_betArea.png": [
		51261,
		1,
		51261
	],
	"./assets/image/language/id-ID/teenpatti/teenPatti_betArea.scss": [
		54262,
		9,
		54262
	],
	"./assets/image/language/id-ID/trial/trial_image": [
		21993,
		3,
		21993
	],
	"./assets/image/language/id-ID/trial/trial_image.json": [
		21993,
		3,
		21993
	],
	"./assets/image/language/id-ID/trial/trial_image.png": [
		84572,
		1,
		84572
	],
	"./assets/image/language/id-ID/trial/trial_image.scss": [
		17409,
		9,
		17409
	],
	"./assets/image/language/ja-JP/andarbahar/andarbahar_text": [
		87620,
		3,
		87620
	],
	"./assets/image/language/ja-JP/andarbahar/andarbahar_text.json": [
		87620,
		3,
		87620
	],
	"./assets/image/language/ja-JP/andarbahar/andarbahar_text.png": [
		52111,
		1,
		52111
	],
	"./assets/image/language/ja-JP/andarbahar/andarbahar_text.scss": [
		33640,
		9,
		33640
	],
	"./assets/image/language/ja-JP/baccarat/bacc_betarea_label": [
		35654,
		3,
		35654
	],
	"./assets/image/language/ja-JP/baccarat/bacc_betarea_label.json": [
		35654,
		3,
		35654
	],
	"./assets/image/language/ja-JP/baccarat/bacc_betarea_label.png": [
		57373,
		1,
		57373
	],
	"./assets/image/language/ja-JP/baccarat/bacc_betarea_label.scss": [
		53266,
		9,
		53266
	],
	"./assets/image/language/ja-JP/dt/betAreaLabel_dt": [
		22267,
		3,
		22267
	],
	"./assets/image/language/ja-JP/dt/betAreaLabel_dt.json": [
		22267,
		3,
		22267
	],
	"./assets/image/language/ja-JP/dt/betAreaLabel_dt.png": [
		28226,
		1,
		28226
	],
	"./assets/image/language/ja-JP/dt/betAreaLabel_dt.scss": [
		84759,
		9,
		84759
	],
	"./assets/image/language/ja-JP/lobby/menu": [
		5431,
		3,
		5431
	],
	"./assets/image/language/ja-JP/lobby/menu.json": [
		5431,
		3,
		5431
	],
	"./assets/image/language/ja-JP/lobby/menu.png": [
		75222,
		1,
		75222
	],
	"./assets/image/language/ja-JP/lobby/menu.scss": [
		70123,
		9,
		70123
	],
	"./assets/image/language/ja-JP/multibet/multibet_betarea": [
		17663,
		3,
		17663
	],
	"./assets/image/language/ja-JP/multibet/multibet_betarea.json": [
		17663,
		3,
		17663
	],
	"./assets/image/language/ja-JP/multibet/multibet_betarea.png": [
		25630,
		1,
		25630
	],
	"./assets/image/language/ja-JP/multibet/multibet_betarea.scss": [
		48947,
		9,
		48947
	],
	"./assets/image/language/ja-JP/pokdeng/pokdeng_betarea": [
		40665,
		3,
		40665
	],
	"./assets/image/language/ja-JP/pokdeng/pokdeng_betarea.json": [
		40665,
		3,
		40665
	],
	"./assets/image/language/ja-JP/pokdeng/pokdeng_betarea.png": [
		76748,
		1,
		76748
	],
	"./assets/image/language/ja-JP/pokdeng/pokdeng_betarea.scss": [
		6573,
		9,
		6573
	],
	"./assets/image/language/ja-JP/promotiontool/event_title": [
		14666,
		3,
		14666
	],
	"./assets/image/language/ja-JP/promotiontool/event_title.json": [
		14666,
		3,
		14666
	],
	"./assets/image/language/ja-JP/promotiontool/event_title.png": [
		7753,
		1,
		7753
	],
	"./assets/image/language/ja-JP/promotiontool/event_title.scss": [
		17366,
		9,
		17366
	],
	"./assets/image/language/ja-JP/roulette/roul_betarea": [
		18369,
		3,
		18369
	],
	"./assets/image/language/ja-JP/roulette/roul_betarea.json": [
		18369,
		3,
		18369
	],
	"./assets/image/language/ja-JP/roulette/roul_betarea.png": [
		67748,
		1,
		67748
	],
	"./assets/image/language/ja-JP/roulette/roul_betarea.scss": [
		41245,
		9,
		41245
	],
	"./assets/image/language/ja-JP/sedie/sedie_betarea": [
		94121,
		3,
		94121
	],
	"./assets/image/language/ja-JP/sedie/sedie_betarea.json": [
		94121,
		3,
		94121
	],
	"./assets/image/language/ja-JP/sedie/sedie_betarea.png": [
		35132,
		1,
		35132
	],
	"./assets/image/language/ja-JP/sedie/sedie_betarea.scss": [
		17293,
		9,
		17293
	],
	"./assets/image/language/ja-JP/sicbo/feature": [
		49256,
		3,
		49256
	],
	"./assets/image/language/ja-JP/sicbo/feature.json": [
		49256,
		3,
		49256
	],
	"./assets/image/language/ja-JP/sicbo/feature.png": [
		22203,
		1,
		22203
	],
	"./assets/image/language/ja-JP/sicbo/feature.scss": [
		26372,
		9,
		26372
	],
	"./assets/image/language/ja-JP/sicbo/popular": [
		55663,
		3,
		55663
	],
	"./assets/image/language/ja-JP/sicbo/popular.json": [
		55663,
		3,
		55663
	],
	"./assets/image/language/ja-JP/sicbo/popular.png": [
		70686,
		1,
		70686
	],
	"./assets/image/language/ja-JP/sicbo/popular.scss": [
		92279,
		9,
		92279
	],
	"./assets/image/language/ja-JP/teenpatti/teenPatti_betArea": [
		2197,
		3,
		2197
	],
	"./assets/image/language/ja-JP/teenpatti/teenPatti_betArea.json": [
		2197,
		3,
		2197
	],
	"./assets/image/language/ja-JP/teenpatti/teenPatti_betArea.png": [
		92512,
		1,
		92512
	],
	"./assets/image/language/ja-JP/teenpatti/teenPatti_betArea.scss": [
		73065,
		9,
		73065
	],
	"./assets/image/language/ja-JP/trial/trial_image": [
		30314,
		3,
		30314
	],
	"./assets/image/language/ja-JP/trial/trial_image.json": [
		30314,
		3,
		30314
	],
	"./assets/image/language/ja-JP/trial/trial_image.png": [
		12137,
		1,
		12137
	],
	"./assets/image/language/ja-JP/trial/trial_image.scss": [
		15286,
		9,
		15286
	],
	"./assets/image/language/ko-KR/andarbahar/andarbahar_text": [
		75870,
		3,
		75870
	],
	"./assets/image/language/ko-KR/andarbahar/andarbahar_text.json": [
		75870,
		3,
		75870
	],
	"./assets/image/language/ko-KR/andarbahar/andarbahar_text.png": [
		36325,
		1,
		36325
	],
	"./assets/image/language/ko-KR/andarbahar/andarbahar_text.scss": [
		22106,
		9,
		22106
	],
	"./assets/image/language/ko-KR/baccarat/bacc_betarea_label": [
		39136,
		3,
		39136
	],
	"./assets/image/language/ko-KR/baccarat/bacc_betarea_label.json": [
		39136,
		3,
		39136
	],
	"./assets/image/language/ko-KR/baccarat/bacc_betarea_label.png": [
		53683,
		1,
		53683
	],
	"./assets/image/language/ko-KR/baccarat/bacc_betarea_label.scss": [
		4916,
		9,
		4916
	],
	"./assets/image/language/ko-KR/dt/betAreaLabel_dt": [
		90913,
		3,
		90913
	],
	"./assets/image/language/ko-KR/dt/betAreaLabel_dt.json": [
		90913,
		3,
		90913
	],
	"./assets/image/language/ko-KR/dt/betAreaLabel_dt.png": [
		60644,
		1,
		60644
	],
	"./assets/image/language/ko-KR/dt/betAreaLabel_dt.scss": [
		30381,
		9,
		30381
	],
	"./assets/image/language/ko-KR/lobby/menu": [
		87565,
		3,
		87565
	],
	"./assets/image/language/ko-KR/lobby/menu.json": [
		87565,
		3,
		87565
	],
	"./assets/image/language/ko-KR/lobby/menu.png": [
		40328,
		1,
		40328
	],
	"./assets/image/language/ko-KR/lobby/menu.scss": [
		57033,
		9,
		57033
	],
	"./assets/image/language/ko-KR/multibet/multibet_betarea": [
		98317,
		3,
		98317
	],
	"./assets/image/language/ko-KR/multibet/multibet_betarea.json": [
		98317,
		3,
		98317
	],
	"./assets/image/language/ko-KR/multibet/multibet_betarea.png": [
		49912,
		1,
		49912
	],
	"./assets/image/language/ko-KR/multibet/multibet_betarea.scss": [
		55105,
		9,
		55105
	],
	"./assets/image/language/ko-KR/pokdeng/pokdeng_betarea": [
		58247,
		3,
		58247
	],
	"./assets/image/language/ko-KR/pokdeng/pokdeng_betarea.json": [
		58247,
		3,
		58247
	],
	"./assets/image/language/ko-KR/pokdeng/pokdeng_betarea.png": [
		67078,
		1,
		67078
	],
	"./assets/image/language/ko-KR/pokdeng/pokdeng_betarea.scss": [
		21323,
		9,
		21323
	],
	"./assets/image/language/ko-KR/promotiontool/event_title": [
		87052,
		3,
		87052
	],
	"./assets/image/language/ko-KR/promotiontool/event_title.json": [
		87052,
		3,
		87052
	],
	"./assets/image/language/ko-KR/promotiontool/event_title.png": [
		28599,
		1,
		28599
	],
	"./assets/image/language/ko-KR/promotiontool/event_title.scss": [
		62920,
		9,
		62920
	],
	"./assets/image/language/ko-KR/roulette/roul_betarea": [
		84343,
		3,
		84343
	],
	"./assets/image/language/ko-KR/roulette/roul_betarea.json": [
		84343,
		3,
		84343
	],
	"./assets/image/language/ko-KR/roulette/roul_betarea.png": [
		80310,
		1,
		80310
	],
	"./assets/image/language/ko-KR/roulette/roul_betarea.scss": [
		12547,
		9,
		12547
	],
	"./assets/image/language/ko-KR/sedie/sedie_betarea": [
		50055,
		3,
		50055
	],
	"./assets/image/language/ko-KR/sedie/sedie_betarea.json": [
		50055,
		3,
		50055
	],
	"./assets/image/language/ko-KR/sedie/sedie_betarea.png": [
		90310,
		1,
		90310
	],
	"./assets/image/language/ko-KR/sedie/sedie_betarea.scss": [
		60411,
		9,
		60411
	],
	"./assets/image/language/ko-KR/sicbo/feature": [
		48530,
		3,
		48530
	],
	"./assets/image/language/ko-KR/sicbo/feature.json": [
		48530,
		3,
		48530
	],
	"./assets/image/language/ko-KR/sicbo/feature.png": [
		80513,
		1,
		80513
	],
	"./assets/image/language/ko-KR/sicbo/feature.scss": [
		83214,
		9,
		83214
	],
	"./assets/image/language/ko-KR/sicbo/popular": [
		4161,
		3,
		4161
	],
	"./assets/image/language/ko-KR/sicbo/popular.json": [
		4161,
		3,
		4161
	],
	"./assets/image/language/ko-KR/sicbo/popular.png": [
		87492,
		1,
		87492
	],
	"./assets/image/language/ko-KR/sicbo/popular.scss": [
		47857,
		9,
		47857
	],
	"./assets/image/language/ko-KR/teenpatti/teenPatti_betArea": [
		44115,
		3,
		44115
	],
	"./assets/image/language/ko-KR/teenpatti/teenPatti_betArea.json": [
		44115,
		3,
		44115
	],
	"./assets/image/language/ko-KR/teenpatti/teenPatti_betArea.png": [
		33674,
		1,
		33674
	],
	"./assets/image/language/ko-KR/teenpatti/teenPatti_betArea.scss": [
		88439,
		9,
		88439
	],
	"./assets/image/language/ko-KR/trial/trial_image": [
		73692,
		3,
		73692
	],
	"./assets/image/language/ko-KR/trial/trial_image.json": [
		73692,
		3,
		73692
	],
	"./assets/image/language/ko-KR/trial/trial_image.png": [
		49671,
		1,
		49671
	],
	"./assets/image/language/ko-KR/trial/trial_image.scss": [
		86920,
		9,
		86920
	],
	"./assets/image/language/ms-MY/andarbahar/andarbahar_text": [
		58373,
		3,
		58373
	],
	"./assets/image/language/ms-MY/andarbahar/andarbahar_text.json": [
		58373,
		3,
		58373
	],
	"./assets/image/language/ms-MY/andarbahar/andarbahar_text.png": [
		32544,
		1,
		32544
	],
	"./assets/image/language/ms-MY/andarbahar/andarbahar_text.scss": [
		2041,
		9,
		2041
	],
	"./assets/image/language/ms-MY/baccarat/bacc_betarea_label": [
		37001,
		3,
		37001
	],
	"./assets/image/language/ms-MY/baccarat/bacc_betarea_label.json": [
		37001,
		3,
		37001
	],
	"./assets/image/language/ms-MY/baccarat/bacc_betarea_label.png": [
		74428,
		1,
		74428
	],
	"./assets/image/language/ms-MY/baccarat/bacc_betarea_label.scss": [
		68397,
		9,
		68397
	],
	"./assets/image/language/ms-MY/dt/betAreaLabel_dt": [
		16562,
		3,
		16562
	],
	"./assets/image/language/ms-MY/dt/betAreaLabel_dt.json": [
		16562,
		3,
		16562
	],
	"./assets/image/language/ms-MY/dt/betAreaLabel_dt.png": [
		34337,
		1,
		34337
	],
	"./assets/image/language/ms-MY/dt/betAreaLabel_dt.scss": [
		32150,
		9,
		32150
	],
	"./assets/image/language/ms-MY/lobby/menu": [
		86046,
		3,
		86046
	],
	"./assets/image/language/ms-MY/lobby/menu.json": [
		86046,
		3,
		86046
	],
	"./assets/image/language/ms-MY/lobby/menu.png": [
		94741,
		1,
		94741
	],
	"./assets/image/language/ms-MY/lobby/menu.scss": [
		49354,
		9,
		49354
	],
	"./assets/image/language/ms-MY/multibet/multibet_betarea": [
		21668,
		3,
		21668
	],
	"./assets/image/language/ms-MY/multibet/multibet_betarea.json": [
		21668,
		3,
		21668
	],
	"./assets/image/language/ms-MY/multibet/multibet_betarea.png": [
		23231,
		1,
		23231
	],
	"./assets/image/language/ms-MY/multibet/multibet_betarea.scss": [
		3440,
		9,
		3440
	],
	"./assets/image/language/ms-MY/pokdeng/pokdeng_betarea": [
		8002,
		3,
		8002
	],
	"./assets/image/language/ms-MY/pokdeng/pokdeng_betarea.json": [
		8002,
		3,
		8002
	],
	"./assets/image/language/ms-MY/pokdeng/pokdeng_betarea.png": [
		13121,
		1,
		13121
	],
	"./assets/image/language/ms-MY/pokdeng/pokdeng_betarea.scss": [
		48318,
		9,
		48318
	],
	"./assets/image/language/ms-MY/promotiontool/event_title": [
		85217,
		3,
		85217
	],
	"./assets/image/language/ms-MY/promotiontool/event_title.json": [
		85217,
		3,
		85217
	],
	"./assets/image/language/ms-MY/promotiontool/event_title.png": [
		59188,
		1,
		59188
	],
	"./assets/image/language/ms-MY/promotiontool/event_title.scss": [
		35813,
		9,
		35813
	],
	"./assets/image/language/ms-MY/roulette/roul_betarea": [
		5830,
		3,
		5830
	],
	"./assets/image/language/ms-MY/roulette/roul_betarea.json": [
		5830,
		3,
		5830
	],
	"./assets/image/language/ms-MY/roulette/roul_betarea.png": [
		39837,
		1,
		39837
	],
	"./assets/image/language/ms-MY/roulette/roul_betarea.scss": [
		14002,
		9,
		14002
	],
	"./assets/image/language/ms-MY/sedie/sedie_betarea": [
		87938,
		3,
		87938
	],
	"./assets/image/language/ms-MY/sedie/sedie_betarea.json": [
		87938,
		3,
		87938
	],
	"./assets/image/language/ms-MY/sedie/sedie_betarea.png": [
		69377,
		1,
		69377
	],
	"./assets/image/language/ms-MY/sedie/sedie_betarea.scss": [
		98830,
		9,
		98830
	],
	"./assets/image/language/ms-MY/sicbo/feature": [
		7371,
		3,
		7371
	],
	"./assets/image/language/ms-MY/sicbo/feature.json": [
		7371,
		3,
		7371
	],
	"./assets/image/language/ms-MY/sicbo/feature.png": [
		41666,
		1,
		41666
	],
	"./assets/image/language/ms-MY/sicbo/feature.scss": [
		58687,
		9,
		58687
	],
	"./assets/image/language/ms-MY/sicbo/popular": [
		29300,
		3,
		29300
	],
	"./assets/image/language/ms-MY/sicbo/popular.json": [
		29300,
		3,
		29300
	],
	"./assets/image/language/ms-MY/sicbo/popular.png": [
		30271,
		1,
		30271
	],
	"./assets/image/language/ms-MY/sicbo/popular.scss": [
		5468,
		9,
		5468
	],
	"./assets/image/language/ms-MY/teenpatti/teenPatti_betArea": [
		79134,
		3,
		79134
	],
	"./assets/image/language/ms-MY/teenpatti/teenPatti_betArea.json": [
		79134,
		3,
		79134
	],
	"./assets/image/language/ms-MY/teenpatti/teenPatti_betArea.png": [
		82597,
		1,
		82597
	],
	"./assets/image/language/ms-MY/teenpatti/teenPatti_betArea.scss": [
		60650,
		9,
		60650
	],
	"./assets/image/language/ms-MY/trial/trial_image": [
		48657,
		3,
		48657
	],
	"./assets/image/language/ms-MY/trial/trial_image.json": [
		48657,
		3,
		48657
	],
	"./assets/image/language/ms-MY/trial/trial_image.png": [
		53956,
		1,
		53956
	],
	"./assets/image/language/ms-MY/trial/trial_image.scss": [
		73493,
		9,
		73493
	],
	"./assets/image/language/pt-BR/andarbahar/andarbahar_text": [
		19615,
		3,
		19615
	],
	"./assets/image/language/pt-BR/andarbahar/andarbahar_text.json": [
		19615,
		3,
		19615
	],
	"./assets/image/language/pt-BR/andarbahar/andarbahar_text.png": [
		72766,
		1,
		72766
	],
	"./assets/image/language/pt-BR/andarbahar/andarbahar_text.scss": [
		66039,
		9,
		66039
	],
	"./assets/image/language/pt-BR/baccarat/bacc_betarea_label": [
		59267,
		3,
		59267
	],
	"./assets/image/language/pt-BR/baccarat/bacc_betarea_label.json": [
		59267,
		3,
		59267
	],
	"./assets/image/language/pt-BR/baccarat/bacc_betarea_label.png": [
		55098,
		1,
		55098
	],
	"./assets/image/language/pt-BR/baccarat/bacc_betarea_label.scss": [
		74411,
		9,
		74411
	],
	"./assets/image/language/pt-BR/dt/betAreaLabel_dt": [
		30728,
		3,
		30728
	],
	"./assets/image/language/pt-BR/dt/betAreaLabel_dt.json": [
		30728,
		3,
		30728
	],
	"./assets/image/language/pt-BR/dt/betAreaLabel_dt.png": [
		41448,
		1,
		19067
	],
	"./assets/image/language/pt-BR/dt/betAreaLabel_dt.scss": [
		33680,
		9,
		33680
	],
	"./assets/image/language/pt-BR/lobby/menu": [
		33820,
		3,
		33820
	],
	"./assets/image/language/pt-BR/lobby/menu.json": [
		33820,
		3,
		33820
	],
	"./assets/image/language/pt-BR/lobby/menu.png": [
		39687,
		1,
		39687
	],
	"./assets/image/language/pt-BR/lobby/menu.scss": [
		31532,
		9,
		31532
	],
	"./assets/image/language/pt-BR/multibet/multibet_betarea": [
		34554,
		3,
		34554
	],
	"./assets/image/language/pt-BR/multibet/multibet_betarea.json": [
		34554,
		3,
		34554
	],
	"./assets/image/language/pt-BR/multibet/multibet_betarea.png": [
		32921,
		1,
		32921
	],
	"./assets/image/language/pt-BR/multibet/multibet_betarea.scss": [
		98154,
		9,
		98154
	],
	"./assets/image/language/pt-BR/pokdeng/pokdeng_betarea": [
		17872,
		3,
		17872
	],
	"./assets/image/language/pt-BR/pokdeng/pokdeng_betarea.json": [
		17872,
		3,
		17872
	],
	"./assets/image/language/pt-BR/pokdeng/pokdeng_betarea.png": [
		18211,
		1,
		18211
	],
	"./assets/image/language/pt-BR/pokdeng/pokdeng_betarea.scss": [
		6752,
		9,
		6752
	],
	"./assets/image/language/pt-BR/promotiontool/event_title": [
		69083,
		3,
		69083
	],
	"./assets/image/language/pt-BR/promotiontool/event_title.json": [
		69083,
		3,
		69083
	],
	"./assets/image/language/pt-BR/promotiontool/event_title.png": [
		39570,
		1,
		39570
	],
	"./assets/image/language/pt-BR/promotiontool/event_title.scss": [
		71219,
		9,
		71219
	],
	"./assets/image/language/pt-BR/roulette/roul_betarea": [
		10372,
		3,
		10372
	],
	"./assets/image/language/pt-BR/roulette/roul_betarea.json": [
		10372,
		3,
		10372
	],
	"./assets/image/language/pt-BR/roulette/roul_betarea.png": [
		74031,
		1,
		74031
	],
	"./assets/image/language/pt-BR/roulette/roul_betarea.scss": [
		49924,
		9,
		49924
	],
	"./assets/image/language/pt-BR/sedie/sedie_betarea": [
		13216,
		3,
		13216
	],
	"./assets/image/language/pt-BR/sedie/sedie_betarea.json": [
		13216,
		3,
		13216
	],
	"./assets/image/language/pt-BR/sedie/sedie_betarea.png": [
		96819,
		1,
		96819
	],
	"./assets/image/language/pt-BR/sedie/sedie_betarea.scss": [
		1344,
		9,
		1344
	],
	"./assets/image/language/pt-BR/sicbo/feature": [
		16181,
		3,
		16181
	],
	"./assets/image/language/pt-BR/sicbo/feature.json": [
		16181,
		3,
		16181
	],
	"./assets/image/language/pt-BR/sicbo/feature.png": [
		34192,
		1,
		34192
	],
	"./assets/image/language/pt-BR/sicbo/feature.scss": [
		83565,
		9,
		83565
	],
	"./assets/image/language/pt-BR/sicbo/popular": [
		4518,
		3,
		4518
	],
	"./assets/image/language/pt-BR/sicbo/popular.json": [
		4518,
		3,
		4518
	],
	"./assets/image/language/pt-BR/sicbo/popular.png": [
		26333,
		1,
		26333
	],
	"./assets/image/language/pt-BR/sicbo/popular.scss": [
		7642,
		9,
		7642
	],
	"./assets/image/language/pt-BR/teenpatti/teenPatti_betArea": [
		45388,
		3,
		45388
	],
	"./assets/image/language/pt-BR/teenpatti/teenPatti_betArea.json": [
		45388,
		3,
		45388
	],
	"./assets/image/language/pt-BR/teenpatti/teenPatti_betArea.png": [
		11271,
		1,
		11271
	],
	"./assets/image/language/pt-BR/teenpatti/teenPatti_betArea.scss": [
		66092,
		9,
		66092
	],
	"./assets/image/language/pt-BR/trial/trial_image": [
		62827,
		3,
		62827
	],
	"./assets/image/language/pt-BR/trial/trial_image.json": [
		62827,
		3,
		62827
	],
	"./assets/image/language/pt-BR/trial/trial_image.png": [
		52386,
		1,
		52386
	],
	"./assets/image/language/pt-BR/trial/trial_image.scss": [
		83235,
		9,
		83235
	],
	"./assets/image/language/pt-PT/andarbahar/andarbahar_text": [
		78083,
		3,
		78083
	],
	"./assets/image/language/pt-PT/andarbahar/andarbahar_text.json": [
		78083,
		3,
		78083
	],
	"./assets/image/language/pt-PT/andarbahar/andarbahar_text.png": [
		76362,
		1,
		76362
	],
	"./assets/image/language/pt-PT/andarbahar/andarbahar_text.scss": [
		69099,
		9,
		69099
	],
	"./assets/image/language/pt-PT/baccarat/bacc_betarea_label": [
		47239,
		3,
		47239
	],
	"./assets/image/language/pt-PT/baccarat/bacc_betarea_label.json": [
		47239,
		3,
		47239
	],
	"./assets/image/language/pt-PT/baccarat/bacc_betarea_label.png": [
		40870,
		1,
		40870
	],
	"./assets/image/language/pt-PT/baccarat/bacc_betarea_label.scss": [
		79503,
		9,
		79503
	],
	"./assets/image/language/pt-PT/dt/betAreaLabel_dt": [
		51188,
		3,
		51188
	],
	"./assets/image/language/pt-PT/dt/betAreaLabel_dt.json": [
		51188,
		3,
		51188
	],
	"./assets/image/language/pt-PT/dt/betAreaLabel_dt.png": [
		55951,
		1,
		55951
	],
	"./assets/image/language/pt-PT/dt/betAreaLabel_dt.scss": [
		77372,
		9,
		77372
	],
	"./assets/image/language/pt-PT/lobby/menu": [
		67184,
		3,
		67184
	],
	"./assets/image/language/pt-PT/lobby/menu.json": [
		67184,
		3,
		67184
	],
	"./assets/image/language/pt-PT/lobby/menu.png": [
		29715,
		1,
		29715
	],
	"./assets/image/language/pt-PT/lobby/menu.scss": [
		68512,
		9,
		68512
	],
	"./assets/image/language/pt-PT/multibet/multibet_betarea": [
		17974,
		3,
		17974
	],
	"./assets/image/language/pt-PT/multibet/multibet_betarea.json": [
		17974,
		3,
		17974
	],
	"./assets/image/language/pt-PT/multibet/multibet_betarea.png": [
		16381,
		1,
		16381
	],
	"./assets/image/language/pt-PT/multibet/multibet_betarea.scss": [
		4918,
		9,
		4918
	],
	"./assets/image/language/pt-PT/pokdeng/pokdeng_betarea": [
		4460,
		3,
		4460
	],
	"./assets/image/language/pt-PT/pokdeng/pokdeng_betarea.json": [
		4460,
		3,
		4460
	],
	"./assets/image/language/pt-PT/pokdeng/pokdeng_betarea.png": [
		32391,
		1,
		32391
	],
	"./assets/image/language/pt-PT/pokdeng/pokdeng_betarea.scss": [
		45548,
		9,
		45548
	],
	"./assets/image/language/pt-PT/promotiontool/event_title": [
		15719,
		3,
		15719
	],
	"./assets/image/language/pt-PT/promotiontool/event_title.json": [
		15719,
		3,
		15719
	],
	"./assets/image/language/pt-PT/promotiontool/event_title.png": [
		30262,
		1,
		30262
	],
	"./assets/image/language/pt-PT/promotiontool/event_title.scss": [
		63551,
		9,
		63551
	],
	"./assets/image/language/pt-PT/roulette/roul_betarea": [
		21232,
		3,
		21232
	],
	"./assets/image/language/pt-PT/roulette/roul_betarea.json": [
		21232,
		3,
		21232
	],
	"./assets/image/language/pt-PT/roulette/roul_betarea.png": [
		28899,
		1,
		28899
	],
	"./assets/image/language/pt-PT/roulette/roul_betarea.scss": [
		54496,
		9,
		54496
	],
	"./assets/image/language/pt-PT/sedie/sedie_betarea": [
		87308,
		3,
		87308
	],
	"./assets/image/language/pt-PT/sedie/sedie_betarea.json": [
		87308,
		3,
		87308
	],
	"./assets/image/language/pt-PT/sedie/sedie_betarea.png": [
		88871,
		1,
		88871
	],
	"./assets/image/language/pt-PT/sedie/sedie_betarea.scss": [
		43276,
		9,
		43276
	],
	"./assets/image/language/pt-PT/sicbo/feature": [
		20673,
		3,
		20673
	],
	"./assets/image/language/pt-PT/sicbo/feature.json": [
		20673,
		3,
		20673
	],
	"./assets/image/language/pt-PT/sicbo/feature.png": [
		56660,
		1,
		56660
	],
	"./assets/image/language/pt-PT/sicbo/feature.scss": [
		7577,
		9,
		7577
	],
	"./assets/image/language/pt-PT/sicbo/popular": [
		9746,
		3,
		9746
	],
	"./assets/image/language/pt-PT/sicbo/popular.json": [
		9746,
		3,
		9746
	],
	"./assets/image/language/pt-PT/sicbo/popular.png": [
		66481,
		1,
		66481
	],
	"./assets/image/language/pt-PT/sicbo/popular.scss": [
		32950,
		9,
		32950
	],
	"./assets/image/language/pt-PT/teenpatti/teenPatti_betArea": [
		43720,
		3,
		43720
	],
	"./assets/image/language/pt-PT/teenpatti/teenPatti_betArea.json": [
		43720,
		3,
		43720
	],
	"./assets/image/language/pt-PT/teenpatti/teenPatti_betArea.png": [
		92555,
		1,
		92555
	],
	"./assets/image/language/pt-PT/teenpatti/teenPatti_betArea.scss": [
		10104,
		9,
		10104
	],
	"./assets/image/language/pt-PT/trial/trial_image": [
		19111,
		3,
		19111
	],
	"./assets/image/language/pt-PT/trial/trial_image.json": [
		19111,
		3,
		19111
	],
	"./assets/image/language/pt-PT/trial/trial_image.png": [
		67926,
		1,
		67926
	],
	"./assets/image/language/pt-PT/trial/trial_image.scss": [
		5967,
		9,
		5967
	],
	"./assets/image/language/te-IN/andarbahar/andarbahar_text": [
		23097,
		3,
		23097
	],
	"./assets/image/language/te-IN/andarbahar/andarbahar_text.json": [
		23097,
		3,
		23097
	],
	"./assets/image/language/te-IN/andarbahar/andarbahar_text.png": [
		13356,
		1,
		13356
	],
	"./assets/image/language/te-IN/andarbahar/andarbahar_text.scss": [
		39693,
		9,
		39693
	],
	"./assets/image/language/te-IN/baccarat/bacc_betarea_label": [
		1725,
		3,
		1725
	],
	"./assets/image/language/te-IN/baccarat/bacc_betarea_label.json": [
		1725,
		3,
		1725
	],
	"./assets/image/language/te-IN/baccarat/bacc_betarea_label.png": [
		64456,
		1,
		64456
	],
	"./assets/image/language/te-IN/baccarat/bacc_betarea_label.scss": [
		86385,
		9,
		86385
	],
	"./assets/image/language/te-IN/dt/betAreaLabel_dt": [
		20030,
		3,
		20030
	],
	"./assets/image/language/te-IN/dt/betAreaLabel_dt.json": [
		20030,
		3,
		20030
	],
	"./assets/image/language/te-IN/dt/betAreaLabel_dt.png": [
		70981,
		1,
		70981
	],
	"./assets/image/language/te-IN/dt/betAreaLabel_dt.scss": [
		60002,
		9,
		60002
	],
	"./assets/image/language/te-IN/lobby/menu": [
		58578,
		3,
		58578
	],
	"./assets/image/language/te-IN/lobby/menu.json": [
		58578,
		3,
		58578
	],
	"./assets/image/language/te-IN/lobby/menu.png": [
		44881,
		1,
		44881
	],
	"./assets/image/language/te-IN/lobby/menu.scss": [
		26494,
		9,
		26494
	],
	"./assets/image/language/te-IN/multibet/multibet_betarea": [
		10400,
		3,
		10400
	],
	"./assets/image/language/te-IN/multibet/multibet_betarea.json": [
		10400,
		3,
		10400
	],
	"./assets/image/language/te-IN/multibet/multibet_betarea.png": [
		6835,
		1,
		6835
	],
	"./assets/image/language/te-IN/multibet/multibet_betarea.scss": [
		90975,
		9,
		90975
	],
	"./assets/image/language/te-IN/pokdeng/pokdeng_betarea": [
		94382,
		3,
		94382
	],
	"./assets/image/language/te-IN/pokdeng/pokdeng_betarea.json": [
		94382,
		3,
		94382
	],
	"./assets/image/language/te-IN/pokdeng/pokdeng_betarea.png": [
		92229,
		1,
		92229
	],
	"./assets/image/language/te-IN/pokdeng/pokdeng_betarea.scss": [
		75418,
		9,
		75418
	],
	"./assets/image/language/te-IN/promotiontool/event_title": [
		84653,
		3,
		84653
	],
	"./assets/image/language/te-IN/promotiontool/event_title.json": [
		84653,
		3,
		84653
	],
	"./assets/image/language/te-IN/promotiontool/event_title.png": [
		2216,
		1,
		2216
	],
	"./assets/image/language/te-IN/promotiontool/event_title.scss": [
		50561,
		9,
		50561
	],
	"./assets/image/language/te-IN/roulette/roul_betarea": [
		99794,
		3,
		99794
	],
	"./assets/image/language/te-IN/roulette/roul_betarea.json": [
		99794,
		3,
		99794
	],
	"./assets/image/language/te-IN/roulette/roul_betarea.png": [
		3521,
		1,
		3521
	],
	"./assets/image/language/te-IN/roulette/roul_betarea.scss": [
		7726,
		9,
		7726
	],
	"./assets/image/language/te-IN/sedie/sedie_betarea": [
		65934,
		3,
		65934
	],
	"./assets/image/language/te-IN/sedie/sedie_betarea.json": [
		65934,
		3,
		65934
	],
	"./assets/image/language/te-IN/sedie/sedie_betarea.png": [
		98597,
		1,
		98597
	],
	"./assets/image/language/te-IN/sedie/sedie_betarea.scss": [
		15610,
		9,
		15610
	],
	"./assets/image/language/te-IN/sicbo/feature": [
		88167,
		3,
		88167
	],
	"./assets/image/language/te-IN/sicbo/feature.json": [
		88167,
		3,
		88167
	],
	"./assets/image/language/te-IN/sicbo/feature.png": [
		56166,
		1,
		56166
	],
	"./assets/image/language/te-IN/sicbo/feature.scss": [
		70171,
		9,
		70171
	],
	"./assets/image/language/te-IN/sicbo/popular": [
		60128,
		3,
		60128
	],
	"./assets/image/language/te-IN/sicbo/popular.json": [
		60128,
		3,
		60128
	],
	"./assets/image/language/te-IN/sicbo/popular.png": [
		65827,
		1,
		65827
	],
	"./assets/image/language/te-IN/sicbo/popular.scss": [
		12024,
		9,
		12024
	],
	"./assets/image/language/te-IN/teenpatti/teenPatti_betArea": [
		1818,
		3,
		1818
	],
	"./assets/image/language/te-IN/teenpatti/teenPatti_betArea.json": [
		1818,
		3,
		1818
	],
	"./assets/image/language/te-IN/teenpatti/teenPatti_betArea.png": [
		19225,
		1,
		19225
	],
	"./assets/image/language/te-IN/teenpatti/teenPatti_betArea.scss": [
		58038,
		9,
		58038
	],
	"./assets/image/language/te-IN/trial/trial_image": [
		32861,
		3,
		32861
	],
	"./assets/image/language/te-IN/trial/trial_image.json": [
		32861,
		3,
		32861
	],
	"./assets/image/language/te-IN/trial/trial_image.png": [
		62264,
		1,
		62264
	],
	"./assets/image/language/te-IN/trial/trial_image.scss": [
		19489,
		9,
		19489
	],
	"./assets/image/language/th-TH/andarbahar/andarbahar_text": [
		14475,
		3,
		14475
	],
	"./assets/image/language/th-TH/andarbahar/andarbahar_text.json": [
		14475,
		3,
		14475
	],
	"./assets/image/language/th-TH/andarbahar/andarbahar_text.png": [
		85794,
		1,
		85794
	],
	"./assets/image/language/th-TH/andarbahar/andarbahar_text.scss": [
		66299,
		9,
		66299
	],
	"./assets/image/language/th-TH/baccarat/bacc_betarea_label": [
		82815,
		3,
		82815
	],
	"./assets/image/language/th-TH/baccarat/bacc_betarea_label.json": [
		82815,
		3,
		82815
	],
	"./assets/image/language/th-TH/baccarat/bacc_betarea_label.png": [
		7822,
		1,
		7822
	],
	"./assets/image/language/th-TH/baccarat/bacc_betarea_label.scss": [
		4895,
		9,
		4895
	],
	"./assets/image/language/th-TH/dt/betAreaLabel_dt": [
		1388,
		3,
		1388
	],
	"./assets/image/language/th-TH/dt/betAreaLabel_dt.json": [
		1388,
		3,
		1388
	],
	"./assets/image/language/th-TH/dt/betAreaLabel_dt.png": [
		19959,
		1,
		19959
	],
	"./assets/image/language/th-TH/dt/betAreaLabel_dt.scss": [
		47084,
		9,
		47084
	],
	"./assets/image/language/th-TH/lobby/menu": [
		39304,
		3,
		39304
	],
	"./assets/image/language/th-TH/lobby/menu.json": [
		39304,
		3,
		39304
	],
	"./assets/image/language/th-TH/lobby/menu.png": [
		44731,
		1,
		44731
	],
	"./assets/image/language/th-TH/lobby/menu.scss": [
		85744,
		9,
		85744
	],
	"./assets/image/language/th-TH/multibet/multibet_betarea": [
		7646,
		3,
		7646
	],
	"./assets/image/language/th-TH/multibet/multibet_betarea.json": [
		7646,
		3,
		7646
	],
	"./assets/image/language/th-TH/multibet/multibet_betarea.png": [
		9205,
		1,
		9205
	],
	"./assets/image/language/th-TH/multibet/multibet_betarea.scss": [
		85094,
		9,
		85094
	],
	"./assets/image/language/th-TH/pokdeng/pokdeng_betarea": [
		8276,
		3,
		8276
	],
	"./assets/image/language/th-TH/pokdeng/pokdeng_betarea.json": [
		8276,
		3,
		8276
	],
	"./assets/image/language/th-TH/pokdeng/pokdeng_betarea.png": [
		88511,
		1,
		88511
	],
	"./assets/image/language/th-TH/pokdeng/pokdeng_betarea.scss": [
		28028,
		9,
		28028
	],
	"./assets/image/language/th-TH/promotiontool/event_title": [
		29199,
		3,
		29199
	],
	"./assets/image/language/th-TH/promotiontool/event_title.json": [
		29199,
		3,
		29199
	],
	"./assets/image/language/th-TH/promotiontool/event_title.png": [
		10606,
		1,
		10606
	],
	"./assets/image/language/th-TH/promotiontool/event_title.scss": [
		47439,
		9,
		47439
	],
	"./assets/image/language/th-TH/roulette/roul_betarea": [
		55864,
		3,
		55864
	],
	"./assets/image/language/th-TH/roulette/roul_betarea.json": [
		55864,
		3,
		55864
	],
	"./assets/image/language/th-TH/roulette/roul_betarea.png": [
		59931,
		1,
		59931
	],
	"./assets/image/language/th-TH/roulette/roul_betarea.scss": [
		96208,
		9,
		96208
	],
	"./assets/image/language/th-TH/sedie/sedie_betarea": [
		30164,
		3,
		30164
	],
	"./assets/image/language/th-TH/sedie/sedie_betarea.json": [
		30164,
		3,
		30164
	],
	"./assets/image/language/th-TH/sedie/sedie_betarea.png": [
		65823,
		1,
		65823
	],
	"./assets/image/language/th-TH/sedie/sedie_betarea.scss": [
		77084,
		9,
		77084
	],
	"./assets/image/language/th-TH/sicbo/feature": [
		73177,
		3,
		73177
	],
	"./assets/image/language/th-TH/sicbo/feature.json": [
		73177,
		3,
		73177
	],
	"./assets/image/language/th-TH/sicbo/feature.png": [
		81916,
		1,
		81916
	],
	"./assets/image/language/th-TH/sicbo/feature.scss": [
		43913,
		9,
		43913
	],
	"./assets/image/language/th-TH/sicbo/popular": [
		25930,
		3,
		25930
	],
	"./assets/image/language/th-TH/sicbo/popular.json": [
		25930,
		3,
		25930
	],
	"./assets/image/language/th-TH/sicbo/popular.png": [
		20921,
		1,
		20921
	],
	"./assets/image/language/th-TH/sicbo/popular.scss": [
		66598,
		9,
		66598
	],
	"./assets/image/language/th-TH/teenpatti/teenPatti_betArea": [
		83088,
		3,
		83088
	],
	"./assets/image/language/th-TH/teenpatti/teenPatti_betArea.json": [
		83088,
		3,
		83088
	],
	"./assets/image/language/th-TH/teenpatti/teenPatti_betArea.png": [
		96899,
		1,
		96899
	],
	"./assets/image/language/th-TH/teenpatti/teenPatti_betArea.scss": [
		22984,
		9,
		22984
	],
	"./assets/image/language/th-TH/trial/trial_image": [
		10735,
		3,
		10735
	],
	"./assets/image/language/th-TH/trial/trial_image.json": [
		10735,
		3,
		10735
	],
	"./assets/image/language/th-TH/trial/trial_image.png": [
		14830,
		1,
		14830
	],
	"./assets/image/language/th-TH/trial/trial_image.scss": [
		2879,
		9,
		2879
	],
	"./assets/image/language/vi-VN/andarbahar/andarbahar_text": [
		634,
		3,
		634
	],
	"./assets/image/language/vi-VN/andarbahar/andarbahar_text.json": [
		634,
		3,
		634
	],
	"./assets/image/language/vi-VN/andarbahar/andarbahar_text.png": [
		49721,
		1,
		49721
	],
	"./assets/image/language/vi-VN/andarbahar/andarbahar_text.scss": [
		31578,
		9,
		31578
	],
	"./assets/image/language/vi-VN/baccarat/bacc_betarea_label": [
		53724,
		3,
		53724
	],
	"./assets/image/language/vi-VN/baccarat/bacc_betarea_label.json": [
		53724,
		3,
		53724
	],
	"./assets/image/language/vi-VN/baccarat/bacc_betarea_label.png": [
		70151,
		1,
		70151
	],
	"./assets/image/language/vi-VN/baccarat/bacc_betarea_label.scss": [
		77524,
		9,
		77524
	],
	"./assets/image/language/vi-VN/dt/betAreaLabel_dt": [
		34373,
		3,
		34373
	],
	"./assets/image/language/vi-VN/dt/betAreaLabel_dt.json": [
		34373,
		3,
		34373
	],
	"./assets/image/language/vi-VN/dt/betAreaLabel_dt.png": [
		80288,
		1,
		80288
	],
	"./assets/image/language/vi-VN/dt/betAreaLabel_dt.scss": [
		78733,
		9,
		78733
	],
	"./assets/image/language/vi-VN/lobby/menu": [
		73801,
		3,
		73801
	],
	"./assets/image/language/vi-VN/lobby/menu.json": [
		73801,
		3,
		73801
	],
	"./assets/image/language/vi-VN/lobby/menu.png": [
		41164,
		1,
		41164
	],
	"./assets/image/language/vi-VN/lobby/menu.scss": [
		10377,
		9,
		10377
	],
	"./assets/image/language/vi-VN/multibet/multibet_betarea": [
		62465,
		3,
		62465
	],
	"./assets/image/language/vi-VN/multibet/multibet_betarea.json": [
		62465,
		3,
		62465
	],
	"./assets/image/language/vi-VN/multibet/multibet_betarea.png": [
		34244,
		1,
		34244
	],
	"./assets/image/language/vi-VN/multibet/multibet_betarea.scss": [
		92705,
		9,
		92705
	],
	"./assets/image/language/vi-VN/pokdeng/pokdeng_betarea": [
		46475,
		3,
		46475
	],
	"./assets/image/language/vi-VN/pokdeng/pokdeng_betarea.json": [
		46475,
		3,
		46475
	],
	"./assets/image/language/vi-VN/pokdeng/pokdeng_betarea.png": [
		44290,
		1,
		44290
	],
	"./assets/image/language/vi-VN/pokdeng/pokdeng_betarea.scss": [
		15851,
		9,
		15851
	],
	"./assets/image/language/vi-VN/promotiontool/event_title": [
		54704,
		3,
		54704
	],
	"./assets/image/language/vi-VN/promotiontool/event_title.json": [
		54704,
		3,
		54704
	],
	"./assets/image/language/vi-VN/promotiontool/event_title.png": [
		93667,
		1,
		93667
	],
	"./assets/image/language/vi-VN/promotiontool/event_title.scss": [
		84168,
		9,
		84168
	],
	"./assets/image/language/vi-VN/roulette/roul_betarea": [
		23739,
		3,
		23739
	],
	"./assets/image/language/vi-VN/roulette/roul_betarea.json": [
		23739,
		3,
		23739
	],
	"./assets/image/language/vi-VN/roulette/roul_betarea.png": [
		87986,
		1,
		87986
	],
	"./assets/image/language/vi-VN/roulette/roul_betarea.scss": [
		31555,
		9,
		31555
	],
	"./assets/image/language/vi-VN/sedie/sedie_betarea": [
		20267,
		3,
		20267
	],
	"./assets/image/language/vi-VN/sedie/sedie_betarea.json": [
		20267,
		3,
		20267
	],
	"./assets/image/language/vi-VN/sedie/sedie_betarea.png": [
		65282,
		1,
		65282
	],
	"./assets/image/language/vi-VN/sedie/sedie_betarea.scss": [
		78971,
		9,
		78971
	],
	"./assets/image/language/vi-VN/sicbo/feature": [
		51462,
		3,
		51462
	],
	"./assets/image/language/vi-VN/sicbo/feature.json": [
		51462,
		3,
		51462
	],
	"./assets/image/language/vi-VN/sicbo/feature.png": [
		51645,
		1,
		51645
	],
	"./assets/image/language/vi-VN/sicbo/feature.scss": [
		49166,
		9,
		49166
	],
	"./assets/image/language/vi-VN/sicbo/popular": [
		22789,
		3,
		22789
	],
	"./assets/image/language/vi-VN/sicbo/popular.json": [
		22789,
		3,
		22789
	],
	"./assets/image/language/vi-VN/sicbo/popular.png": [
		88019,
		1,
		88019
	],
	"./assets/image/language/vi-VN/sicbo/popular.scss": [
		13809,
		9,
		13809
	],
	"./assets/image/language/vi-VN/teenpatti/teenPatti_betArea": [
		18439,
		3,
		18439
	],
	"./assets/image/language/vi-VN/teenpatti/teenPatti_betArea.json": [
		18439,
		3,
		18439
	],
	"./assets/image/language/vi-VN/teenpatti/teenPatti_betArea.png": [
		90390,
		1,
		90390
	],
	"./assets/image/language/vi-VN/teenpatti/teenPatti_betArea.scss": [
		77399,
		9,
		77399
	],
	"./assets/image/language/vi-VN/trial/trial_image": [
		42448,
		3,
		42448
	],
	"./assets/image/language/vi-VN/trial/trial_image.json": [
		42448,
		3,
		42448
	],
	"./assets/image/language/vi-VN/trial/trial_image.png": [
		62595,
		1,
		62595
	],
	"./assets/image/language/vi-VN/trial/trial_image.scss": [
		79176,
		9,
		79176
	],
	"./assets/image/language/zh-CN/andarbahar/andarbahar_text": [
		40854,
		3,
		40854
	],
	"./assets/image/language/zh-CN/andarbahar/andarbahar_text.json": [
		40854,
		3,
		40854
	],
	"./assets/image/language/zh-CN/andarbahar/andarbahar_text.png": [
		31789,
		1,
		31789
	],
	"./assets/image/language/zh-CN/andarbahar/andarbahar_text.scss": [
		5822,
		9,
		5822
	],
	"./assets/image/language/zh-CN/baccarat/bacc_betarea_label": [
		32776,
		3,
		32776
	],
	"./assets/image/language/zh-CN/baccarat/bacc_betarea_label.json": [
		32776,
		3,
		32776
	],
	"./assets/image/language/zh-CN/baccarat/bacc_betarea_label.png": [
		37099,
		1,
		37099
	],
	"./assets/image/language/zh-CN/baccarat/bacc_betarea_label.scss": [
		98616,
		9,
		98616
	],
	"./assets/image/language/zh-CN/dt/betAreaLabel_dt": [
		11862,
		3,
		89481
	],
	"./assets/image/language/zh-CN/dt/betAreaLabel_dt.json": [
		11862,
		3,
		89481
	],
	"./assets/image/language/zh-CN/dt/betAreaLabel_dt.png": [
		21020,
		1,
		21020
	],
	"./assets/image/language/zh-CN/dt/betAreaLabel_dt.scss": [
		93897,
		9,
		93897
	],
	"./assets/image/language/zh-CN/lobby/menu": [
		48757,
		3,
		48757
	],
	"./assets/image/language/zh-CN/lobby/menu.json": [
		48757,
		3,
		48757
	],
	"./assets/image/language/zh-CN/lobby/menu.png": [
		42048,
		1,
		42048
	],
	"./assets/image/language/zh-CN/lobby/menu.scss": [
		76701,
		9,
		76701
	],
	"./assets/image/language/zh-CN/multibet/multibet_betarea": [
		43429,
		3,
		43429
	],
	"./assets/image/language/zh-CN/multibet/multibet_betarea.json": [
		43429,
		3,
		43429
	],
	"./assets/image/language/zh-CN/multibet/multibet_betarea.png": [
		51712,
		1,
		51712
	],
	"./assets/image/language/zh-CN/multibet/multibet_betarea.scss": [
		7117,
		9,
		7117
	],
	"./assets/image/language/zh-CN/pokdeng/pokdeng_betarea": [
		73503,
		3,
		73503
	],
	"./assets/image/language/zh-CN/pokdeng/pokdeng_betarea.json": [
		73503,
		3,
		73503
	],
	"./assets/image/language/zh-CN/pokdeng/pokdeng_betarea.png": [
		30382,
		1,
		30382
	],
	"./assets/image/language/zh-CN/pokdeng/pokdeng_betarea.scss": [
		23431,
		9,
		23431
	],
	"./assets/image/language/zh-CN/promotiontool/event_title": [
		69124,
		3,
		69124
	],
	"./assets/image/language/zh-CN/promotiontool/event_title.json": [
		69124,
		3,
		69124
	],
	"./assets/image/language/zh-CN/promotiontool/event_title.png": [
		56255,
		1,
		56255
	],
	"./assets/image/language/zh-CN/promotiontool/event_title.scss": [
		8532,
		9,
		8532
	],
	"./assets/image/language/zh-CN/roulette/roul_betarea": [
		76975,
		3,
		76975
	],
	"./assets/image/language/zh-CN/roulette/roul_betarea.json": [
		76975,
		3,
		76975
	],
	"./assets/image/language/zh-CN/roulette/roul_betarea.png": [
		16798,
		1,
		16798
	],
	"./assets/image/language/zh-CN/roulette/roul_betarea.scss": [
		27007,
		9,
		27007
	],
	"./assets/image/language/zh-CN/sedie/sedie_betarea": [
		1119,
		3,
		1119
	],
	"./assets/image/language/zh-CN/sedie/sedie_betarea.json": [
		1119,
		3,
		1119
	],
	"./assets/image/language/zh-CN/sedie/sedie_betarea.png": [
		20174,
		1,
		20174
	],
	"./assets/image/language/zh-CN/sedie/sedie_betarea.scss": [
		18087,
		9,
		18087
	],
	"./assets/image/language/zh-CN/sicbo/feature": [
		50426,
		3,
		50426
	],
	"./assets/image/language/zh-CN/sicbo/feature.json": [
		50426,
		3,
		50426
	],
	"./assets/image/language/zh-CN/sicbo/feature.png": [
		27609,
		1,
		27609
	],
	"./assets/image/language/zh-CN/sicbo/feature.scss": [
		40314,
		9,
		40314
	],
	"./assets/image/language/zh-CN/sicbo/popular": [
		89257,
		3,
		89257
	],
	"./assets/image/language/zh-CN/sicbo/popular.json": [
		89257,
		3,
		89257
	],
	"./assets/image/language/zh-CN/sicbo/popular.png": [
		4252,
		1,
		4252
	],
	"./assets/image/language/zh-CN/sicbo/popular.scss": [
		23853,
		9,
		23853
	],
	"./assets/image/language/zh-CN/teenpatti/teenPatti_betArea": [
		23563,
		3,
		23563
	],
	"./assets/image/language/zh-CN/teenpatti/teenPatti_betArea.json": [
		23563,
		3,
		23563
	],
	"./assets/image/language/zh-CN/teenpatti/teenPatti_betArea.png": [
		47858,
		1,
		47858
	],
	"./assets/image/language/zh-CN/teenpatti/teenPatti_betArea.scss": [
		34307,
		9,
		34307
	],
	"./assets/image/language/zh-CN/trial/trial_image": [
		80756,
		3,
		80756
	],
	"./assets/image/language/zh-CN/trial/trial_image.json": [
		80756,
		3,
		80756
	],
	"./assets/image/language/zh-CN/trial/trial_image.png": [
		38895,
		1,
		38895
	],
	"./assets/image/language/zh-CN/trial/trial_image.scss": [
		44644,
		9,
		44644
	],
	"./assets/image/language/zh-TW/andarbahar/andarbahar_text": [
		82282,
		3,
		82282
	],
	"./assets/image/language/zh-TW/andarbahar/andarbahar_text.json": [
		82282,
		3,
		82282
	],
	"./assets/image/language/zh-TW/andarbahar/andarbahar_text.png": [
		82089,
		1,
		82089
	],
	"./assets/image/language/zh-TW/andarbahar/andarbahar_text.scss": [
		39734,
		9,
		39734
	],
	"./assets/image/language/zh-TW/baccarat/bacc_betarea_label": [
		8908,
		3,
		8908
	],
	"./assets/image/language/zh-TW/baccarat/bacc_betarea_label.json": [
		8908,
		3,
		8908
	],
	"./assets/image/language/zh-TW/baccarat/bacc_betarea_label.png": [
		20183,
		1,
		20183
	],
	"./assets/image/language/zh-TW/baccarat/bacc_betarea_label.scss": [
		30176,
		9,
		30176
	],
	"./assets/image/language/zh-TW/dt/betAreaLabel_dt": [
		40341,
		3,
		40341
	],
	"./assets/image/language/zh-TW/dt/betAreaLabel_dt.json": [
		40341,
		3,
		40341
	],
	"./assets/image/language/zh-TW/dt/betAreaLabel_dt.png": [
		16944,
		1,
		16944
	],
	"./assets/image/language/zh-TW/dt/betAreaLabel_dt.scss": [
		9905,
		9,
		9905
	],
	"./assets/image/language/zh-TW/lobby/menu": [
		12857,
		3,
		12857
	],
	"./assets/image/language/zh-TW/lobby/menu.json": [
		12857,
		3,
		12857
	],
	"./assets/image/language/zh-TW/lobby/menu.png": [
		97820,
		1,
		97820
	],
	"./assets/image/language/zh-TW/lobby/menu.scss": [
		67506,
		9,
		45125
	],
	"./assets/image/language/zh-TW/multibet/multibet_betarea": [
		57873,
		3,
		57873
	],
	"./assets/image/language/zh-TW/multibet/multibet_betarea.json": [
		57873,
		3,
		57873
	],
	"./assets/image/language/zh-TW/multibet/multibet_betarea.png": [
		63924,
		1,
		63924
	],
	"./assets/image/language/zh-TW/multibet/multibet_betarea.scss": [
		97093,
		9,
		97093
	],
	"./assets/image/language/zh-TW/pokdeng/pokdeng_betarea": [
		82939,
		3,
		82939
	],
	"./assets/image/language/zh-TW/pokdeng/pokdeng_betarea.json": [
		82939,
		3,
		82939
	],
	"./assets/image/language/zh-TW/pokdeng/pokdeng_betarea.png": [
		15890,
		1,
		15890
	],
	"./assets/image/language/zh-TW/pokdeng/pokdeng_betarea.scss": [
		94399,
		9,
		94399
	],
	"./assets/image/language/zh-TW/promotiontool/event_title": [
		33856,
		3,
		33856
	],
	"./assets/image/language/zh-TW/promotiontool/event_title.json": [
		33856,
		3,
		33856
	],
	"./assets/image/language/zh-TW/promotiontool/event_title.png": [
		64499,
		1,
		64499
	],
	"./assets/image/language/zh-TW/promotiontool/event_title.scss": [
		55820,
		9,
		55820
	],
	"./assets/image/language/zh-TW/roulette/roul_betarea": [
		13739,
		3,
		13739
	],
	"./assets/image/language/zh-TW/roulette/roul_betarea.json": [
		13739,
		3,
		13739
	],
	"./assets/image/language/zh-TW/roulette/roul_betarea.png": [
		2722,
		1,
		2722
	],
	"./assets/image/language/zh-TW/roulette/roul_betarea.scss": [
		47127,
		9,
		47127
	],
	"./assets/image/language/zh-TW/sedie/sedie_betarea": [
		66491,
		3,
		66491
	],
	"./assets/image/language/zh-TW/sedie/sedie_betarea.json": [
		66491,
		3,
		66491
	],
	"./assets/image/language/zh-TW/sedie/sedie_betarea.png": [
		26258,
		1,
		26258
	],
	"./assets/image/language/zh-TW/sedie/sedie_betarea.scss": [
		69823,
		9,
		69823
	],
	"./assets/image/language/zh-TW/sicbo/feature": [
		3766,
		3,
		3766
	],
	"./assets/image/language/zh-TW/sicbo/feature.json": [
		3766,
		3,
		3766
	],
	"./assets/image/language/zh-TW/sicbo/feature.png": [
		57261,
		1,
		57261
	],
	"./assets/image/language/zh-TW/sicbo/feature.scss": [
		49858,
		9,
		49858
	],
	"./assets/image/language/zh-TW/sicbo/popular": [
		9269,
		3,
		9269
	],
	"./assets/image/language/zh-TW/sicbo/popular.json": [
		9269,
		3,
		9269
	],
	"./assets/image/language/zh-TW/sicbo/popular.png": [
		98320,
		1,
		98320
	],
	"./assets/image/language/zh-TW/sicbo/popular.scss": [
		33941,
		9,
		33941
	],
	"./assets/image/language/zh-TW/teenpatti/teenPatti_betArea": [
		25175,
		3,
		25175
	],
	"./assets/image/language/zh-TW/teenpatti/teenPatti_betArea.json": [
		25175,
		3,
		25175
	],
	"./assets/image/language/zh-TW/teenpatti/teenPatti_betArea.png": [
		73606,
		1,
		73606
	],
	"./assets/image/language/zh-TW/teenpatti/teenPatti_betArea.scss": [
		53352,
		9,
		30971
	],
	"./assets/image/language/zh-TW/trial/trial_image": [
		57600,
		3,
		57600
	],
	"./assets/image/language/zh-TW/trial/trial_image.json": [
		57600,
		3,
		57600
	],
	"./assets/image/language/zh-TW/trial/trial_image.png": [
		48627,
		1,
		48627
	],
	"./assets/image/language/zh-TW/trial/trial_image.scss": [
		86684,
		9,
		86684
	],
	"./components/common/baseImage": [
		31508,
		9
	],
	"./components/common/baseImage/": [
		31508,
		9
	],
	"./components/common/baseImage/components/animationImage": [
		62055,
		9
	],
	"./components/common/baseImage/components/animationImage/": [
		62055,
		9
	],
	"./components/common/baseImage/components/animationImage/index": [
		62055,
		9
	],
	"./components/common/baseImage/components/animationImage/index.tsx": [
		62055,
		9
	],
	"./components/common/baseImage/index": [
		31508,
		9
	],
	"./components/common/baseImage/index.tsx": [
		31508,
		9
	],
	"./components/common/baseText/BaseTypography": [
		69770,
		9
	],
	"./components/common/baseText/BaseTypography.tsx": [
		69770,
		9
	],
	"./components/common/betArea": [
		15044,
		9
	],
	"./components/common/betArea/": [
		15044,
		9
	],
	"./components/common/betArea/TotalBetAmount": [
		15153,
		9
	],
	"./components/common/betArea/TotalBetAmount.tsx": [
		15153,
		9
	],
	"./components/common/betArea/index": [
		15044,
		9
	],
	"./components/common/betArea/index.scss": [
		68353,
		9
	],
	"./components/common/betArea/index.tsx": [
		15044,
		9
	],
	"./components/common/button": [
		74810,
		9
	],
	"./components/common/button/": [
		74810,
		9
	],
	"./components/common/button/baseButton": [
		64518,
		9
	],
	"./components/common/button/baseButton/": [
		64518,
		9
	],
	"./components/common/button/baseButton/index": [
		64518,
		9
	],
	"./components/common/button/baseButton/index.scss": [
		81031,
		9
	],
	"./components/common/button/baseButton/index.tsx": [
		64518,
		9
	],
	"./components/common/button/index": [
		74810,
		9
	],
	"./components/common/button/index.scss": [
		743,
		9
	],
	"./components/common/button/index.tsx": [
		74810,
		9
	],
	"./components/common/chips": [
		2529,
		9
	],
	"./components/common/chips/": [
		2529,
		9
	],
	"./components/common/chips/chip": [
		55080,
		9
	],
	"./components/common/chips/chip/": [
		55080,
		9
	],
	"./components/common/chips/chip/index": [
		55080,
		9
	],
	"./components/common/chips/chip/index.scss": [
		24441,
		9
	],
	"./components/common/chips/chip/index.tsx": [
		55080,
		9
	],
	"./components/common/chips/index": [
		2529,
		9
	],
	"./components/common/chips/index.ts": [
		2529,
		9
	],
	"./components/common/chips/pending": [
		50079,
		9
	],
	"./components/common/chips/pending/": [
		50079,
		9
	],
	"./components/common/chips/pending/index": [
		50079,
		9
	],
	"./components/common/chips/pending/index.scss": [
		3136,
		9
	],
	"./components/common/chips/pending/index.tsx": [
		50079,
		9
	],
	"./components/common/confirmPanel": [
		36432,
		9
	],
	"./components/common/confirmPanel/": [
		36432,
		9
	],
	"./components/common/confirmPanel/index": [
		36432,
		9
	],
	"./components/common/confirmPanel/index.tsx": [
		36432,
		9
	],
	"./components/common/netState": [
		73458,
		9
	],
	"./components/common/netState/": [
		73458,
		9
	],
	"./components/common/netState/index": [
		73458,
		9
	],
	"./components/common/netState/index.scss": [
		45835,
		9
	],
	"./components/common/netState/index.tsx": [
		73458,
		9
	],
	"./components/common/playerCountPanel": [
		24908,
		9,
		24908
	],
	"./components/common/playerCountPanel/": [
		24908,
		9,
		24908
	],
	"./components/common/playerCountPanel/index": [
		24908,
		9,
		24908
	],
	"./components/common/playerCountPanel/index.scss": [
		38177,
		9,
		38177
	],
	"./components/common/playerCountPanel/index.tsx": [
		24908,
		9,
		24908
	],
	"./components/common/poker": [
		35313,
		9
	],
	"./components/common/poker/": [
		35313,
		9
	],
	"./components/common/poker/index": [
		35313,
		9
	],
	"./components/common/poker/index.tsx": [
		35313,
		9
	],
	"./components/images": [
		11794,
		9
	],
	"./components/images/": [
		11794,
		9
	],
	"./components/images/certificate/GamingCuracaoLogo": [
		1488,
		9
	],
	"./components/images/certificate/GamingCuracaoLogo.tsx": [
		1488,
		9
	],
	"./components/images/certificate/GamingLabLogo": [
		8507,
		9
	],
	"./components/images/certificate/GamingLabLogo.tsx": [
		8507,
		9
	],
	"./components/images/index": [
		11794,
		9
	],
	"./components/images/index.ts": [
		11794,
		9
	],
	"./components/images/landing/SaLoadingLogo": [
		31371,
		9
	],
	"./components/images/landing/SaLoadingLogo.tsx": [
		31371,
		9
	],
	"./components/images/landing/SaLoadingOverlayLogo": [
		5265,
		9
	],
	"./components/images/landing/SaLoadingOverlayLogo.tsx": [
		5265,
		9
	],
	"./components/images/landing/SaLogo": [
		1193,
		9
	],
	"./components/images/landing/SaLogo.tsx": [
		1193,
		9
	],
	"./components/images/loading/LoadingDot": [
		72350,
		9
	],
	"./components/images/loading/LoadingDot.tsx": [
		72350,
		9
	],
	"./contexts/AudioPlayContext": [
		12200,
		9
	],
	"./contexts/AudioPlayContext.tsx": [
		12200,
		9
	],
	"./contexts/BetChipContext": [
		72481,
		9
	],
	"./contexts/BetChipContext.tsx": [
		72481,
		9
	],
	"./contexts/CdnContext": [
		23723,
		9
	],
	"./contexts/CdnContext.tsx": [
		23723,
		9
	],
	"./contexts/ConfigContext": [
		60290,
		9
	],
	"./contexts/ConfigContext.tsx": [
		60290,
		9
	],
	"./contexts/DatePickerLocalizationContext": [
		60431,
		9
	],
	"./contexts/DatePickerLocalizationContext.tsx": [
		60431,
		9
	],
	"./contexts/EnterCountContext": [
		36177,
		9
	],
	"./contexts/EnterCountContext.tsx": [
		36177,
		9
	],
	"./contexts/GlobalDataContext": [
		99919,
		9
	],
	"./contexts/GlobalDataContext.tsx": [
		99919,
		9
	],
	"./contexts/LiteUIContext": [
		60878,
		9
	],
	"./contexts/LiteUIContext.tsx": [
		60878,
		9
	],
	"./contexts/LobbyUiContext": [
		85002,
		9
	],
	"./contexts/LobbyUiContext.tsx": [
		85002,
		9
	],
	"./contexts/ResourceContext": [
		28900,
		9
	],
	"./contexts/ResourceContext.tsx": [
		28900,
		9
	],
	"./contexts/SeatAreaContext": [
		65636,
		9
	],
	"./contexts/SeatAreaContext.tsx": [
		65636,
		9
	],
	"./contexts/TableInfoContext": [
		71128,
		9
	],
	"./contexts/TableInfoContext.tsx": [
		71128,
		9
	],
	"./contexts/VideoContext": [
		66483,
		9
	],
	"./contexts/VideoContext.tsx": [
		66483,
		9
	],
	"./contexts/WebSocketContext": [
		4519,
		9
	],
	"./contexts/WebSocketContext.tsx": [
		4519,
		9
	],
	"./epics/roadmapEpic": [
		24901,
		9
	],
	"./epics/roadmapEpic.ts": [
		24901,
		9
	],
	"./hooks/storage/useCookie": [
		81646,
		9,
		81646
	],
	"./hooks/storage/useCookie.ts": [
		81646,
		9,
		81646
	],
	"./hooks/storage/useIndexedDb": [
		73489,
		9,
		73489
	],
	"./hooks/storage/useIndexedDb.ts": [
		73489,
		9,
		73489
	],
	"./hooks/storage/useLocalStorage": [
		29800,
		9
	],
	"./hooks/storage/useLocalStorage.ts": [
		29800,
		9
	],
	"./hooks/storage/useSession": [
		38550,
		9
	],
	"./hooks/storage/useSession.ts": [
		38550,
		9
	],
	"./hooks/useAudioPlay": [
		6420,
		9
	],
	"./hooks/useAudioPlay.ts": [
		6420,
		9
	],
	"./hooks/useBalance": [
		7768,
		9
	],
	"./hooks/useBalance.ts": [
		7768,
		9
	],
	"./hooks/useBenchmark": [
		58486,
		9
	],
	"./hooks/useBenchmark.ts": [
		58486,
		9
	],
	"./hooks/useBetChip": [
		14713,
		9
	],
	"./hooks/useBetChip.ts": [
		14713,
		9
	],
	"./hooks/useBetSource": [
		41238,
		9
	],
	"./hooks/useBetSource.ts": [
		41238,
		9
	],
	"./hooks/useClientIp": [
		8956,
		9
	],
	"./hooks/useClientIp.ts": [
		8956,
		9
	],
	"./hooks/useConfig": [
		55192,
		9
	],
	"./hooks/useConfig.ts": [
		55192,
		9
	],
	"./hooks/useCurrentTime": [
		83364,
		9
	],
	"./hooks/useCurrentTime.ts": [
		83364,
		9
	],
	"./hooks/useDocumentVisible": [
		70217,
		9
	],
	"./hooks/useDocumentVisible.ts": [
		70217,
		9
	],
	"./hooks/useECard": [
		27369,
		9
	],
	"./hooks/useECard.ts": [
		27369,
		9
	],
	"./hooks/useEnterCount": [
		26439,
		9
	],
	"./hooks/useEnterCount.ts": [
		26439,
		9
	],
	"./hooks/useFavorite": [
		26994,
		9
	],
	"./hooks/useFavorite.ts": [
		26994,
		9
	],
	"./hooks/useGameFeature": [
		35600,
		9
	],
	"./hooks/useGameFeature.ts": [
		35600,
		9
	],
	"./hooks/useGlobalData": [
		85233,
		9
	],
	"./hooks/useGlobalData.ts": [
		85233,
		9
	],
	"./hooks/useIframeMessage": [
		52679,
		9
	],
	"./hooks/useIframeMessage.ts": [
		52679,
		9
	],
	"./hooks/useInGamePopup": [
		65909,
		9
	],
	"./hooks/useInGamePopup.ts": [
		65909,
		9
	],
	"./hooks/useLiveGameSocket": [
		83123,
		9
	],
	"./hooks/useLiveGameSocket.ts": [
		83123,
		9
	],
	"./hooks/useLobbyGame": [
		32426,
		9
	],
	"./hooks/useLobbyGame.ts": [
		32426,
		9
	],
	"./hooks/useLogin": [
		73985,
		9
	],
	"./hooks/useLogin.ts": [
		73985,
		9
	],
	"./hooks/useNavigatorOnLine": [
		35038,
		9
	],
	"./hooks/useNavigatorOnLine.ts": [
		35038,
		9
	],
	"./hooks/usePokerScroll": [
		39840,
		9
	],
	"./hooks/usePokerScroll.ts": [
		39840,
		9
	],
	"./hooks/useProgress": [
		82557,
		9
	],
	"./hooks/useProgress.ts": [
		82557,
		9
	],
	"./hooks/useQueryParams": [
		90990,
		9
	],
	"./hooks/useQueryParams.ts": [
		90990,
		9
	],
	"./hooks/useScreenRatio": [
		54115,
		9
	],
	"./hooks/useScreenRatio.ts": [
		54115,
		9
	],
	"./hooks/useSeatArea": [
		65238,
		9
	],
	"./hooks/useSeatArea.ts": [
		65238,
		9
	],
	"./hooks/useSeatBet": [
		46624,
		9
	],
	"./hooks/useSeatBet.ts": [
		46624,
		9
	],
	"./hooks/useStartTime": [
		3113,
		9
	],
	"./hooks/useStartTime.ts": [
		3113,
		9
	],
	"./hooks/useTableInfo": [
		77388,
		9
	],
	"./hooks/useTableInfo.ts": [
		77388,
		9
	],
	"./hooks/useTotalBet": [
		65019,
		9
	],
	"./hooks/useTotalBet.ts": [
		65019,
		9
	],
	"./hooks/useUserAgent": [
		11224,
		9
	],
	"./hooks/useUserAgent.ts": [
		11224,
		9
	],
	"./hooks/useVersion": [
		90228,
		9
	],
	"./hooks/useVersion.ts": [
		90228,
		9
	],
	"./hooks/useVideoPlayer": [
		15534,
		9
	],
	"./hooks/useVideoPlayer.ts": [
		15534,
		9
	],
	"./hooks/useVideoZoom": [
		5012,
		9
	],
	"./hooks/useVideoZoom.ts": [
		5012,
		9
	],
	"./index": [
		81418,
		9
	],
	"./index.scss": [
		19659,
		9
	],
	"./index.tsx": [
		81418,
		9
	],
	"./models/BetSource": [
		79259,
		9
	],
	"./models/BetSource.ts": [
		79259,
		9
	],
	"./models/GameCategory": [
		26179,
		9
	],
	"./models/GameCategory.ts": [
		26179,
		9
	],
	"./models/Hall": [
		73090,
		9,
		73090
	],
	"./models/Hall.ts": [
		73090,
		9,
		73090
	],
	"./models/LobbyType": [
		52737,
		9
	],
	"./models/LobbyType.ts": [
		52737,
		9
	],
	"./models/Locale": [
		71587,
		9
	],
	"./models/Locale.ts": [
		71587,
		9
	],
	"./models/Music": [
		25850,
		9,
		25850
	],
	"./models/Music.ts": [
		25850,
		9,
		25850
	],
	"./models/Popup": [
		41035,
		9
	],
	"./models/Popup.ts": [
		41035,
		9
	],
	"./models/Rating": [
		69100,
		9
	],
	"./models/Rating.ts": [
		69100,
		9
	],
	"./models/Roadmap": [
		39129,
		9
	],
	"./models/Roadmap.ts": [
		39129,
		9
	],
	"./models/Route": [
		11236,
		9
	],
	"./models/Route.ts": [
		11236,
		9
	],
	"./models/SyncData": [
		82042,
		9
	],
	"./models/SyncData.ts": [
		82042,
		9
	],
	"./models/TableMode": [
		28686,
		9
	],
	"./models/TableMode.ts": [
		28686,
		9
	],
	"./models/Video": [
		474,
		9,
		474
	],
	"./models/Video.ts": [
		474,
		9,
		474
	],
	"./models/Voice": [
		17859,
		9
	],
	"./models/Voice.ts": [
		17859,
		9
	],
	"./models/cmd": [
		35058,
		9
	],
	"./models/cmd/": [
		35058,
		9
	],
	"./models/cmd/BitArray": [
		10596,
		9
	],
	"./models/cmd/BitArray.ts": [
		10596,
		9
	],
	"./models/cmd/ByteArray": [
		14173,
		9
	],
	"./models/cmd/ByteArray.ts": [
		14173,
		9
	],
	"./models/cmd/handler": [
		29793,
		9
	],
	"./models/cmd/handler/": [
		29793,
		9
	],
	"./models/cmd/handler/AbstractHandler": [
		107,
		9
	],
	"./models/cmd/handler/AbstractHandler.ts": [
		107,
		9
	],
	"./models/cmd/handler/CMDScAckHandler": [
		73952,
		9
	],
	"./models/cmd/handler/CMDScAckHandler.ts": [
		73952,
		9
	],
	"./models/cmd/handler/CMDScAnchorLoginHandler": [
		23021,
		9
	],
	"./models/cmd/handler/CMDScAnchorLoginHandler.ts": [
		23021,
		9
	],
	"./models/cmd/handler/CMDScGameRestHandler": [
		59815,
		9
	],
	"./models/cmd/handler/CMDScGameRestHandler.ts": [
		59815,
		9
	],
	"./models/cmd/handler/CMDScGameResultHandler": [
		38438,
		9
	],
	"./models/cmd/handler/CMDScGameResultHandler.ts": [
		38438,
		9
	],
	"./models/cmd/handler/CMDScGameStateHandler": [
		68650,
		9
	],
	"./models/cmd/handler/CMDScGameStateHandler.ts": [
		68650,
		9
	],
	"./models/cmd/handler/CMDScInitAndarBaharHandler": [
		18851,
		9
	],
	"./models/cmd/handler/CMDScInitAndarBaharHandler.ts": [
		18851,
		9
	],
	"./models/cmd/handler/CMDScInitBaccaratHandler": [
		61662,
		9
	],
	"./models/cmd/handler/CMDScInitBaccaratHandler.ts": [
		61662,
		9
	],
	"./models/cmd/handler/CMDScInitBlackjackHandler": [
		50913,
		9
	],
	"./models/cmd/handler/CMDScInitBlackjackHandler.ts": [
		50913,
		9
	],
	"./models/cmd/handler/CMDScInitDragontigerHandler": [
		50819,
		9
	],
	"./models/cmd/handler/CMDScInitDragontigerHandler.ts": [
		50819,
		9
	],
	"./models/cmd/handler/CMDScInitPokDengHandler": [
		28939,
		9
	],
	"./models/cmd/handler/CMDScInitPokDengHandler.ts": [
		28939,
		9
	],
	"./models/cmd/handler/CMDScInitRoomHandler": [
		24388,
		9
	],
	"./models/cmd/handler/CMDScInitRoomHandler.ts": [
		24388,
		9
	],
	"./models/cmd/handler/CMDScInitRouletteHandler": [
		70261,
		9
	],
	"./models/cmd/handler/CMDScInitRouletteHandler.ts": [
		70261,
		9
	],
	"./models/cmd/handler/CMDScInitSedieHandler": [
		13827,
		9
	],
	"./models/cmd/handler/CMDScInitSedieHandler.ts": [
		13827,
		9
	],
	"./models/cmd/handler/CMDScInitSicboHandler": [
		67347,
		9
	],
	"./models/cmd/handler/CMDScInitSicboHandler.ts": [
		67347,
		9
	],
	"./models/cmd/handler/CMDScInitSyncHandler": [
		81084,
		9
	],
	"./models/cmd/handler/CMDScInitSyncHandler.ts": [
		81084,
		9
	],
	"./models/cmd/handler/CMDScInitTeenPattiHandler": [
		18203,
		9
	],
	"./models/cmd/handler/CMDScInitTeenPattiHandler.ts": [
		18203,
		9
	],
	"./models/cmd/handler/CMDScPlayerBetHandler": [
		83115,
		9
	],
	"./models/cmd/handler/CMDScPlayerBetHandler.ts": [
		83115,
		9
	],
	"./models/cmd/handler/CMDScPlayerCountHandler": [
		6923,
		9
	],
	"./models/cmd/handler/CMDScPlayerCountHandler.ts": [
		6923,
		9
	],
	"./models/cmd/handler/CMDScPokerShowHandler": [
		86587,
		9
	],
	"./models/cmd/handler/CMDScPokerShowHandler.ts": [
		86587,
		9
	],
	"./models/cmd/handler/CMDScRemoveSyncHandler": [
		79050,
		9
	],
	"./models/cmd/handler/CMDScRemoveSyncHandler.ts": [
		79050,
		9
	],
	"./models/cmd/handler/CMDScRestartHandler": [
		11978,
		9
	],
	"./models/cmd/handler/CMDScRestartHandler.ts": [
		11978,
		9
	],
	"./models/cmd/handler/CMDScRoomLeftHandler": [
		7057,
		9,
		7057
	],
	"./models/cmd/handler/CMDScRoomLeftHandler.ts": [
		7057,
		9,
		7057
	],
	"./models/cmd/handler/CMDScRoomSeatHandler": [
		12761,
		9
	],
	"./models/cmd/handler/CMDScRoomSeatHandler.ts": [
		12761,
		9
	],
	"./models/cmd/handler/CMDScRoundCancelHandler": [
		66989,
		9
	],
	"./models/cmd/handler/CMDScRoundCancelHandler.ts": [
		66989,
		9
	],
	"./models/cmd/handler/CMDScRoundResetHandler": [
		25466,
		9
	],
	"./models/cmd/handler/CMDScRoundResetHandler.ts": [
		25466,
		9
	],
	"./models/cmd/handler/CMDScShuffleEndHandler": [
		13285,
		9
	],
	"./models/cmd/handler/CMDScShuffleEndHandler.ts": [
		13285,
		9
	],
	"./models/cmd/handler/CMDScShuffleHandler": [
		71412,
		9
	],
	"./models/cmd/handler/CMDScShuffleHandler.ts": [
		71412,
		9
	],
	"./models/cmd/handler/CMDScStartBetHandler": [
		86678,
		9
	],
	"./models/cmd/handler/CMDScStartBetHandler.ts": [
		86678,
		9
	],
	"./models/cmd/handler/CMDScStartGameHandler": [
		92709,
		9
	],
	"./models/cmd/handler/CMDScStartGameHandler.ts": [
		92709,
		9
	],
	"./models/cmd/handler/CMDScSyncDataHandler": [
		83430,
		9
	],
	"./models/cmd/handler/CMDScSyncDataHandler.ts": [
		83430,
		9
	],
	"./models/cmd/handler/CMDScTotalBetAndarBaharHandler": [
		73954,
		9
	],
	"./models/cmd/handler/CMDScTotalBetAndarBaharHandler.ts": [
		73954,
		9
	],
	"./models/cmd/handler/CMDScTotalBetBaccaratHandler": [
		22507,
		9
	],
	"./models/cmd/handler/CMDScTotalBetBaccaratHandler.ts": [
		22507,
		9
	],
	"./models/cmd/handler/CMDScTotalBetBlackjackHandler": [
		66326,
		9
	],
	"./models/cmd/handler/CMDScTotalBetBlackjackHandler.ts": [
		66326,
		9
	],
	"./models/cmd/handler/CMDScTotalBetDragontigerHandler": [
		61964,
		9
	],
	"./models/cmd/handler/CMDScTotalBetDragontigerHandler.ts": [
		61964,
		9
	],
	"./models/cmd/handler/CMDScTotalBetPokdengHandler": [
		26968,
		9
	],
	"./models/cmd/handler/CMDScTotalBetPokdengHandler.ts": [
		26968,
		9
	],
	"./models/cmd/handler/CMDScTotalBetRouletteHandler": [
		19768,
		9
	],
	"./models/cmd/handler/CMDScTotalBetRouletteHandler.ts": [
		19768,
		9
	],
	"./models/cmd/handler/CMDScTotalBetSedieHandler": [
		31968,
		9
	],
	"./models/cmd/handler/CMDScTotalBetSedieHandler.ts": [
		31968,
		9
	],
	"./models/cmd/handler/CMDScTotalBetSicboHandler": [
		86404,
		9
	],
	"./models/cmd/handler/CMDScTotalBetSicboHandler.ts": [
		86404,
		9
	],
	"./models/cmd/handler/CMDScTotalBetTeenPattiHandler": [
		31932,
		9
	],
	"./models/cmd/handler/CMDScTotalBetTeenPattiHandler.ts": [
		31932,
		9
	],
	"./models/cmd/handler/CMDSpAndarBaharStatisticsHandler": [
		55255,
		9
	],
	"./models/cmd/handler/CMDSpAndarBaharStatisticsHandler.ts": [
		55255,
		9
	],
	"./models/cmd/handler/CMDSpBaccaratGoodRoadHandler": [
		45810,
		9
	],
	"./models/cmd/handler/CMDSpBaccaratGoodRoadHandler.ts": [
		45810,
		9
	],
	"./models/cmd/handler/CMDSpBaccaratStatisticsHandler": [
		43806,
		9
	],
	"./models/cmd/handler/CMDSpBaccaratStatisticsHandler.ts": [
		43806,
		9
	],
	"./models/cmd/handler/CMDSpBetLogQueryHandler": [
		82693,
		9
	],
	"./models/cmd/handler/CMDSpBetLogQueryHandler.ts": [
		82693,
		9
	],
	"./models/cmd/handler/CMDSpBetLogQueryTotalHandler": [
		25843,
		9
	],
	"./models/cmd/handler/CMDSpBetLogQueryTotalHandler.ts": [
		25843,
		9
	],
	"./models/cmd/handler/CMDSpBetResultHandler": [
		65248,
		9
	],
	"./models/cmd/handler/CMDSpBetResultHandler.ts": [
		65248,
		9
	],
	"./models/cmd/handler/CMDSpBetWinHandler": [
		14749,
		9
	],
	"./models/cmd/handler/CMDSpBetWinHandler.ts": [
		14749,
		9
	],
	"./models/cmd/handler/CMDSpChangePasswordReturnHandler": [
		65241,
		9
	],
	"./models/cmd/handler/CMDSpChangePasswordReturnHandler.ts": [
		65241,
		9
	],
	"./models/cmd/handler/CMDSpDragontigerStatisticsHandler": [
		32873,
		9
	],
	"./models/cmd/handler/CMDSpDragontigerStatisticsHandler.ts": [
		32873,
		9
	],
	"./models/cmd/handler/CMDSpForceStandHandler": [
		78919,
		9
	],
	"./models/cmd/handler/CMDSpForceStandHandler.ts": [
		78919,
		9
	],
	"./models/cmd/handler/CMDSpGiftSettingHandler": [
		32104,
		9
	],
	"./models/cmd/handler/CMDSpGiftSettingHandler.ts": [
		32104,
		9
	],
	"./models/cmd/handler/CMDSpHostListHandler": [
		46362,
		9
	],
	"./models/cmd/handler/CMDSpHostListHandler.ts": [
		46362,
		9
	],
	"./models/cmd/handler/CMDSpInitBetHandler": [
		75445,
		9
	],
	"./models/cmd/handler/CMDSpInitBetHandler.ts": [
		75445,
		9
	],
	"./models/cmd/handler/CMDSpInitMaxBetHandler": [
		69433,
		9
	],
	"./models/cmd/handler/CMDSpInitMaxBetHandler.ts": [
		69433,
		9
	],
	"./models/cmd/handler/CMDSpKeyRefreshHandler": [
		12450,
		9
	],
	"./models/cmd/handler/CMDSpKeyRefreshHandler.ts": [
		12450,
		9
	],
	"./models/cmd/handler/CMDSpLimitRedUpdateHandler": [
		48917,
		9
	],
	"./models/cmd/handler/CMDSpLimitRedUpdateHandler.ts": [
		48917,
		9
	],
	"./models/cmd/handler/CMDSpLivePlayerCountHandler": [
		23248,
		9
	],
	"./models/cmd/handler/CMDSpLivePlayerCountHandler.ts": [
		23248,
		9
	],
	"./models/cmd/handler/CMDSpLoginHandler": [
		3481,
		9
	],
	"./models/cmd/handler/CMDSpLoginHandler.ts": [
		3481,
		9
	],
	"./models/cmd/handler/CMDSpPlayerReportHandler": [
		85441,
		9
	],
	"./models/cmd/handler/CMDSpPlayerReportHandler.ts": [
		85441,
		9
	],
	"./models/cmd/handler/CMDSpPokDengStatisticsHandler": [
		39389,
		9
	],
	"./models/cmd/handler/CMDSpPokDengStatisticsHandler.ts": [
		39389,
		9
	],
	"./models/cmd/handler/CMDSpResultHandler": [
		59679,
		9
	],
	"./models/cmd/handler/CMDSpResultHandler.ts": [
		59679,
		9
	],
	"./models/cmd/handler/CMDSpRoomBetHandler": [
		82912,
		9
	],
	"./models/cmd/handler/CMDSpRoomBetHandler.ts": [
		82912,
		9
	],
	"./models/cmd/handler/CMDSpRouletteStatisticsHandler": [
		52629,
		9
	],
	"./models/cmd/handler/CMDSpRouletteStatisticsHandler.ts": [
		52629,
		9
	],
	"./models/cmd/handler/CMDSpRuleChangeHandler": [
		55214,
		9
	],
	"./models/cmd/handler/CMDSpRuleChangeHandler.ts": [
		55214,
		9
	],
	"./models/cmd/handler/CMDSpSedieStatisticsHandler": [
		49349,
		9
	],
	"./models/cmd/handler/CMDSpSedieStatisticsHandler.ts": [
		49349,
		9
	],
	"./models/cmd/handler/CMDSpServerResetHandler": [
		8716,
		9
	],
	"./models/cmd/handler/CMDSpServerResetHandler.ts": [
		8716,
		9
	],
	"./models/cmd/handler/CMDSpSicboStatisticsHandler": [
		32545,
		9
	],
	"./models/cmd/handler/CMDSpSicboStatisticsHandler.ts": [
		32545,
		9
	],
	"./models/cmd/handler/CMDSpTeenPattiStatisticsHandler": [
		11089,
		9
	],
	"./models/cmd/handler/CMDSpTeenPattiStatisticsHandler.ts": [
		11089,
		9
	],
	"./models/cmd/handler/LoginFailHandler": [
		31358,
		9
	],
	"./models/cmd/handler/LoginFailHandler.ts": [
		31358,
		9
	],
	"./models/cmd/handler/NotImplementHandler": [
		72047,
		9
	],
	"./models/cmd/handler/NotImplementHandler.ts": [
		72047,
		9
	],
	"./models/cmd/handler/ObsoleteHandler": [
		5724,
		9
	],
	"./models/cmd/handler/ObsoleteHandler.ts": [
		5724,
		9
	],
	"./models/cmd/handler/index": [
		29793,
		9
	],
	"./models/cmd/handler/index.ts": [
		29793,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionEventHandler": [
		81213,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionEventHandler.ts": [
		81213,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionRankingHandler": [
		92923,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionRankingHandler.ts": [
		92923,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionRedeemLogHandler": [
		17087,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionRedeemLogHandler.ts": [
		17087,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionStateHandler": [
		11986,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpPromotionStateHandler.ts": [
		11986,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpRedeemResultHandler": [
		99535,
		9
	],
	"./models/cmd/handler/promotiontool/CMDSpRedeemResultHandler.ts": [
		99535,
		9
	],
	"./models/cmd/index": [
		35058,
		9
	],
	"./models/cmd/index.ts": [
		35058,
		9
	],
	"./models/cmd/live": [
		72669,
		9
	],
	"./models/cmd/live/": [
		72669,
		9
	],
	"./models/cmd/live/CMDAndarBahar": [
		68683,
		9
	],
	"./models/cmd/live/CMDAndarBahar.ts": [
		68683,
		9
	],
	"./models/cmd/live/CMDAndarBaharStatistics": [
		88540,
		9
	],
	"./models/cmd/live/CMDAndarBaharStatistics.ts": [
		88540,
		9
	],
	"./models/cmd/live/CMDBaccarat": [
		88200,
		9
	],
	"./models/cmd/live/CMDBaccarat.ts": [
		88200,
		9
	],
	"./models/cmd/live/CMDBaccaratSqueezeCountDown": [
		84507,
		9
	],
	"./models/cmd/live/CMDBaccaratSqueezeCountDown.ts": [
		84507,
		9
	],
	"./models/cmd/live/CMDBaccaratStatistics": [
		74359,
		9
	],
	"./models/cmd/live/CMDBaccaratStatistics.ts": [
		74359,
		9
	],
	"./models/cmd/live/CMDBallStatistics": [
		97611,
		9
	],
	"./models/cmd/live/CMDBallStatistics.ts": [
		97611,
		9
	],
	"./models/cmd/live/CMDBaseInformation": [
		85012,
		9
	],
	"./models/cmd/live/CMDBaseInformation.ts": [
		85012,
		9
	],
	"./models/cmd/live/CMDBaseResult": [
		66397,
		9
	],
	"./models/cmd/live/CMDBaseResult.ts": [
		66397,
		9
	],
	"./models/cmd/live/CMDBaseStatistics": [
		34411,
		9
	],
	"./models/cmd/live/CMDBaseStatistics.ts": [
		34411,
		9
	],
	"./models/cmd/live/CMDBet": [
		10790,
		9
	],
	"./models/cmd/live/CMDBet.ts": [
		10790,
		9
	],
	"./models/cmd/live/CMDBetLog": [
		34934,
		9
	],
	"./models/cmd/live/CMDBetLog.ts": [
		34934,
		9
	],
	"./models/cmd/live/CMDBetLogFail": [
		80498,
		9
	],
	"./models/cmd/live/CMDBetLogFail.ts": [
		80498,
		9
	],
	"./models/cmd/live/CMDBetLogFailSummary": [
		70124,
		9
	],
	"./models/cmd/live/CMDBetLogFailSummary.ts": [
		70124,
		9
	],
	"./models/cmd/live/CMDBetLogSummary": [
		83584,
		9
	],
	"./models/cmd/live/CMDBetLogSummary.ts": [
		83584,
		9
	],
	"./models/cmd/live/CMDBetRule": [
		97320,
		9
	],
	"./models/cmd/live/CMDBetRule.ts": [
		97320,
		9
	],
	"./models/cmd/live/CMDBetRuleByGameType": [
		23771,
		9
	],
	"./models/cmd/live/CMDBetRuleByGameType.ts": [
		23771,
		9
	],
	"./models/cmd/live/CMDBetSummary": [
		72336,
		9
	],
	"./models/cmd/live/CMDBetSummary.ts": [
		72336,
		9
	],
	"./models/cmd/live/CMDBetTypeMaxBet": [
		27455,
		9
	],
	"./models/cmd/live/CMDBetTypeMaxBet.ts": [
		27455,
		9
	],
	"./models/cmd/live/CMDBlackjack": [
		81293,
		9
	],
	"./models/cmd/live/CMDBlackjack.ts": [
		81293,
		9
	],
	"./models/cmd/live/CMDBlackjackCountDown": [
		64102,
		9
	],
	"./models/cmd/live/CMDBlackjackCountDown.ts": [
		64102,
		9
	],
	"./models/cmd/live/CMDCarnivaltreasure": [
		27406,
		9
	],
	"./models/cmd/live/CMDCarnivaltreasure.ts": [
		27406,
		9
	],
	"./models/cmd/live/CMDCarnivaltreasureStatistics": [
		76565,
		9
	],
	"./models/cmd/live/CMDCarnivaltreasureStatistics.ts": [
		76565,
		9
	],
	"./models/cmd/live/CMDConfirmedBet": [
		68025,
		9
	],
	"./models/cmd/live/CMDConfirmedBet.ts": [
		68025,
		9
	],
	"./models/cmd/live/CMDCsAck": [
		11298,
		9
	],
	"./models/cmd/live/CMDCsAck.ts": [
		11298,
		9
	],
	"./models/cmd/live/CMDCsReportAgent": [
		52372,
		9
	],
	"./models/cmd/live/CMDCsReportAgent.ts": [
		52372,
		9
	],
	"./models/cmd/live/CMDCsRequestServer": [
		20329,
		9
	],
	"./models/cmd/live/CMDCsRequestServer.ts": [
		20329,
		9
	],
	"./models/cmd/live/CMDCurrency": [
		5930,
		9
	],
	"./models/cmd/live/CMDCurrency.ts": [
		5930,
		9
	],
	"./models/cmd/live/CMDDealer": [
		94336,
		9
	],
	"./models/cmd/live/CMDDealer.ts": [
		94336,
		9
	],
	"./models/cmd/live/CMDDragontiger": [
		43179,
		9
	],
	"./models/cmd/live/CMDDragontiger.ts": [
		43179,
		9
	],
	"./models/cmd/live/CMDDragontigerStatistics": [
		83804,
		9
	],
	"./models/cmd/live/CMDDragontigerStatistics.ts": [
		83804,
		9
	],
	"./models/cmd/live/CMDEgameConfig": [
		72902,
		9
	],
	"./models/cmd/live/CMDEgameConfig.ts": [
		72902,
		9
	],
	"./models/cmd/live/CMDFantan": [
		44721,
		9
	],
	"./models/cmd/live/CMDFantan.ts": [
		44721,
		9
	],
	"./models/cmd/live/CMDFantanStatistics": [
		98098,
		9
	],
	"./models/cmd/live/CMDFantanStatistics.ts": [
		98098,
		9
	],
	"./models/cmd/live/CMDField": [
		64341,
		9
	],
	"./models/cmd/live/CMDField.ts": [
		64341,
		9
	],
	"./models/cmd/live/CMDGift": [
		18599,
		9
	],
	"./models/cmd/live/CMDGift.ts": [
		18599,
		9
	],
	"./models/cmd/live/CMDHost": [
		74947,
		9
	],
	"./models/cmd/live/CMDHost.ts": [
		74947,
		9
	],
	"./models/cmd/live/CMDHostPlayer": [
		29098,
		9
	],
	"./models/cmd/live/CMDHostPlayer.ts": [
		29098,
		9
	],
	"./models/cmd/live/CMDHostWithSetting": [
		34091,
		9
	],
	"./models/cmd/live/CMDHostWithSetting.ts": [
		34091,
		9
	],
	"./models/cmd/live/CMDHsFantanResult": [
		7625,
		9
	],
	"./models/cmd/live/CMDHsFantanResult.ts": [
		7625,
		9
	],
	"./models/cmd/live/CMDHsPokerDrawByIndex": [
		31194,
		9
	],
	"./models/cmd/live/CMDHsPokerDrawByIndex.ts": [
		31194,
		9
	],
	"./models/cmd/live/CMDHsRouletteResult": [
		25333,
		9
	],
	"./models/cmd/live/CMDHsRouletteResult.ts": [
		25333,
		9
	],
	"./models/cmd/live/CMDHsSicboResult": [
		30813,
		9
	],
	"./models/cmd/live/CMDHsSicboResult.ts": [
		30813,
		9
	],
	"./models/cmd/live/CMDHsThaihiloResult": [
		42525,
		9
	],
	"./models/cmd/live/CMDHsThaihiloResult.ts": [
		42525,
		9
	],
	"./models/cmd/live/CMDInitBet": [
		86656,
		9
	],
	"./models/cmd/live/CMDInitBet.ts": [
		86656,
		9
	],
	"./models/cmd/live/CMDJackpot": [
		50579,
		9
	],
	"./models/cmd/live/CMDJackpot.ts": [
		50579,
		9
	],
	"./models/cmd/live/CMDLiveBaccaratData": [
		36818,
		9
	],
	"./models/cmd/live/CMDLiveBaccaratData.ts": [
		36818,
		9
	],
	"./models/cmd/live/CMDLiveGameConfig": [
		58671,
		9
	],
	"./models/cmd/live/CMDLiveGameConfig.ts": [
		58671,
		9
	],
	"./models/cmd/live/CMDLivePokdengData": [
		96585,
		9
	],
	"./models/cmd/live/CMDLivePokdengData.ts": [
		96585,
		9
	],
	"./models/cmd/live/CMDLottery": [
		64744,
		9
	],
	"./models/cmd/live/CMDLottery.ts": [
		64744,
		9
	],
	"./models/cmd/live/CMDLotteryResult": [
		45457,
		9
	],
	"./models/cmd/live/CMDLotteryResult.ts": [
		45457,
		9
	],
	"./models/cmd/live/CMDLotteryTicket": [
		32736,
		9
	],
	"./models/cmd/live/CMDLotteryTicket.ts": [
		32736,
		9
	],
	"./models/cmd/live/CMDOdd": [
		95900,
		9
	],
	"./models/cmd/live/CMDOdd.ts": [
		95900,
		9
	],
	"./models/cmd/live/CMDPartnerCompany": [
		4608,
		9
	],
	"./models/cmd/live/CMDPartnerCompany.ts": [
		4608,
		9
	],
	"./models/cmd/live/CMDPokdeng": [
		74035,
		9
	],
	"./models/cmd/live/CMDPokdeng.ts": [
		74035,
		9
	],
	"./models/cmd/live/CMDPokdengStatistics": [
		55684,
		9
	],
	"./models/cmd/live/CMDPokdengStatistics.ts": [
		55684,
		9
	],
	"./models/cmd/live/CMDPromotionPrize": [
		75250,
		9
	],
	"./models/cmd/live/CMDPromotionPrize.ts": [
		75250,
		9
	],
	"./models/cmd/live/CMDPromotionRank": [
		722,
		9
	],
	"./models/cmd/live/CMDPromotionRank.ts": [
		722,
		9
	],
	"./models/cmd/live/CMDPsBet": [
		31921,
		9
	],
	"./models/cmd/live/CMDPsBet.ts": [
		31921,
		9
	],
	"./models/cmd/live/CMDPsBetLogFailQuery": [
		14471,
		9
	],
	"./models/cmd/live/CMDPsBetLogFailQuery.ts": [
		14471,
		9
	],
	"./models/cmd/live/CMDPsBetLogFailSummaryQuery": [
		30059,
		9
	],
	"./models/cmd/live/CMDPsBetLogFailSummaryQuery.ts": [
		30059,
		9
	],
	"./models/cmd/live/CMDPsBetLogQuery": [
		15623,
		9
	],
	"./models/cmd/live/CMDPsBetLogQuery.ts": [
		15623,
		9
	],
	"./models/cmd/live/CMDPsBetLogSummaryQuery": [
		17675,
		9
	],
	"./models/cmd/live/CMDPsBetLogSummaryQuery.ts": [
		17675,
		9
	],
	"./models/cmd/live/CMDPsChangePassword": [
		77533,
		9
	],
	"./models/cmd/live/CMDPsChangePassword.ts": [
		77533,
		9
	],
	"./models/cmd/live/CMDPsChatroomAuth": [
		77887,
		9
	],
	"./models/cmd/live/CMDPsChatroomAuth.ts": [
		77887,
		9
	],
	"./models/cmd/live/CMDPsDealerTips": [
		6883,
		9
	],
	"./models/cmd/live/CMDPsDealerTips.ts": [
		6883,
		9
	],
	"./models/cmd/live/CMDPsDisconnect": [
		33310,
		9
	],
	"./models/cmd/live/CMDPsDisconnect.ts": [
		33310,
		9
	],
	"./models/cmd/live/CMDPsEgameDebugJackpot": [
		99712,
		9
	],
	"./models/cmd/live/CMDPsEgameDebugJackpot.ts": [
		99712,
		9
	],
	"./models/cmd/live/CMDPsEgameLogin": [
		20858,
		9
	],
	"./models/cmd/live/CMDPsEgameLogin.ts": [
		20858,
		9
	],
	"./models/cmd/live/CMDPsLogin": [
		94431,
		9
	],
	"./models/cmd/live/CMDPsLogin.ts": [
		94431,
		9
	],
	"./models/cmd/live/CMDPsLoginLaucherTime": [
		22264,
		9
	],
	"./models/cmd/live/CMDPsLoginLaucherTime.ts": [
		22264,
		9
	],
	"./models/cmd/live/CMDPsLottery": [
		78835,
		9
	],
	"./models/cmd/live/CMDPsLottery.ts": [
		78835,
		9
	],
	"./models/cmd/live/CMDPsLotteryOldResult": [
		81895,
		9
	],
	"./models/cmd/live/CMDPsLotteryOldResult.ts": [
		81895,
		9
	],
	"./models/cmd/live/CMDPsLotteryStatistics": [
		83460,
		9
	],
	"./models/cmd/live/CMDPsLotteryStatistics.ts": [
		83460,
		9
	],
	"./models/cmd/live/CMDPsLotteryTicketDetail": [
		39446,
		9
	],
	"./models/cmd/live/CMDPsLotteryTicketDetail.ts": [
		39446,
		9
	],
	"./models/cmd/live/CMDPsMakeDecision": [
		94216,
		9
	],
	"./models/cmd/live/CMDPsMakeDecision.ts": [
		94216,
		9
	],
	"./models/cmd/live/CMDPsMinigameAction": [
		93223,
		9
	],
	"./models/cmd/live/CMDPsMinigameAction.ts": [
		93223,
		9
	],
	"./models/cmd/live/CMDPsMinigameActionDone": [
		20351,
		9
	],
	"./models/cmd/live/CMDPsMinigameActionDone.ts": [
		20351,
		9
	],
	"./models/cmd/live/CMDPsNbsBet": [
		75616,
		9
	],
	"./models/cmd/live/CMDPsNbsBet.ts": [
		75616,
		9
	],
	"./models/cmd/live/CMDPsPlayerPattern": [
		38199,
		9
	],
	"./models/cmd/live/CMDPsPlayerPattern.ts": [
		38199,
		9
	],
	"./models/cmd/live/CMDPsPlayerRecentlyPlay": [
		92867,
		9
	],
	"./models/cmd/live/CMDPsPlayerRecentlyPlay.ts": [
		92867,
		9
	],
	"./models/cmd/live/CMDPsPlayerReport": [
		6935,
		9
	],
	"./models/cmd/live/CMDPsPlayerReport.ts": [
		6935,
		9
	],
	"./models/cmd/live/CMDPsPrizeRedeem": [
		80038,
		9
	],
	"./models/cmd/live/CMDPsPrizeRedeem.ts": [
		80038,
		9
	],
	"./models/cmd/live/CMDPsQueryPatternExisted": [
		70134,
		9
	],
	"./models/cmd/live/CMDPsQueryPatternExisted.ts": [
		70134,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionPoint": [
		56235,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionPoint.ts": [
		56235,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionRanking": [
		60103,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionRanking.ts": [
		60103,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionRedeemLog": [
		35291,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionRedeemLog.ts": [
		35291,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionState": [
		79384,
		9
	],
	"./models/cmd/live/CMDPsQueryPromotionState.ts": [
		79384,
		9
	],
	"./models/cmd/live/CMDPsRequestAutoBetToken": [
		63588,
		9
	],
	"./models/cmd/live/CMDPsRequestAutoBetToken.ts": [
		63588,
		9
	],
	"./models/cmd/live/CMDPsRequestChatroom": [
		82114,
		9
	],
	"./models/cmd/live/CMDPsRequestChatroom.ts": [
		82114,
		9
	],
	"./models/cmd/live/CMDPsRequestInitClient": [
		2546,
		9
	],
	"./models/cmd/live/CMDPsRequestInitClient.ts": [
		2546,
		9
	],
	"./models/cmd/live/CMDPsRequestLoginToken": [
		68961,
		9
	],
	"./models/cmd/live/CMDPsRequestLoginToken.ts": [
		68961,
		9
	],
	"./models/cmd/live/CMDPsRequestTicketResult": [
		50770,
		9
	],
	"./models/cmd/live/CMDPsRequestTicketResult.ts": [
		50770,
		9
	],
	"./models/cmd/live/CMDPsRequestVideoToken": [
		15371,
		9
	],
	"./models/cmd/live/CMDPsRequestVideoToken.ts": [
		15371,
		9
	],
	"./models/cmd/live/CMDPsRoomSeat": [
		32234,
		9
	],
	"./models/cmd/live/CMDPsRoomSeat.ts": [
		32234,
		9
	],
	"./models/cmd/live/CMDPsRuleChange": [
		62730,
		9
	],
	"./models/cmd/live/CMDPsRuleChange.ts": [
		62730,
		9
	],
	"./models/cmd/live/CMDPsSetLimitRedToken": [
		72911,
		9
	],
	"./models/cmd/live/CMDPsSetLimitRedToken.ts": [
		72911,
		9
	],
	"./models/cmd/live/CMDPsSetPrefs": [
		60682,
		9
	],
	"./models/cmd/live/CMDPsSetPrefs.ts": [
		60682,
		9
	],
	"./models/cmd/live/CMDPsStandUp": [
		5411,
		9
	],
	"./models/cmd/live/CMDPsStandUp.ts": [
		5411,
		9
	],
	"./models/cmd/live/CMDPsSuspendPromotionPopup": [
		75759,
		9
	],
	"./models/cmd/live/CMDPsSuspendPromotionPopup.ts": [
		75759,
		9
	],
	"./models/cmd/live/CMDPsTableEnter": [
		93542,
		9
	],
	"./models/cmd/live/CMDPsTableEnter.ts": [
		93542,
		9
	],
	"./models/cmd/live/CMDPsTokenUpdate": [
		50230,
		9
	],
	"./models/cmd/live/CMDPsTokenUpdate.ts": [
		50230,
		9
	],
	"./models/cmd/live/CMDRedeemRecord": [
		51592,
		9
	],
	"./models/cmd/live/CMDRedeemRecord.ts": [
		51592,
		9
	],
	"./models/cmd/live/CMDRoom": [
		41410,
		9
	],
	"./models/cmd/live/CMDRoom.ts": [
		41410,
		9
	],
	"./models/cmd/live/CMDRoulette": [
		35369,
		9
	],
	"./models/cmd/live/CMDRoulette.ts": [
		35369,
		9
	],
	"./models/cmd/live/CMDRouletteStatistics": [
		62314,
		9
	],
	"./models/cmd/live/CMDRouletteStatistics.ts": [
		62314,
		9
	],
	"./models/cmd/live/CMDScAck": [
		74562,
		9
	],
	"./models/cmd/live/CMDScAck.ts": [
		74562,
		9
	],
	"./models/cmd/live/CMDScAnchorLogin": [
		15053,
		9
	],
	"./models/cmd/live/CMDScAnchorLogin.ts": [
		15053,
		9
	],
	"./models/cmd/live/CMDScBlackjackSeatInfo": [
		83766,
		9
	],
	"./models/cmd/live/CMDScBlackjackSeatInfo.ts": [
		83766,
		9
	],
	"./models/cmd/live/CMDScBlackjackUpdateSetting": [
		39180,
		9
	],
	"./models/cmd/live/CMDScBlackjackUpdateSetting.ts": [
		39180,
		9
	],
	"./models/cmd/live/CMDScGameRest": [
		31987,
		9
	],
	"./models/cmd/live/CMDScGameRest.ts": [
		31987,
		9
	],
	"./models/cmd/live/CMDScGameResult": [
		6108,
		9
	],
	"./models/cmd/live/CMDScGameResult.ts": [
		6108,
		9
	],
	"./models/cmd/live/CMDScGameState": [
		56712,
		9
	],
	"./models/cmd/live/CMDScGameState.ts": [
		56712,
		9
	],
	"./models/cmd/live/CMDScInitAndarBahar": [
		14895,
		9
	],
	"./models/cmd/live/CMDScInitAndarBahar.ts": [
		14895,
		9
	],
	"./models/cmd/live/CMDScInitBaccarat": [
		3028,
		9
	],
	"./models/cmd/live/CMDScInitBaccarat.ts": [
		3028,
		9
	],
	"./models/cmd/live/CMDScInitBaccaratSqueeze": [
		57366,
		9
	],
	"./models/cmd/live/CMDScInitBaccaratSqueeze.ts": [
		57366,
		9
	],
	"./models/cmd/live/CMDScInitBlackjack": [
		52913,
		9
	],
	"./models/cmd/live/CMDScInitBlackjack.ts": [
		52913,
		9
	],
	"./models/cmd/live/CMDScInitCarnivaltreasure": [
		5466,
		9
	],
	"./models/cmd/live/CMDScInitCarnivaltreasure.ts": [
		5466,
		9
	],
	"./models/cmd/live/CMDScInitDragontiger": [
		34879,
		9
	],
	"./models/cmd/live/CMDScInitDragontiger.ts": [
		34879,
		9
	],
	"./models/cmd/live/CMDScInitFantan": [
		73893,
		9
	],
	"./models/cmd/live/CMDScInitFantan.ts": [
		73893,
		9
	],
	"./models/cmd/live/CMDScInitLottery": [
		17596,
		9
	],
	"./models/cmd/live/CMDScInitLottery.ts": [
		17596,
		9
	],
	"./models/cmd/live/CMDScInitPokdeng": [
		79431,
		9
	],
	"./models/cmd/live/CMDScInitPokdeng.ts": [
		79431,
		9
	],
	"./models/cmd/live/CMDScInitRoom": [
		61646,
		9
	],
	"./models/cmd/live/CMDScInitRoom.ts": [
		61646,
		9
	],
	"./models/cmd/live/CMDScInitRoulette": [
		29621,
		9
	],
	"./models/cmd/live/CMDScInitRoulette.ts": [
		29621,
		9
	],
	"./models/cmd/live/CMDScInitSicbo": [
		90463,
		9
	],
	"./models/cmd/live/CMDScInitSicbo.ts": [
		90463,
		9
	],
	"./models/cmd/live/CMDScInitSync": [
		71638,
		9
	],
	"./models/cmd/live/CMDScInitSync.ts": [
		71638,
		9
	],
	"./models/cmd/live/CMDScInitTeenPatti2020": [
		1151,
		9
	],
	"./models/cmd/live/CMDScInitTeenPatti2020.ts": [
		1151,
		9
	],
	"./models/cmd/live/CMDScInitThaihilo": [
		18489,
		9
	],
	"./models/cmd/live/CMDScInitThaihilo.ts": [
		18489,
		9
	],
	"./models/cmd/live/CMDScInitXocdia": [
		34173,
		9
	],
	"./models/cmd/live/CMDScInitXocdia.ts": [
		34173,
		9
	],
	"./models/cmd/live/CMDScLotteryBallErase": [
		33677,
		9
	],
	"./models/cmd/live/CMDScLotteryBallErase.ts": [
		33677,
		9
	],
	"./models/cmd/live/CMDScLotteryResultRevoke": [
		72225,
		9
	],
	"./models/cmd/live/CMDScLotteryResultRevoke.ts": [
		72225,
		9
	],
	"./models/cmd/live/CMDScLotterySetting": [
		62008,
		9
	],
	"./models/cmd/live/CMDScLotterySetting.ts": [
		62008,
		9
	],
	"./models/cmd/live/CMDScMaintenanceEnd": [
		59463,
		9
	],
	"./models/cmd/live/CMDScMaintenanceEnd.ts": [
		59463,
		9
	],
	"./models/cmd/live/CMDScMaintenanceStart": [
		59122,
		9
	],
	"./models/cmd/live/CMDScMaintenanceStart.ts": [
		59122,
		9
	],
	"./models/cmd/live/CMDScPlayerBet": [
		98255,
		9
	],
	"./models/cmd/live/CMDScPlayerBet.ts": [
		98255,
		9
	],
	"./models/cmd/live/CMDScPlayerCount": [
		56223,
		9
	],
	"./models/cmd/live/CMDScPlayerCount.ts": [
		56223,
		9
	],
	"./models/cmd/live/CMDScPokerShow": [
		57791,
		9
	],
	"./models/cmd/live/CMDScPokerShow.ts": [
		57791,
		9
	],
	"./models/cmd/live/CMDScRemoveSync": [
		93760,
		9
	],
	"./models/cmd/live/CMDScRemoveSync.ts": [
		93760,
		9
	],
	"./models/cmd/live/CMDScReportHostState": [
		40210,
		9
	],
	"./models/cmd/live/CMDScReportHostState.ts": [
		40210,
		9
	],
	"./models/cmd/live/CMDScReportHostTicket": [
		53899,
		9
	],
	"./models/cmd/live/CMDScReportHostTicket.ts": [
		53899,
		9
	],
	"./models/cmd/live/CMDScReportReject": [
		43702,
		9
	],
	"./models/cmd/live/CMDScReportReject.ts": [
		43702,
		9
	],
	"./models/cmd/live/CMDScRequestFail": [
		81134,
		9
	],
	"./models/cmd/live/CMDScRequestFail.ts": [
		81134,
		9
	],
	"./models/cmd/live/CMDScRestart": [
		51808,
		9
	],
	"./models/cmd/live/CMDScRestart.ts": [
		51808,
		9
	],
	"./models/cmd/live/CMDScRoomLeft": [
		92777,
		9
	],
	"./models/cmd/live/CMDScRoomLeft.ts": [
		92777,
		9
	],
	"./models/cmd/live/CMDScRoomSeat": [
		25729,
		9
	],
	"./models/cmd/live/CMDScRoomSeat.ts": [
		25729,
		9
	],
	"./models/cmd/live/CMDScRoundCancel": [
		88005,
		9
	],
	"./models/cmd/live/CMDScRoundCancel.ts": [
		88005,
		9
	],
	"./models/cmd/live/CMDScRoundReset": [
		53896,
		9
	],
	"./models/cmd/live/CMDScRoundReset.ts": [
		53896,
		9
	],
	"./models/cmd/live/CMDScServer": [
		34968,
		9
	],
	"./models/cmd/live/CMDScServer.ts": [
		34968,
		9
	],
	"./models/cmd/live/CMDScShuffle": [
		92598,
		9
	],
	"./models/cmd/live/CMDScShuffle.ts": [
		92598,
		9
	],
	"./models/cmd/live/CMDScShuffleEnd": [
		17645,
		9
	],
	"./models/cmd/live/CMDScShuffleEnd.ts": [
		17645,
		9
	],
	"./models/cmd/live/CMDScSkipSqueezeCountDown": [
		97159,
		9
	],
	"./models/cmd/live/CMDScSkipSqueezeCountDown.ts": [
		97159,
		9
	],
	"./models/cmd/live/CMDScStartBet": [
		8772,
		9
	],
	"./models/cmd/live/CMDScStartBet.ts": [
		8772,
		9
	],
	"./models/cmd/live/CMDScStartGame": [
		18189,
		9
	],
	"./models/cmd/live/CMDScStartGame.ts": [
		18189,
		9
	],
	"./models/cmd/live/CMDScSyncData": [
		58956,
		9
	],
	"./models/cmd/live/CMDScSyncData.ts": [
		58956,
		9
	],
	"./models/cmd/live/CMDScTotalBetAndarBahar": [
		7784,
		9
	],
	"./models/cmd/live/CMDScTotalBetAndarBahar.ts": [
		7784,
		9
	],
	"./models/cmd/live/CMDScTotalBetBaccarat": [
		20863,
		9
	],
	"./models/cmd/live/CMDScTotalBetBaccarat.ts": [
		20863,
		9
	],
	"./models/cmd/live/CMDScTotalBetBlackjack": [
		94324,
		9
	],
	"./models/cmd/live/CMDScTotalBetBlackjack.ts": [
		94324,
		9
	],
	"./models/cmd/live/CMDScTotalBetCarnivaltreasure": [
		37357,
		9
	],
	"./models/cmd/live/CMDScTotalBetCarnivaltreasure.ts": [
		37357,
		9
	],
	"./models/cmd/live/CMDScTotalBetDragontiger": [
		76318,
		9
	],
	"./models/cmd/live/CMDScTotalBetDragontiger.ts": [
		76318,
		9
	],
	"./models/cmd/live/CMDScTotalBetFantan": [
		51298,
		9
	],
	"./models/cmd/live/CMDScTotalBetFantan.ts": [
		51298,
		9
	],
	"./models/cmd/live/CMDScTotalBetPokdeng": [
		4130,
		9
	],
	"./models/cmd/live/CMDScTotalBetPokdeng.ts": [
		4130,
		9
	],
	"./models/cmd/live/CMDScTotalBetRoulette": [
		29114,
		9
	],
	"./models/cmd/live/CMDScTotalBetRoulette.ts": [
		29114,
		9
	],
	"./models/cmd/live/CMDScTotalBetSicbo": [
		82870,
		9
	],
	"./models/cmd/live/CMDScTotalBetSicbo.ts": [
		82870,
		9
	],
	"./models/cmd/live/CMDScTotalBetTeenPatti2020": [
		10886,
		9
	],
	"./models/cmd/live/CMDScTotalBetTeenPatti2020.ts": [
		10886,
		9
	],
	"./models/cmd/live/CMDScTotalBetThaihilo": [
		68558,
		9
	],
	"./models/cmd/live/CMDScTotalBetThaihilo.ts": [
		68558,
		9
	],
	"./models/cmd/live/CMDScTotalBetXocdia": [
		96650,
		9
	],
	"./models/cmd/live/CMDScTotalBetXocdia.ts": [
		96650,
		9
	],
	"./models/cmd/live/CMDSeatBet": [
		553,
		9
	],
	"./models/cmd/live/CMDSeatBet.ts": [
		553,
		9
	],
	"./models/cmd/live/CMDSicbo": [
		40635,
		9
	],
	"./models/cmd/live/CMDSicbo.ts": [
		40635,
		9
	],
	"./models/cmd/live/CMDSicboStatistics": [
		66284,
		9
	],
	"./models/cmd/live/CMDSicboStatistics.ts": [
		66284,
		9
	],
	"./models/cmd/live/CMDSpActionReject": [
		97763,
		9
	],
	"./models/cmd/live/CMDSpActionReject.ts": [
		97763,
		9
	],
	"./models/cmd/live/CMDSpAndarBaharStatistics": [
		67315,
		9
	],
	"./models/cmd/live/CMDSpAndarBaharStatistics.ts": [
		67315,
		9
	],
	"./models/cmd/live/CMDSpAutoBetToken": [
		20069,
		9
	],
	"./models/cmd/live/CMDSpAutoBetToken.ts": [
		20069,
		9
	],
	"./models/cmd/live/CMDSpBaccaratGoodRoad": [
		67232,
		9
	],
	"./models/cmd/live/CMDSpBaccaratGoodRoad.ts": [
		67232,
		9
	],
	"./models/cmd/live/CMDSpBaccaratStatistics": [
		66828,
		9
	],
	"./models/cmd/live/CMDSpBaccaratStatistics.ts": [
		66828,
		9
	],
	"./models/cmd/live/CMDSpBanSeat": [
		69920,
		9
	],
	"./models/cmd/live/CMDSpBanSeat.ts": [
		69920,
		9
	],
	"./models/cmd/live/CMDSpBetCancel": [
		38305,
		9
	],
	"./models/cmd/live/CMDSpBetCancel.ts": [
		38305,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailQuery": [
		5705,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailQuery.ts": [
		5705,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailQueryTotal": [
		25451,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailQueryTotal.ts": [
		25451,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailSummaryQuery": [
		58913,
		9
	],
	"./models/cmd/live/CMDSpBetLogFailSummaryQuery.ts": [
		58913,
		9
	],
	"./models/cmd/live/CMDSpBetLogQuery": [
		74413,
		9
	],
	"./models/cmd/live/CMDSpBetLogQuery.ts": [
		74413,
		9
	],
	"./models/cmd/live/CMDSpBetLogQueryTotal": [
		15735,
		9
	],
	"./models/cmd/live/CMDSpBetLogQueryTotal.ts": [
		15735,
		9
	],
	"./models/cmd/live/CMDSpBetLogSummaryQuery": [
		79189,
		9
	],
	"./models/cmd/live/CMDSpBetLogSummaryQuery.ts": [
		79189,
		9
	],
	"./models/cmd/live/CMDSpBetResult": [
		55074,
		9
	],
	"./models/cmd/live/CMDSpBetResult.ts": [
		55074,
		9
	],
	"./models/cmd/live/CMDSpBetWin": [
		14213,
		9
	],
	"./models/cmd/live/CMDSpBetWin.ts": [
		14213,
		9
	],
	"./models/cmd/live/CMDSpBetWinDetail": [
		62348,
		9
	],
	"./models/cmd/live/CMDSpBetWinDetail.ts": [
		62348,
		9
	],
	"./models/cmd/live/CMDSpBetWinDetailList": [
		1912,
		9
	],
	"./models/cmd/live/CMDSpBetWinDetailList.ts": [
		1912,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureResult": [
		62200,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureResult.ts": [
		62200,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureStatistics": [
		122,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureStatistics.ts": [
		122,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureTopResultPlayer": [
		1610,
		9
	],
	"./models/cmd/live/CMDSpCarnivaltreasureTopResultPlayer.ts": [
		1610,
		9
	],
	"./models/cmd/live/CMDSpChangePasswordReturn": [
		35177,
		9
	],
	"./models/cmd/live/CMDSpChangePasswordReturn.ts": [
		35177,
		9
	],
	"./models/cmd/live/CMDSpChatroomAuth": [
		85481,
		9
	],
	"./models/cmd/live/CMDSpChatroomAuth.ts": [
		85481,
		9
	],
	"./models/cmd/live/CMDSpChatroomAuthFail": [
		50893,
		9
	],
	"./models/cmd/live/CMDSpChatroomAuthFail.ts": [
		50893,
		9
	],
	"./models/cmd/live/CMDSpChatroomInfo": [
		52291,
		9
	],
	"./models/cmd/live/CMDSpChatroomInfo.ts": [
		52291,
		9
	],
	"./models/cmd/live/CMDSpClientConfig": [
		40683,
		9
	],
	"./models/cmd/live/CMDSpClientConfig.ts": [
		40683,
		9
	],
	"./models/cmd/live/CMDSpDragontigerStatistics": [
		82833,
		9
	],
	"./models/cmd/live/CMDSpDragontigerStatistics.ts": [
		82833,
		9
	],
	"./models/cmd/live/CMDSpDuplicateLogin": [
		31456,
		9
	],
	"./models/cmd/live/CMDSpDuplicateLogin.ts": [
		31456,
		9
	],
	"./models/cmd/live/CMDSpEgameError": [
		79055,
		9
	],
	"./models/cmd/live/CMDSpEgameError.ts": [
		79055,
		9
	],
	"./models/cmd/live/CMDSpFantanStatistics": [
		23789,
		9
	],
	"./models/cmd/live/CMDSpFantanStatistics.ts": [
		23789,
		9
	],
	"./models/cmd/live/CMDSpForceStand": [
		35243,
		9
	],
	"./models/cmd/live/CMDSpForceStand.ts": [
		35243,
		9
	],
	"./models/cmd/live/CMDSpGameResultInvalid": [
		35378,
		9
	],
	"./models/cmd/live/CMDSpGameResultInvalid.ts": [
		35378,
		9
	],
	"./models/cmd/live/CMDSpGiftSetting": [
		36330,
		9
	],
	"./models/cmd/live/CMDSpGiftSetting.ts": [
		36330,
		9
	],
	"./models/cmd/live/CMDSpHostList": [
		81456,
		9
	],
	"./models/cmd/live/CMDSpHostList.ts": [
		81456,
		9
	],
	"./models/cmd/live/CMDSpInitBet": [
		47189,
		9
	],
	"./models/cmd/live/CMDSpInitBet.ts": [
		47189,
		9
	],
	"./models/cmd/live/CMDSpInitEgame": [
		57219,
		9
	],
	"./models/cmd/live/CMDSpInitEgame.ts": [
		57219,
		9
	],
	"./models/cmd/live/CMDSpInitMaxBet": [
		25745,
		9
	],
	"./models/cmd/live/CMDSpInitMaxBet.ts": [
		25745,
		9
	],
	"./models/cmd/live/CMDSpInitNbsBet": [
		45412,
		9
	],
	"./models/cmd/live/CMDSpInitNbsBet.ts": [
		45412,
		9
	],
	"./models/cmd/live/CMDSpKeyRefresh": [
		49416,
		9
	],
	"./models/cmd/live/CMDSpKeyRefresh.ts": [
		49416,
		9
	],
	"./models/cmd/live/CMDSpKickTrialTimeout": [
		65779,
		9
	],
	"./models/cmd/live/CMDSpKickTrialTimeout.ts": [
		65779,
		9
	],
	"./models/cmd/live/CMDSpLimitRedUpdate": [
		86997,
		9
	],
	"./models/cmd/live/CMDSpLimitRedUpdate.ts": [
		86997,
		9
	],
	"./models/cmd/live/CMDSpLivePlayerCount": [
		24394,
		9
	],
	"./models/cmd/live/CMDSpLivePlayerCount.ts": [
		24394,
		9
	],
	"./models/cmd/live/CMDSpLogin": [
		18337,
		9
	],
	"./models/cmd/live/CMDSpLogin.ts": [
		18337,
		9
	],
	"./models/cmd/live/CMDSpLoginFail": [
		10949,
		9
	],
	"./models/cmd/live/CMDSpLoginFail.ts": [
		10949,
		9
	],
	"./models/cmd/live/CMDSpLoginToken": [
		22412,
		9
	],
	"./models/cmd/live/CMDSpLoginToken.ts": [
		22412,
		9
	],
	"./models/cmd/live/CMDSpLotteryFirstPrize": [
		6379,
		9
	],
	"./models/cmd/live/CMDSpLotteryFirstPrize.ts": [
		6379,
		9
	],
	"./models/cmd/live/CMDSpLotteryOldResult": [
		80141,
		9
	],
	"./models/cmd/live/CMDSpLotteryOldResult.ts": [
		80141,
		9
	],
	"./models/cmd/live/CMDSpLotteryStatistics": [
		66058,
		9
	],
	"./models/cmd/live/CMDSpLotteryStatistics.ts": [
		66058,
		9
	],
	"./models/cmd/live/CMDSpLotteryTicketDetail": [
		63780,
		9
	],
	"./models/cmd/live/CMDSpLotteryTicketDetail.ts": [
		63780,
		9
	],
	"./models/cmd/live/CMDSpMakeDecisionFail": [
		95330,
		9
	],
	"./models/cmd/live/CMDSpMakeDecisionFail.ts": [
		95330,
		9
	],
	"./models/cmd/live/CMDSpMergeOdd": [
		68931,
		9
	],
	"./models/cmd/live/CMDSpMergeOdd.ts": [
		68931,
		9
	],
	"./models/cmd/live/CMDSpMinigameAction": [
		82437,
		9
	],
	"./models/cmd/live/CMDSpMinigameAction.ts": [
		82437,
		9
	],
	"./models/cmd/live/CMDSpNbsBetResult": [
		62611,
		9
	],
	"./models/cmd/live/CMDSpNbsBetResult.ts": [
		62611,
		9
	],
	"./models/cmd/live/CMDSpPartnerGame": [
		12068,
		9
	],
	"./models/cmd/live/CMDSpPartnerGame.ts": [
		12068,
		9
	],
	"./models/cmd/live/CMDSpPlayerBeDisabled": [
		62006,
		9
	],
	"./models/cmd/live/CMDSpPlayerBeDisabled.ts": [
		62006,
		9
	],
	"./models/cmd/live/CMDSpPlayerPattern": [
		37529,
		9
	],
	"./models/cmd/live/CMDSpPlayerPattern.ts": [
		37529,
		9
	],
	"./models/cmd/live/CMDSpPlayerRecentlyPlay": [
		30125,
		9
	],
	"./models/cmd/live/CMDSpPlayerRecentlyPlay.ts": [
		30125,
		9
	],
	"./models/cmd/live/CMDSpPlayerReport": [
		52745,
		9
	],
	"./models/cmd/live/CMDSpPlayerReport.ts": [
		52745,
		9
	],
	"./models/cmd/live/CMDSpPokdengStatistics": [
		6909,
		9
	],
	"./models/cmd/live/CMDSpPokdengStatistics.ts": [
		6909,
		9
	],
	"./models/cmd/live/CMDSpPromotionEvent": [
		24713,
		9
	],
	"./models/cmd/live/CMDSpPromotionEvent.ts": [
		24713,
		9
	],
	"./models/cmd/live/CMDSpPromotionRanking": [
		20939,
		9
	],
	"./models/cmd/live/CMDSpPromotionRanking.ts": [
		20939,
		9
	],
	"./models/cmd/live/CMDSpPromotionRedeemLog": [
		21127,
		9
	],
	"./models/cmd/live/CMDSpPromotionRedeemLog.ts": [
		21127,
		9
	],
	"./models/cmd/live/CMDSpPromotionState": [
		64956,
		9
	],
	"./models/cmd/live/CMDSpPromotionState.ts": [
		64956,
		9
	],
	"./models/cmd/live/CMDSpPvpGame": [
		36868,
		9
	],
	"./models/cmd/live/CMDSpPvpGame.ts": [
		36868,
		9
	],
	"./models/cmd/live/CMDSpQueryPatternExisted": [
		96636,
		9
	],
	"./models/cmd/live/CMDSpQueryPatternExisted.ts": [
		96636,
		9
	],
	"./models/cmd/live/CMDSpRedeemResult": [
		37287,
		9
	],
	"./models/cmd/live/CMDSpRedeemResult.ts": [
		37287,
		9
	],
	"./models/cmd/live/CMDSpRequestVideoToken": [
		59197,
		9
	],
	"./models/cmd/live/CMDSpRequestVideoToken.ts": [
		59197,
		9
	],
	"./models/cmd/live/CMDSpRoomBet": [
		46522,
		9
	],
	"./models/cmd/live/CMDSpRoomBet.ts": [
		46522,
		9
	],
	"./models/cmd/live/CMDSpRoomSeat": [
		99692,
		9
	],
	"./models/cmd/live/CMDSpRoomSeat.ts": [
		99692,
		9
	],
	"./models/cmd/live/CMDSpRouletteStatistics": [
		65181,
		9
	],
	"./models/cmd/live/CMDSpRouletteStatistics.ts": [
		65181,
		9
	],
	"./models/cmd/live/CMDSpRuleChange": [
		51484,
		9
	],
	"./models/cmd/live/CMDSpRuleChange.ts": [
		51484,
		9
	],
	"./models/cmd/live/CMDSpSameIpLoginWarning": [
		33010,
		9
	],
	"./models/cmd/live/CMDSpSameIpLoginWarning.ts": [
		33010,
		9
	],
	"./models/cmd/live/CMDSpSendBackLobby": [
		37915,
		9
	],
	"./models/cmd/live/CMDSpSendBackLobby.ts": [
		37915,
		9
	],
	"./models/cmd/live/CMDSpServerReset": [
		46678,
		9
	],
	"./models/cmd/live/CMDSpServerReset.ts": [
		46678,
		9
	],
	"./models/cmd/live/CMDSpSetLimitRedTokenResult": [
		84764,
		9
	],
	"./models/cmd/live/CMDSpSetLimitRedTokenResult.ts": [
		84764,
		9
	],
	"./models/cmd/live/CMDSpSicboStatistics": [
		95641,
		9
	],
	"./models/cmd/live/CMDSpSicboStatistics.ts": [
		95641,
		9
	],
	"./models/cmd/live/CMDSpSlotJackpot": [
		89362,
		9
	],
	"./models/cmd/live/CMDSpSlotJackpot.ts": [
		89362,
		9
	],
	"./models/cmd/live/CMDSpSlotPlayerCount": [
		14276,
		9
	],
	"./models/cmd/live/CMDSpSlotPlayerCount.ts": [
		14276,
		9
	],
	"./models/cmd/live/CMDSpSuspendPromotionPopup": [
		57785,
		9
	],
	"./models/cmd/live/CMDSpSuspendPromotionPopup.ts": [
		57785,
		9
	],
	"./models/cmd/live/CMDSpTableLeft": [
		72769,
		9
	],
	"./models/cmd/live/CMDSpTableLeft.ts": [
		72769,
		9
	],
	"./models/cmd/live/CMDSpTeenPatti2020Statistics": [
		35025,
		9
	],
	"./models/cmd/live/CMDSpTeenPatti2020Statistics.ts": [
		35025,
		9
	],
	"./models/cmd/live/CMDSpThaihiloStatistics": [
		15193,
		9
	],
	"./models/cmd/live/CMDSpThaihiloStatistics.ts": [
		15193,
		9
	],
	"./models/cmd/live/CMDSpTicketResult": [
		65163,
		9
	],
	"./models/cmd/live/CMDSpTicketResult.ts": [
		65163,
		9
	],
	"./models/cmd/live/CMDSpTipsResult": [
		20029,
		9
	],
	"./models/cmd/live/CMDSpTipsResult.ts": [
		20029,
		9
	],
	"./models/cmd/live/CMDSpXocdiaStatistics": [
		2261,
		9
	],
	"./models/cmd/live/CMDSpXocdiaStatistics.ts": [
		2261,
		9
	],
	"./models/cmd/live/CMDTeenPatti2020": [
		26515,
		9
	],
	"./models/cmd/live/CMDTeenPatti2020.ts": [
		26515,
		9
	],
	"./models/cmd/live/CMDTeenPatti2020Statistics": [
		59780,
		9
	],
	"./models/cmd/live/CMDTeenPatti2020Statistics.ts": [
		59780,
		9
	],
	"./models/cmd/live/CMDThaihilo": [
		45069,
		9
	],
	"./models/cmd/live/CMDThaihilo.ts": [
		45069,
		9
	],
	"./models/cmd/live/CMDThaihiloStatistics": [
		30518,
		9
	],
	"./models/cmd/live/CMDThaihiloStatistics.ts": [
		30518,
		9
	],
	"./models/cmd/live/CMDTicket": [
		44285,
		9
	],
	"./models/cmd/live/CMDTicket.ts": [
		44285,
		9
	],
	"./models/cmd/live/CMDTicketPrice": [
		88432,
		9
	],
	"./models/cmd/live/CMDTicketPrice.ts": [
		88432,
		9
	],
	"./models/cmd/live/CMDTopResultPlayer": [
		22170,
		9
	],
	"./models/cmd/live/CMDTopResultPlayer.ts": [
		22170,
		9
	],
	"./models/cmd/live/CMDTotalBet": [
		77080,
		9
	],
	"./models/cmd/live/CMDTotalBet.ts": [
		77080,
		9
	],
	"./models/cmd/live/CMDXocdia": [
		87273,
		9
	],
	"./models/cmd/live/CMDXocdia.ts": [
		87273,
		9
	],
	"./models/cmd/live/CMDXocdiaStatistics": [
		5258,
		9
	],
	"./models/cmd/live/CMDXocdiaStatistics.ts": [
		5258,
		9
	],
	"./models/cmd/live/Command": [
		49424,
		9
	],
	"./models/cmd/live/Command.ts": [
		49424,
		9
	],
	"./models/cmd/live/ICommand": [
		81353,
		9,
		81353
	],
	"./models/cmd/live/ICommand.ts": [
		81353,
		9,
		81353
	],
	"./models/cmd/live/index": [
		72669,
		9
	],
	"./models/cmd/live/index.ts": [
		72669,
		9
	],
	"./models/cmd/readme.md": [
		20981,
		1,
		20981
	],
	"./models/config/CdnRawConfig": [
		2023,
		9,
		2023
	],
	"./models/config/CdnRawConfig.ts": [
		2023,
		9,
		2023
	],
	"./models/games/BaseInformation": [
		39400,
		9,
		39400
	],
	"./models/games/BaseInformation.ts": [
		39400,
		9,
		39400
	],
	"./models/games/BaseRecord": [
		13889,
		9,
		13889
	],
	"./models/games/BaseRecord.ts": [
		13889,
		9,
		13889
	],
	"./models/games/BaseResult": [
		92273,
		9,
		92273
	],
	"./models/games/BaseResult.ts": [
		92273,
		9,
		92273
	],
	"./models/games/BaseRoadmapRecord": [
		5351,
		9,
		5351
	],
	"./models/games/BaseRoadmapRecord.ts": [
		5351,
		9,
		5351
	],
	"./models/games/BaseTotalBet": [
		68689,
		9,
		68689
	],
	"./models/games/BaseTotalBet.ts": [
		68689,
		9,
		68689
	],
	"./models/games/BetRoom": [
		17717,
		9
	],
	"./models/games/BetRoom.ts": [
		17717,
		9
	],
	"./models/games/Chip": [
		17015,
		9,
		17015
	],
	"./models/games/Chip.ts": [
		17015,
		9,
		17015
	],
	"./models/games/PokerCard": [
		93130,
		9
	],
	"./models/games/PokerCard.ts": [
		93130,
		9
	],
	"./models/games/PokerShow": [
		71225,
		9,
		71225
	],
	"./models/games/PokerShow.ts": [
		71225,
		9,
		71225
	],
	"./models/games/Progress": [
		95078,
		9
	],
	"./models/games/Progress.ts": [
		95078,
		9
	],
	"./models/games/ShoeRound": [
		29660,
		9,
		29660
	],
	"./models/games/ShoeRound.ts": [
		29660,
		9,
		29660
	],
	"./models/games/andarBahar": [
		5328,
		9,
		5328
	],
	"./models/games/andarBahar/": [
		5328,
		9,
		5328
	],
	"./models/games/andarBahar/BetType": [
		30971,
		9
	],
	"./models/games/andarBahar/BetType.ts": [
		30971,
		9
	],
	"./models/games/andarBahar/GameResult": [
		54113,
		9
	],
	"./models/games/andarBahar/GameResult.ts": [
		54113,
		9
	],
	"./models/games/andarBahar/GameState": [
		56747,
		9
	],
	"./models/games/andarBahar/GameState.ts": [
		56747,
		9
	],
	"./models/games/andarBahar/Record": [
		18043,
		9,
		18043
	],
	"./models/games/andarBahar/Record.ts": [
		18043,
		9,
		18043
	],
	"./models/games/andarBahar/Result": [
		91171,
		9,
		91171
	],
	"./models/games/andarBahar/Result.ts": [
		91171,
		9,
		91171
	],
	"./models/games/andarBahar/Roadmap": [
		78724,
		9,
		78724
	],
	"./models/games/andarBahar/Roadmap.ts": [
		78724,
		9,
		78724
	],
	"./models/games/andarBahar/Statistics": [
		91337,
		9,
		91337
	],
	"./models/games/andarBahar/Statistics.ts": [
		91337,
		9,
		91337
	],
	"./models/games/andarBahar/TotalBet": [
		14795,
		9,
		14795
	],
	"./models/games/andarBahar/TotalBet.ts": [
		14795,
		9,
		14795
	],
	"./models/games/andarBahar/index": [
		5328,
		9,
		5328
	],
	"./models/games/andarBahar/index.ts": [
		5328,
		9,
		5328
	],
	"./models/games/baccarat": [
		55963,
		9,
		55963
	],
	"./models/games/baccarat/": [
		55963,
		9,
		55963
	],
	"./models/games/baccarat/BetType": [
		60244,
		9
	],
	"./models/games/baccarat/BetType.ts": [
		60244,
		9
	],
	"./models/games/baccarat/GameResult": [
		98756,
		9,
		98756
	],
	"./models/games/baccarat/GameResult.ts": [
		98756,
		9,
		98756
	],
	"./models/games/baccarat/GameState": [
		84048,
		9
	],
	"./models/games/baccarat/GameState.ts": [
		84048,
		9
	],
	"./models/games/baccarat/GoodRoad": [
		87948,
		9,
		87948
	],
	"./models/games/baccarat/GoodRoad.ts": [
		87948,
		9,
		87948
	],
	"./models/games/baccarat/Record": [
		70610,
		9,
		70610
	],
	"./models/games/baccarat/Record.ts": [
		70610,
		9,
		70610
	],
	"./models/games/baccarat/Result": [
		79422,
		9,
		79422
	],
	"./models/games/baccarat/Result.ts": [
		79422,
		9,
		79422
	],
	"./models/games/baccarat/Roadmap": [
		1947,
		9,
		1947
	],
	"./models/games/baccarat/Roadmap.ts": [
		1947,
		9,
		1947
	],
	"./models/games/baccarat/Statistics": [
		70448,
		9,
		70448
	],
	"./models/games/baccarat/Statistics.ts": [
		70448,
		9,
		70448
	],
	"./models/games/baccarat/TotalBet": [
		14862,
		9,
		14862
	],
	"./models/games/baccarat/TotalBet.ts": [
		14862,
		9,
		14862
	],
	"./models/games/baccarat/index": [
		55963,
		9,
		55963
	],
	"./models/games/baccarat/index.ts": [
		55963,
		9,
		55963
	],
	"./models/games/blackjack": [
		88450,
		9
	],
	"./models/games/blackjack/": [
		88450,
		9
	],
	"./models/games/blackjack/BetResult": [
		38780,
		9
	],
	"./models/games/blackjack/BetResult.ts": [
		38780,
		9
	],
	"./models/games/blackjack/GameDelay": [
		78447,
		9,
		78447
	],
	"./models/games/blackjack/GameDelay.ts": [
		78447,
		9,
		78447
	],
	"./models/games/blackjack/GameRecord": [
		97943,
		9,
		97943
	],
	"./models/games/blackjack/GameRecord.ts": [
		97943,
		9,
		97943
	],
	"./models/games/blackjack/GameResult": [
		28807,
		9,
		28807
	],
	"./models/games/blackjack/GameResult.ts": [
		28807,
		9,
		28807
	],
	"./models/games/blackjack/GameState": [
		3961,
		9,
		3961
	],
	"./models/games/blackjack/GameState.ts": [
		3961,
		9,
		3961
	],
	"./models/games/blackjack/HandInfo": [
		90093,
		9,
		90093
	],
	"./models/games/blackjack/HandInfo.ts": [
		90093,
		9,
		90093
	],
	"./models/games/blackjack/History": [
		13574,
		9,
		13574
	],
	"./models/games/blackjack/History.ts": [
		13574,
		9,
		13574
	],
	"./models/games/blackjack/SeatInfo": [
		49205,
		9,
		49205
	],
	"./models/games/blackjack/SeatInfo.ts": [
		49205,
		9,
		49205
	],
	"./models/games/blackjack/TotalBet": [
		17925,
		9,
		17925
	],
	"./models/games/blackjack/TotalBet.ts": [
		17925,
		9,
		17925
	],
	"./models/games/blackjack/enums/BetClass": [
		64546,
		9
	],
	"./models/games/blackjack/enums/BetClass.ts": [
		64546,
		9
	],
	"./models/games/blackjack/enums/BetContent": [
		10399,
		9
	],
	"./models/games/blackjack/enums/BetContent.ts": [
		10399,
		9
	],
	"./models/games/blackjack/enums/BetType": [
		98144,
		9
	],
	"./models/games/blackjack/enums/BetType.ts": [
		98144,
		9
	],
	"./models/games/blackjack/enums/Decision": [
		84681,
		9
	],
	"./models/games/blackjack/enums/Decision.ts": [
		84681,
		9
	],
	"./models/games/blackjack/enums/HistoryInfo": [
		7043,
		9
	],
	"./models/games/blackjack/enums/HistoryInfo.ts": [
		7043,
		9
	],
	"./models/games/blackjack/enums/ResultPlayer": [
		45171,
		9
	],
	"./models/games/blackjack/enums/ResultPlayer.ts": [
		45171,
		9
	],
	"./models/games/blackjack/index": [
		88450,
		9
	],
	"./models/games/blackjack/index.ts": [
		88450,
		9
	],
	"./models/games/blackjack/states": [
		45501,
		9
	],
	"./models/games/blackjack/states/": [
		45501,
		9
	],
	"./models/games/blackjack/states/Constant": [
		77893,
		9
	],
	"./models/games/blackjack/states/Constant.ts": [
		77893,
		9
	],
	"./models/games/blackjack/states/DealtLoop": [
		57309,
		9
	],
	"./models/games/blackjack/states/DealtLoop.ts": [
		57309,
		9
	],
	"./models/games/blackjack/states/DealtTurn": [
		67140,
		9
	],
	"./models/games/blackjack/states/DealtTurn.ts": [
		67140,
		9
	],
	"./models/games/blackjack/states/Init": [
		21019,
		9
	],
	"./models/games/blackjack/states/Init.ts": [
		21019,
		9
	],
	"./models/games/blackjack/states/Phase": [
		28062,
		9
	],
	"./models/games/blackjack/states/Phase.ts": [
		28062,
		9
	],
	"./models/games/blackjack/states/index": [
		45501,
		9
	],
	"./models/games/blackjack/states/index.ts": [
		45501,
		9
	],
	"./models/games/dragonTiger": [
		55616,
		9,
		55616
	],
	"./models/games/dragonTiger/": [
		55616,
		9,
		55616
	],
	"./models/games/dragonTiger/BetType": [
		40107,
		9
	],
	"./models/games/dragonTiger/BetType.ts": [
		40107,
		9
	],
	"./models/games/dragonTiger/Game": [
		10536,
		9,
		10536
	],
	"./models/games/dragonTiger/Game.ts": [
		10536,
		9,
		10536
	],
	"./models/games/dragonTiger/GameResult": [
		57521,
		9,
		57521
	],
	"./models/games/dragonTiger/GameResult.ts": [
		57521,
		9,
		57521
	],
	"./models/games/dragonTiger/GameState": [
		56315,
		9
	],
	"./models/games/dragonTiger/GameState.ts": [
		56315,
		9
	],
	"./models/games/dragonTiger/Record": [
		31819,
		9,
		31819
	],
	"./models/games/dragonTiger/Record.ts": [
		31819,
		9,
		31819
	],
	"./models/games/dragonTiger/Result": [
		45491,
		9,
		45491
	],
	"./models/games/dragonTiger/Result.ts": [
		45491,
		9,
		45491
	],
	"./models/games/dragonTiger/Roadmap": [
		24372,
		9,
		24372
	],
	"./models/games/dragonTiger/Roadmap.ts": [
		24372,
		9,
		24372
	],
	"./models/games/dragonTiger/Statistics": [
		62265,
		9,
		62265
	],
	"./models/games/dragonTiger/Statistics.ts": [
		62265,
		9,
		62265
	],
	"./models/games/dragonTiger/TotalBet": [
		67643,
		9,
		67643
	],
	"./models/games/dragonTiger/TotalBet.ts": [
		67643,
		9,
		67643
	],
	"./models/games/dragonTiger/index": [
		55616,
		9,
		55616
	],
	"./models/games/dragonTiger/index.ts": [
		55616,
		9,
		55616
	],
	"./models/games/enums/BetState": [
		49110,
		9
	],
	"./models/games/enums/BetState.ts": [
		49110,
		9
	],
	"./models/games/enums/GameError": [
		60020,
		9
	],
	"./models/games/enums/GameError.ts": [
		60020,
		9
	],
	"./models/games/enums/GameFeature": [
		43544,
		9
	],
	"./models/games/enums/GameFeature.ts": [
		43544,
		9
	],
	"./models/games/enums/GameState": [
		31331,
		9
	],
	"./models/games/enums/GameState.ts": [
		31331,
		9
	],
	"./models/games/enums/GameType": [
		23752,
		9
	],
	"./models/games/enums/GameType.ts": [
		23752,
		9
	],
	"./models/games/enums/LocalState": [
		22230,
		9
	],
	"./models/games/enums/LocalState.ts": [
		22230,
		9
	],
	"./models/games/pokdeng": [
		62120,
		9,
		62120
	],
	"./models/games/pokdeng/": [
		62120,
		9,
		62120
	],
	"./models/games/pokdeng/BetType": [
		80051,
		9
	],
	"./models/games/pokdeng/BetType.ts": [
		80051,
		9
	],
	"./models/games/pokdeng/DeckInfo": [
		57399,
		9,
		57399
	],
	"./models/games/pokdeng/DeckInfo.ts": [
		57399,
		9,
		57399
	],
	"./models/games/pokdeng/Game": [
		44800,
		9,
		44800
	],
	"./models/games/pokdeng/Game.ts": [
		44800,
		9,
		44800
	],
	"./models/games/pokdeng/GameState": [
		78115,
		9
	],
	"./models/games/pokdeng/GameState.ts": [
		78115,
		9
	],
	"./models/games/pokdeng/HandResult": [
		8562,
		9
	],
	"./models/games/pokdeng/HandResult.ts": [
		8562,
		9
	],
	"./models/games/pokdeng/Record": [
		99267,
		9,
		99267
	],
	"./models/games/pokdeng/Record.ts": [
		99267,
		9,
		99267
	],
	"./models/games/pokdeng/Result": [
		10507,
		9,
		10507
	],
	"./models/games/pokdeng/Result.ts": [
		10507,
		9,
		10507
	],
	"./models/games/pokdeng/Roadmap": [
		46252,
		9,
		46252
	],
	"./models/games/pokdeng/Roadmap.ts": [
		46252,
		9,
		46252
	],
	"./models/games/pokdeng/Statistics": [
		87201,
		9,
		87201
	],
	"./models/games/pokdeng/Statistics.ts": [
		87201,
		9,
		87201
	],
	"./models/games/pokdeng/TotalBet": [
		21539,
		9,
		21539
	],
	"./models/games/pokdeng/TotalBet.ts": [
		21539,
		9,
		21539
	],
	"./models/games/pokdeng/index": [
		62120,
		9,
		62120
	],
	"./models/games/pokdeng/index.ts": [
		62120,
		9,
		62120
	],
	"./models/games/roulette": [
		18918,
		9,
		18918
	],
	"./models/games/roulette/": [
		18918,
		9,
		18918
	],
	"./models/games/roulette/BetType": [
		98993,
		9
	],
	"./models/games/roulette/BetType.ts": [
		98993,
		9
	],
	"./models/games/roulette/Game": [
		32330,
		9,
		32330
	],
	"./models/games/roulette/Game.ts": [
		32330,
		9,
		32330
	],
	"./models/games/roulette/GameResult": [
		75779,
		9
	],
	"./models/games/roulette/GameResult.ts": [
		75779,
		9
	],
	"./models/games/roulette/GameState": [
		38517,
		9
	],
	"./models/games/roulette/GameState.ts": [
		38517,
		9
	],
	"./models/games/roulette/Record": [
		17001,
		9
	],
	"./models/games/roulette/Record.ts": [
		17001,
		9
	],
	"./models/games/roulette/Result": [
		5081,
		9,
		5081
	],
	"./models/games/roulette/Result.ts": [
		5081,
		9,
		5081
	],
	"./models/games/roulette/Roadmap": [
		24406,
		9,
		24406
	],
	"./models/games/roulette/Roadmap.ts": [
		24406,
		9,
		24406
	],
	"./models/games/roulette/Statistics": [
		60047,
		9,
		60047
	],
	"./models/games/roulette/Statistics.ts": [
		60047,
		9,
		60047
	],
	"./models/games/roulette/TotalBet": [
		59177,
		9,
		59177
	],
	"./models/games/roulette/TotalBet.ts": [
		59177,
		9,
		59177
	],
	"./models/games/roulette/index": [
		18918,
		9,
		18918
	],
	"./models/games/roulette/index.ts": [
		18918,
		9,
		18918
	],
	"./models/games/sedie": [
		63648,
		9,
		63648
	],
	"./models/games/sedie/": [
		63648,
		9,
		63648
	],
	"./models/games/sedie/BetType": [
		15403,
		9
	],
	"./models/games/sedie/BetType.ts": [
		15403,
		9
	],
	"./models/games/sedie/Game": [
		51848,
		9,
		51848
	],
	"./models/games/sedie/Game.ts": [
		51848,
		9,
		51848
	],
	"./models/games/sedie/GameResult": [
		57457,
		9,
		57457
	],
	"./models/games/sedie/GameResult.ts": [
		57457,
		9,
		57457
	],
	"./models/games/sedie/Record": [
		38891,
		9,
		38891
	],
	"./models/games/sedie/Record.ts": [
		38891,
		9,
		38891
	],
	"./models/games/sedie/Result": [
		38067,
		9,
		38067
	],
	"./models/games/sedie/Result.ts": [
		38067,
		9,
		38067
	],
	"./models/games/sedie/Roadmap": [
		26164,
		9,
		26164
	],
	"./models/games/sedie/Roadmap.ts": [
		26164,
		9,
		26164
	],
	"./models/games/sedie/Statistics": [
		33017,
		9,
		33017
	],
	"./models/games/sedie/Statistics.ts": [
		33017,
		9,
		33017
	],
	"./models/games/sedie/TotalBet": [
		34427,
		9,
		34427
	],
	"./models/games/sedie/TotalBet.ts": [
		34427,
		9,
		34427
	],
	"./models/games/sedie/index": [
		63648,
		9,
		63648
	],
	"./models/games/sedie/index.ts": [
		63648,
		9,
		63648
	],
	"./models/games/sicbo": [
		31344,
		9,
		31344
	],
	"./models/games/sicbo/": [
		31344,
		9,
		31344
	],
	"./models/games/sicbo/BetType": [
		45083,
		9
	],
	"./models/games/sicbo/BetType.ts": [
		45083,
		9
	],
	"./models/games/sicbo/GameState": [
		20587,
		9
	],
	"./models/games/sicbo/GameState.ts": [
		20587,
		9
	],
	"./models/games/sicbo/Record": [
		34555,
		9,
		34555
	],
	"./models/games/sicbo/Record.ts": [
		34555,
		9,
		34555
	],
	"./models/games/sicbo/Result": [
		91331,
		9,
		91331
	],
	"./models/games/sicbo/Result.ts": [
		91331,
		9,
		91331
	],
	"./models/games/sicbo/Roadmap": [
		92836,
		9,
		92836
	],
	"./models/games/sicbo/Roadmap.ts": [
		92836,
		9,
		92836
	],
	"./models/games/sicbo/Statistics": [
		83625,
		9,
		83625
	],
	"./models/games/sicbo/Statistics.ts": [
		83625,
		9,
		83625
	],
	"./models/games/sicbo/TotalBet": [
		76779,
		9,
		76779
	],
	"./models/games/sicbo/TotalBet.ts": [
		76779,
		9,
		76779
	],
	"./models/games/sicbo/index": [
		31344,
		9,
		31344
	],
	"./models/games/sicbo/index.ts": [
		31344,
		9,
		31344
	],
	"./models/games/teenpatti": [
		89024,
		9,
		89024
	],
	"./models/games/teenpatti/": [
		89024,
		9,
		89024
	],
	"./models/games/teenpatti/BetType": [
		33547,
		9
	],
	"./models/games/teenpatti/BetType.ts": [
		33547,
		9
	],
	"./models/games/teenpatti/Game": [
		76680,
		9,
		76680
	],
	"./models/games/teenpatti/Game.ts": [
		76680,
		9,
		76680
	],
	"./models/games/teenpatti/GameResult": [
		84337,
		9
	],
	"./models/games/teenpatti/GameResult.ts": [
		84337,
		9
	],
	"./models/games/teenpatti/GameState": [
		19067,
		9
	],
	"./models/games/teenpatti/GameState.ts": [
		19067,
		9
	],
	"./models/games/teenpatti/Record": [
		91467,
		9,
		91467
	],
	"./models/games/teenpatti/Record.ts": [
		91467,
		9,
		91467
	],
	"./models/games/teenpatti/Result": [
		21491,
		9,
		21491
	],
	"./models/games/teenpatti/Result.ts": [
		21491,
		9,
		21491
	],
	"./models/games/teenpatti/Roadmap": [
		34164,
		9,
		34164
	],
	"./models/games/teenpatti/Roadmap.ts": [
		34164,
		9,
		34164
	],
	"./models/games/teenpatti/Statistics": [
		89081,
		9,
		89081
	],
	"./models/games/teenpatti/Statistics.ts": [
		89081,
		9,
		89081
	],
	"./models/games/teenpatti/TotalBet": [
		35227,
		9,
		35227
	],
	"./models/games/teenpatti/TotalBet.ts": [
		35227,
		9,
		35227
	],
	"./models/games/teenpatti/index": [
		89024,
		9,
		89024
	],
	"./models/games/teenpatti/index.ts": [
		89024,
		9,
		89024
	],
	"./models/host/BetAmount": [
		19147,
		9,
		19147
	],
	"./models/host/BetAmount.ts": [
		19147,
		9,
		19147
	],
	"./models/host/Dealer": [
		50443,
		9,
		50443
	],
	"./models/host/Dealer.ts": [
		50443,
		9,
		50443
	],
	"./models/host/MaxBet": [
		43695,
		9,
		43695
	],
	"./models/host/MaxBet.ts": [
		43695,
		9,
		43695
	],
	"./models/host/PlayerCount": [
		33916,
		9,
		33916
	],
	"./models/host/PlayerCount.ts": [
		33916,
		9,
		33916
	],
	"./models/host/Poker": [
		31013,
		9,
		31013
	],
	"./models/host/Poker.ts": [
		31013,
		9,
		31013
	],
	"./models/host/readme.md": [
		99353,
		1,
		99353
	],
	"./models/html": [
		41659,
		9,
		41659
	],
	"./models/html/": [
		41659,
		9,
		41659
	],
	"./models/html/ImageProps": [
		80926,
		9,
		80926
	],
	"./models/html/ImageProps.ts": [
		80926,
		9,
		80926
	],
	"./models/html/index": [
		41659,
		9,
		41659
	],
	"./models/html/index.ts": [
		41659,
		9,
		41659
	],
	"./models/lobby/GameCategoryTab": [
		74635,
		9
	],
	"./models/lobby/GameCategoryTab.ts": [
		74635,
		9
	],
	"./modules/bet/players/slice": [
		94011,
		9
	],
	"./modules/bet/players/slice.ts": [
		94011,
		9
	],
	"./modules/bet/room/reducer": [
		19054,
		9
	],
	"./modules/bet/room/reducer.ts": [
		19054,
		9
	],
	"./modules/bet/room/slice": [
		98384,
		9
	],
	"./modules/bet/room/slice.ts": [
		98384,
		9
	],
	"./modules/blockLayer": [
		13973,
		9
	],
	"./modules/blockLayer/": [
		13973,
		9
	],
	"./modules/blockLayer/index": [
		13973,
		9
	],
	"./modules/blockLayer/index.tsx": [
		13973,
		9
	],
	"./modules/count/components/PlayerCount": [
		9035,
		9
	],
	"./modules/count/components/PlayerCount.tsx": [
		9035,
		9
	],
	"./modules/count/slice": [
		10453,
		9
	],
	"./modules/count/slice/": [
		10453,
		9
	],
	"./modules/count/slice/index": [
		10453,
		9
	],
	"./modules/count/slice/index.ts": [
		10453,
		9
	],
	"./modules/countdown": [
		25308,
		9
	],
	"./modules/countdown/": [
		25308,
		9
	],
	"./modules/countdown/AndarBaharCountdown": [
		64711,
		9
	],
	"./modules/countdown/AndarBaharCountdown.tsx": [
		64711,
		9
	],
	"./modules/countdown/BaccaratCountdown": [
		12060,
		9
	],
	"./modules/countdown/BaccaratCountdown.tsx": [
		12060,
		9
	],
	"./modules/countdown/BlackjackCountdown": [
		46675,
		9
	],
	"./modules/countdown/BlackjackCountdown.tsx": [
		46675,
		9
	],
	"./modules/countdown/DragonTigerCountdown": [
		41941,
		9
	],
	"./modules/countdown/DragonTigerCountdown.tsx": [
		41941,
		9
	],
	"./modules/countdown/InGameCountdown": [
		31204,
		9
	],
	"./modules/countdown/InGameCountdown.tsx": [
		31204,
		9
	],
	"./modules/countdown/LobbyCountdown": [
		12707,
		9
	],
	"./modules/countdown/LobbyCountdown.tsx": [
		12707,
		9
	],
	"./modules/countdown/SedieCountdown": [
		56017,
		9
	],
	"./modules/countdown/SedieCountdown.tsx": [
		56017,
		9
	],
	"./modules/countdown/SicBoCountdown": [
		58269,
		9
	],
	"./modules/countdown/SicBoCountdown.tsx": [
		58269,
		9
	],
	"./modules/countdown/TeenPattiCountdown": [
		88141,
		9
	],
	"./modules/countdown/TeenPattiCountdown.tsx": [
		88141,
		9
	],
	"./modules/countdown/index": [
		25308,
		9
	],
	"./modules/countdown/index.tsx": [
		25308,
		9
	],
	"./modules/game": [
		3933,
		9
	],
	"./modules/game/": [
		3933,
		9
	],
	"./modules/game/VideoImages": [
		17114,
		9
	],
	"./modules/game/VideoImages.tsx": [
		17114,
		9
	],
	"./modules/game/components/BetAreaPanels": [
		7394,
		9
	],
	"./modules/game/components/BetAreaPanels/": [
		7394,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar": [
		77539,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/": [
		77539,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea": [
		78944,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/": [
		78944,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharBetArea": [
		68044,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharBetArea.tsx": [
		68044,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharNCSwitch": [
		30711,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharNCSwitch.tsx": [
		30711,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharNoCommBetArea": [
		53043,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/AndarBaharNoCommBetArea.tsx": [
		53043,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/betArea": [
		58583,
		3
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/betArea.json": [
		58583,
		3
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/index": [
		78944,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/index.tsx": [
		78944,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/noCommBetArea": [
		76662,
		3
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/BetArea/noCommBetArea.json": [
		76662,
		3
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/index": [
		77539,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/index.tsx": [
		77539,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/utils": [
		36960,
		9
	],
	"./modules/game/components/BetAreaPanels/AndarBahar/utils.ts": [
		36960,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat": [
		1230,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/": [
		1230,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea": [
		51419,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/": [
		51419,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/BaccaratBetArea": [
		39166,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/BaccaratBetArea.tsx": [
		39166,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/SuperSixBetArea": [
		63986,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/SuperSixBetArea.tsx": [
		63986,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/betAreaInfo": [
		90177,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/betAreaInfo.ts": [
		90177,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/index": [
		51419,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/index.scss": [
		40678,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/BetArea/index.tsx": [
		51419,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipList": [
		98855,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipList/": [
		98855,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipList/index": [
		98855,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipList/index.scss": [
		81768,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipList/index.tsx": [
		98855,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipSelector": [
		1584,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipSelector/": [
		1584,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipSelector/index": [
		1584,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ChipSelector/index.tsx": [
		1584,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/DoubleBetButton": [
		61023,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/DoubleBetButton/": [
		61023,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/DoubleBetButton/index": [
		61023,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/DoubleBetButton/index.tsx": [
		61023,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ReBetButton": [
		51719,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ReBetButton/": [
		51719,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ReBetButton/index": [
		51719,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/ReBetButton/index.tsx": [
		51719,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/index": [
		1230,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/index.tsx": [
		1230,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/utils": [
		29543,
		9
	],
	"./modules/game/components/BetAreaPanels/Baccarat/utils.ts": [
		29543,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack": [
		3419,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/": [
		3419,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BankerResultDisplay": [
		46409,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BankerResultDisplay.scss": [
		92838,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BankerResultDisplay.tsx": [
		46409,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BetAmount": [
		29202,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BetAmount.tsx": [
		29202,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BetOptions": [
		76354,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BetOptions.scss": [
		98919,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/BetOptions.tsx": [
		76354,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/DoubleDownDecisionButton": [
		38711,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/DoubleDownDecisionButton.tsx": [
		38711,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/HitDecisionButton": [
		75317,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/HitDecisionButton.tsx": [
		75317,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/SplitDecisionButton": [
		72486,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/SplitDecisionButton.tsx": [
		72486,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/StandDecisionButton": [
		66706,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/StandDecisionButton.tsx": [
		66706,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/SurrenderDecisionButton": [
		22952,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Decision/SurrenderDecisionButton.tsx": [
		22952,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/DecisionPanel": [
		49795,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/DecisionPanel.scss": [
		13608,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/DecisionPanel.tsx": [
		49795,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/FollowDecisionPanel": [
		83522,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/FollowDecisionPanel.tsx": [
		83522,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/InsurancePanel": [
		65634,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/InsurancePanel.tsx": [
		65634,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/PlayerName": [
		83369,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/PlayerName.tsx": [
		83369,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/PlayerResultDisplay": [
		67411,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/PlayerResultDisplay.scss": [
		46254,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/PlayerResultDisplay.tsx": [
		67411,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/BetResultDisplay": [
		75409,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/BetResultDisplay.tsx": [
		75409,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/DecisionSymbols": [
		84120,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/DecisionSymbols.tsx": [
		84120,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/GamingSeatSymbol": [
		64885,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/GamingSeatSymbol.scss": [
		17170,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/GamingSeatSymbol.tsx": [
		64885,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/LeaveButton": [
		37928,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/LeaveButton.tsx": [
		37928,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/PointDisplay": [
		10045,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/PointDisplay.tsx": [
		10045,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/SeatLabel": [
		36894,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/SeatLabel.tsx": [
		36894,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/SeatSymbol": [
		68246,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/SeatSymbol.scss": [
		39019,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/Seat/SeatSymbol.tsx": [
		68246,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea": [
		97970,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/": [
		97970,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/BettingSeatArea": [
		5871,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/BettingSeatArea.tsx": [
		5871,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/GamingSeatArea": [
		45119,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/GamingSeatArea.tsx": [
		45119,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/index": [
		97970,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/index.scss": [
		74243,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/SeatArea/index.tsx": [
		97970,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/index": [
		3419,
		9
	],
	"./modules/game/components/BetAreaPanels/Blackjack/index.tsx": [
		3419,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger": [
		92193,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/": [
		92193,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/betArea": [
		98836,
		3
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/betArea.json": [
		98836,
		3
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/index": [
		92193,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/index.tsx": [
		92193,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/utils": [
		4298,
		9
	],
	"./modules/game/components/BetAreaPanels/DragonTiger/utils.ts": [
		4298,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng": [
		78141,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/": [
		78141,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea": [
		6742,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/": [
		6742,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/PokDengBetArea": [
		34012,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/PokDengBetArea.tsx": [
		34012,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/betArea": [
		89953,
		3
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/betArea.json": [
		89953,
		3
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/index": [
		6742,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/BetArea/index.tsx": [
		6742,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/index": [
		78141,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/index.tsx": [
		78141,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/utils": [
		64878,
		9
	],
	"./modules/game/components/BetAreaPanels/Pokdeng/utils.ts": [
		64878,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette": [
		97841,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/": [
		97841,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type1/BetArea": [
		72316,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type1/BetArea.tsx": [
		72316,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type1/TapArea": [
		6138,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type1/TapArea.tsx": [
		6138,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type2/BetArea": [
		77267,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type2/BetArea.tsx": [
		77267,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type2/TapArea": [
		33781,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/Type2/TapArea.tsx": [
		33781,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/constants": [
		37519,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/BetArea/constants.ts": [
		37519,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/index": [
		97841,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/index.tsx": [
		97841,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg": [
		52855,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg/": [
		52855,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg/index": [
		52855,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg/index.ts": [
		52855,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg/roul_vert_betarea1.svg": [
		34478,
		1,
		34478
	],
	"./modules/game/components/BetAreaPanels/Roulette/svg/roul_vert_betarea2.svg": [
		17453,
		1,
		17453
	],
	"./modules/game/components/BetAreaPanels/Roulette/utils": [
		7962,
		9
	],
	"./modules/game/components/BetAreaPanels/Roulette/utils.ts": [
		7962,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie": [
		52481,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/": [
		52481,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea": [
		32586,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/": [
		32586,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/SedieBetArea": [
		97876,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/SedieBetArea.tsx": [
		97876,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/betArea": [
		39973,
		3
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/betArea.json": [
		39973,
		3
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/index": [
		32586,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/BetArea/index.tsx": [
		32586,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/index": [
		52481,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/index.tsx": [
		52481,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/utils": [
		70410,
		9
	],
	"./modules/game/components/BetAreaPanels/Sedie/utils.ts": [
		70410,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo": [
		60313,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/": [
		60313,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/DoubleBetArea": [
		97797,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/DoubleBetArea.json": [
		9578,
		3
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/DoubleBetArea.tsx": [
		97797,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/FeatureBetArea": [
		50048,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/FeatureBetArea.json": [
		98053,
		3
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/FeatureBetArea.tsx": [
		50048,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/PopularBetArea": [
		555,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/PopularBetArea.json": [
		85696,
		3
	],
	"./modules/game/components/BetAreaPanels/SicBo/BetArea/PopularBetArea.tsx": [
		555,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/index": [
		60313,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/index.scss": [
		36502,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/index.tsx": [
		60313,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/utils": [
		70802,
		9
	],
	"./modules/game/components/BetAreaPanels/SicBo/utils.ts": [
		70802,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti": [
		91629,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/": [
		91629,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea": [
		38406,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/": [
		38406,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/TeenPattiBetArea": [
		80932,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/TeenPattiBetArea.tsx": [
		80932,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/betArea": [
		92985,
		3
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/betArea.json": [
		92985,
		3
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/index": [
		38406,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/BetArea/index.tsx": [
		38406,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/index": [
		91629,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/index.tsx": [
		91629,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/utils": [
		75614,
		9
	],
	"./modules/game/components/BetAreaPanels/TeenPatti/utils.ts": [
		75614,
		9
	],
	"./modules/game/components/BetAreaPanels/index": [
		7394,
		9
	],
	"./modules/game/components/BetAreaPanels/index.tsx": [
		7394,
		9
	],
	"./modules/game/components/BetResult/BaccaratBetResultPopup": [
		80124,
		9
	],
	"./modules/game/components/BetResult/BaccaratBetResultPopup.tsx": [
		80124,
		9
	],
	"./modules/game/components/BetResult/BetResultPanel": [
		61579,
		9
	],
	"./modules/game/components/BetResult/BetResultPanel.tsx": [
		61579,
		9
	],
	"./modules/game/components/BetResult/BlackjackBetResultPopup": [
		4915,
		9
	],
	"./modules/game/components/BetResult/BlackjackBetResultPopup.tsx": [
		4915,
		9
	],
	"./modules/game/components/BetResult/DragonTigerBetResultPopup": [
		60469,
		9
	],
	"./modules/game/components/BetResult/DragonTigerBetResultPopup.tsx": [
		60469,
		9
	],
	"./modules/game/components/ECard/AndarBaharECard": [
		10671,
		9
	],
	"./modules/game/components/ECard/AndarBaharECard.scss": [
		17316,
		9
	],
	"./modules/game/components/ECard/AndarBaharECard.tsx": [
		10671,
		9
	],
	"./modules/game/components/ECard/BaccaratECard": [
		99244,
		9
	],
	"./modules/game/components/ECard/BaccaratECard.scss": [
		31765,
		9
	],
	"./modules/game/components/ECard/BaccaratECard.tsx": [
		99244,
		9
	],
	"./modules/game/components/ECard/DragonTigerECard": [
		58233,
		9
	],
	"./modules/game/components/ECard/DragonTigerECard.scss": [
		42738,
		9
	],
	"./modules/game/components/ECard/DragonTigerECard.tsx": [
		58233,
		9
	],
	"./modules/game/components/ECard/PokDengECard": [
		97181,
		9
	],
	"./modules/game/components/ECard/PokDengECard.scss": [
		99638,
		9
	],
	"./modules/game/components/ECard/PokDengECard.tsx": [
		97181,
		9
	],
	"./modules/game/components/ECard/SedieECard": [
		28521,
		9
	],
	"./modules/game/components/ECard/SedieECard.scss": [
		38126,
		9
	],
	"./modules/game/components/ECard/SedieECard.tsx": [
		28521,
		9
	],
	"./modules/game/components/ECard/TeenPattiECard": [
		85925,
		9
	],
	"./modules/game/components/ECard/TeenPattiECard.scss": [
		754,
		9
	],
	"./modules/game/components/ECard/TeenPattiECard.tsx": [
		85925,
		9
	],
	"./modules/game/components/ECard/index.scss": [
		33451,
		9
	],
	"./modules/game/components/Footer": [
		70542,
		9
	],
	"./modules/game/components/Footer/": [
		70542,
		9
	],
	"./modules/game/components/Footer/index": [
		70542,
		9
	],
	"./modules/game/components/Footer/index.scss": [
		20887,
		9
	],
	"./modules/game/components/Footer/index.tsx": [
		70542,
		9
	],
	"./modules/game/components/GameInfoButton": [
		35028,
		9
	],
	"./modules/game/components/GameInfoButton.tsx": [
		35028,
		9
	],
	"./modules/game/components/GameResultPopup/AndarBaharGameResultPopup": [
		82175,
		9
	],
	"./modules/game/components/GameResultPopup/AndarBaharGameResultPopup.tsx": [
		82175,
		9
	],
	"./modules/game/components/GameResultPopup/BaccaratGameResultPopup": [
		89532,
		9
	],
	"./modules/game/components/GameResultPopup/BaccaratGameResultPopup.tsx": [
		89532,
		9
	],
	"./modules/game/components/GameResultPopup/BlackjackGameResultPopup": [
		74659,
		9
	],
	"./modules/game/components/GameResultPopup/BlackjackGameResultPopup.tsx": [
		74659,
		9
	],
	"./modules/game/components/GameResultPopup/DragonTigerGameResultPopup": [
		19325,
		9
	],
	"./modules/game/components/GameResultPopup/DragonTigerGameResultPopup.tsx": [
		19325,
		9
	],
	"./modules/game/components/GameResultPopup/GameResultPanel": [
		77761,
		9
	],
	"./modules/game/components/GameResultPopup/GameResultPanel.tsx": [
		77761,
		9
	],
	"./modules/game/components/GameResultPopup/RouletteGameResultPopup": [
		21745,
		9
	],
	"./modules/game/components/GameResultPopup/RouletteGameResultPopup.tsx": [
		21745,
		9
	],
	"./modules/game/components/GameResultPopup/SicBoGameResultPopup": [
		93541,
		9
	],
	"./modules/game/components/GameResultPopup/SicBoGameResultPopup.tsx": [
		93541,
		9
	],
	"./modules/game/components/GameResultPopup/TeenPattiGameResultPopup": [
		17781,
		9
	],
	"./modules/game/components/GameResultPopup/TeenPattiGameResultPopup.tsx": [
		17781,
		9
	],
	"./modules/game/components/GameRulesButton": [
		7459,
		9
	],
	"./modules/game/components/GameRulesButton.tsx": [
		7459,
		9
	],
	"./modules/game/components/Header": [
		55181,
		9
	],
	"./modules/game/components/Header.tsx": [
		55181,
		9
	],
	"./modules/game/components/HistoryInfo/BlackjackHistoryInfoTable": [
		45288,
		9
	],
	"./modules/game/components/HistoryInfo/BlackjackHistoryInfoTable.scss": [
		60106,
		9
	],
	"./modules/game/components/HistoryInfo/BlackjackHistoryInfoTable.tsx": [
		45288,
		9
	],
	"./modules/game/components/HistoryInfo/HistoryIcon": [
		57470,
		9
	],
	"./modules/game/components/HistoryInfo/HistoryIcon.tsx": [
		57470,
		9
	],
	"./modules/game/components/HistoryInfo/RouletteHistoryInfoTable": [
		7881,
		9
	],
	"./modules/game/components/HistoryInfo/RouletteHistoryInfoTable.tsx": [
		7881,
		9
	],
	"./modules/game/components/InGamePopupLayer": [
		56656,
		9
	],
	"./modules/game/components/InGamePopupLayer.tsx": [
		56656,
		9
	],
	"./modules/game/components/ShuffleLabel": [
		20425,
		9
	],
	"./modules/game/components/ShuffleLabel.tsx": [
		20425,
		9
	],
	"./modules/game/components/SwitchTableButton": [
		21472,
		9
	],
	"./modules/game/components/SwitchTableButton.scss": [
		91649,
		9
	],
	"./modules/game/components/SwitchTableButton.tsx": [
		21472,
		9
	],
	"./modules/game/components/SwitchTableCell": [
		20140,
		9
	],
	"./modules/game/components/SwitchTableCell.tsx": [
		20140,
		9
	],
	"./modules/game/components/TableInfoHeader": [
		77478,
		9
	],
	"./modules/game/components/TableInfoHeader/": [
		77478,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack": [
		82061,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/": [
		82061,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/LimitInfo": [
		72018,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/LimitInfo.tsx": [
		72018,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/PopupButton": [
		66401,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/PopupButton.tsx": [
		66401,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/PopupPanel": [
		25867,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/PopupPanel.tsx": [
		25867,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/TotalBetAmount": [
		75228,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/TotalBetAmount.tsx": [
		75228,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/index": [
		82061,
		9
	],
	"./modules/game/components/TableInfoHeader/Blackjack/index.ts": [
		82061,
		9
	],
	"./modules/game/components/TableInfoHeader/Roulette": [
		30317,
		9
	],
	"./modules/game/components/TableInfoHeader/Roulette/": [
		30317,
		9
	],
	"./modules/game/components/TableInfoHeader/Roulette/index": [
		30317,
		9
	],
	"./modules/game/components/TableInfoHeader/Roulette/index.tsx": [
		30317,
		9
	],
	"./modules/game/components/TableInfoHeader/index": [
		77478,
		9
	],
	"./modules/game/components/TableInfoHeader/index.tsx": [
		77478,
		9
	],
	"./modules/game/components/TableInfoPanel": [
		51545,
		9
	],
	"./modules/game/components/TableInfoPanel/": [
		51545,
		9
	],
	"./modules/game/components/TableInfoPanel/BaccaratTableInfoPanel": [
		19080,
		9
	],
	"./modules/game/components/TableInfoPanel/BaccaratTableInfoPanel.scss": [
		11569,
		9
	],
	"./modules/game/components/TableInfoPanel/BaccaratTableInfoPanel.tsx": [
		19080,
		9
	],
	"./modules/game/components/TableInfoPanel/BlackjackTableInfoPanel": [
		18739,
		9
	],
	"./modules/game/components/TableInfoPanel/BlackjackTableInfoPanel.scss": [
		98324,
		9
	],
	"./modules/game/components/TableInfoPanel/BlackjackTableInfoPanel.tsx": [
		18739,
		9
	],
	"./modules/game/components/TableInfoPanel/DragonTigerTableInfoPanel": [
		60745,
		9
	],
	"./modules/game/components/TableInfoPanel/DragonTigerTableInfoPanel.scss": [
		51514,
		9
	],
	"./modules/game/components/TableInfoPanel/DragonTigerTableInfoPanel.tsx": [
		60745,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette": [
		7640,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/": [
		7640,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/RouletteTableInfoTab": [
		83355,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/RouletteTableInfoTab.scss": [
		35616,
		9,
		35616
	],
	"./modules/game/components/TableInfoPanel/Roulette/RouletteTableInfoTab.tsx": [
		83355,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/index": [
		7640,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/index.scss": [
		89413,
		9
	],
	"./modules/game/components/TableInfoPanel/Roulette/index.tsx": [
		7640,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharBetLimitInfoTab": [
		583,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharBetLimitInfoTab.tsx": [
		583,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharBetRatePanel": [
		577,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharBetRatePanel.tsx": [
		577,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharLatest30RecordsPager": [
		26041,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharLatest30RecordsPager.tsx": [
		26041,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharOddsTableInfoPopup": [
		62786,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharOddsTableInfoPopup.tsx": [
		62786,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharTableInfoPanel": [
		60160,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharTableInfoPanel.scss": [
		69313,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharTableInfoPanel.tsx": [
		60160,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharWinStatisticPanel": [
		80298,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharWinStatisticPanel.scss": [
		54131,
		9
	],
	"./modules/game/components/TableInfoPanel/andarBahar/AndarBaharWinStatisticPanel.tsx": [
		80298,
		9
	],
	"./modules/game/components/TableInfoPanel/index": [
		51545,
		9
	],
	"./modules/game/components/TableInfoPanel/index.tsx": [
		51545,
		9
	],
	"./modules/game/components/TableInfoPanel/pokdeng/PokDengTableInfoPanel": [
		13314,
		9
	],
	"./modules/game/components/TableInfoPanel/pokdeng/PokDengTableInfoPanel.scss": [
		91427,
		9
	],
	"./modules/game/components/TableInfoPanel/pokdeng/PokDengTableInfoPanel.tsx": [
		13314,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieTableInfoPanel": [
		30818,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieTableInfoPanel.scss": [
		28451,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieTableInfoPanel.tsx": [
		30818,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieWinStatisticsPanel": [
		52203,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieWinStatisticsPanel.scss": [
		30184,
		9
	],
	"./modules/game/components/TableInfoPanel/sedie/SedieWinStatisticsPanel.tsx": [
		52203,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/SicBoTableInfoPanel": [
		28734,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/SicBoTableInfoPanel.scss": [
		16495,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/SicBoTableInfoPanel.tsx": [
		28734,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/SicBoTableInfoTab": [
		14369,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/SicBoTableInfoTab.tsx": [
		14369,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicBoStatisticsButton": [
		37336,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicBoStatisticsButton.scss": [
		98252,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicBoStatisticsButton.tsx": [
		37336,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticBetType": [
		40212,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticBetType.tsx": [
		40212,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticDice": [
		17931,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticDice.tsx": [
		17931,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticPoint": [
		82638,
		9
	],
	"./modules/game/components/TableInfoPanel/sicbo/statistics/SicboStatisticPoint.tsx": [
		82638,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiOddsTableInfoPopup": [
		66080,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiOddsTableInfoPopup.tsx": [
		66080,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiTableInfoPanel": [
		17718,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiTableInfoPanel.scss": [
		18839,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiTableInfoPanel.tsx": [
		17718,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiWinStatisticsPanel": [
		65911,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiWinStatisticsPanel.scss": [
		10228,
		9
	],
	"./modules/game/components/TableInfoPanel/teenpatti/TeenPattiWinStatisticsPanel.tsx": [
		65911,
		9
	],
	"./modules/game/components/TableInfoPanel/util": [
		66065,
		9
	],
	"./modules/game/components/TableInfoPanel/util.tsx": [
		66065,
		9
	],
	"./modules/game/components/TotalBetAmount": [
		10973,
		9
	],
	"./modules/game/components/TotalBetAmount.tsx": [
		10973,
		9
	],
	"./modules/game/components/TrialImage": [
		35325,
		9
	],
	"./modules/game/components/TrialImage.tsx": [
		35325,
		9
	],
	"./modules/game/components/VideoUnmutePanel": [
		66161,
		9
	],
	"./modules/game/components/VideoUnmutePanel.tsx": [
		66161,
		9
	],
	"./modules/game/index": [
		3933,
		9
	],
	"./modules/game/index.tsx": [
		3933,
		9
	],
	"./modules/games/selector": [
		50547,
		9
	],
	"./modules/games/selector.ts": [
		50547,
		9
	],
	"./modules/games/slice": [
		20522,
		9
	],
	"./modules/games/slice.ts": [
		20522,
		9
	],
	"./modules/host/models": [
		2570,
		9
	],
	"./modules/host/models/": [
		2570,
		9
	],
	"./modules/host/models/index": [
		2570,
		9
	],
	"./modules/host/models/index.ts": [
		2570,
		9
	],
	"./modules/host/models/payloads": [
		42659,
		9,
		42659
	],
	"./modules/host/models/payloads.ts": [
		42659,
		9,
		42659
	],
	"./modules/host/slice": [
		43390,
		9
	],
	"./modules/host/slice/": [
		43390,
		9
	],
	"./modules/host/slice/index": [
		43390,
		9
	],
	"./modules/host/slice/index.ts": [
		43390,
		9
	],
	"./modules/host/slice/reducers": [
		31313,
		9
	],
	"./modules/host/slice/reducers.ts": [
		31313,
		9
	],
	"./modules/landing": [
		93220,
		9
	],
	"./modules/landing/": [
		93220,
		9
	],
	"./modules/landing/index": [
		93220,
		9
	],
	"./modules/landing/index.tsx": [
		93220,
		9
	],
	"./modules/lobby": [
		76981,
		9
	],
	"./modules/lobby/": [
		76981,
		9
	],
	"./modules/lobby/components/Footer": [
		96459,
		9
	],
	"./modules/lobby/components/Footer.tsx": [
		96459,
		9
	],
	"./modules/lobby/components/GameCategory": [
		87081,
		9
	],
	"./modules/lobby/components/GameCategory/": [
		87081,
		9
	],
	"./modules/lobby/components/GameCategory/Buttons/BaccaratButton": [
		35996,
		9
	],
	"./modules/lobby/components/GameCategory/Buttons/BaccaratButton.tsx": [
		35996,
		9
	],
	"./modules/lobby/components/GameCategory/Buttons/FeatureButton": [
		12501,
		9
	],
	"./modules/lobby/components/GameCategory/Buttons/FeatureButton.tsx": [
		12501,
		9
	],
	"./modules/lobby/components/GameCategory/Buttons/index.scss": [
		63016,
		9
	],
	"./modules/lobby/components/GameCategory/index": [
		87081,
		9
	],
	"./modules/lobby/components/GameCategory/index.scss": [
		37614,
		9
	],
	"./modules/lobby/components/GameCategory/index.tsx": [
		87081,
		9
	],
	"./modules/lobby/components/GameTables": [
		76292,
		9
	],
	"./modules/lobby/components/GameTables/": [
		76292,
		9
	],
	"./modules/lobby/components/GameTables/BaccaratTables": [
		79048,
		9
	],
	"./modules/lobby/components/GameTables/BaccaratTables.tsx": [
		79048,
		9
	],
	"./modules/lobby/components/GameTables/FeaturedTables": [
		62281,
		9
	],
	"./modules/lobby/components/GameTables/FeaturedTables.tsx": [
		62281,
		9
	],
	"./modules/lobby/components/GameTables/GameTab.scss": [
		53550,
		9
	],
	"./modules/lobby/components/GameTables/MultiBetTables": [
		81707,
		9
	],
	"./modules/lobby/components/GameTables/MultiBetTables.tsx": [
		81707,
		9
	],
	"./modules/lobby/components/GameTables/OtherGamesTables": [
		85760,
		9
	],
	"./modules/lobby/components/GameTables/OtherGamesTables.tsx": [
		85760,
		9
	],
	"./modules/lobby/components/GameTables/TableCell": [
		4643,
		9
	],
	"./modules/lobby/components/GameTables/TableCell/": [
		4643,
		9
	],
	"./modules/lobby/components/GameTables/TableCell/BetAmountStatistic": [
		94034,
		9
	],
	"./modules/lobby/components/GameTables/TableCell/BetAmountStatistic.tsx": [
		94034,
		9
	],
	"./modules/lobby/components/GameTables/TableCell/index": [
		4643,
		9
	],
	"./modules/lobby/components/GameTables/TableCell/index.tsx": [
		4643,
		9
	],
	"./modules/lobby/components/GameTables/index": [
		76292,
		9
	],
	"./modules/lobby/components/GameTables/index.scss": [
		97591,
		9
	],
	"./modules/lobby/components/GameTables/index.tsx": [
		76292,
		9
	],
	"./modules/lobby/components/GridButton": [
		67258,
		9
	],
	"./modules/lobby/components/GridButton.tsx": [
		67258,
		9
	],
	"./modules/lobby/components/Header": [
		52092,
		9
	],
	"./modules/lobby/components/Header/": [
		52092,
		9
	],
	"./modules/lobby/components/Header/Logo": [
		16619,
		9
	],
	"./modules/lobby/components/Header/Logo.tsx": [
		16619,
		9
	],
	"./modules/lobby/components/Header/RefreshBalanceButton": [
		25813,
		9
	],
	"./modules/lobby/components/Header/RefreshBalanceButton.scss": [
		64986,
		9
	],
	"./modules/lobby/components/Header/RefreshBalanceButton.tsx": [
		25813,
		9
	],
	"./modules/lobby/components/Header/index": [
		52092,
		9
	],
	"./modules/lobby/components/Header/index.scss": [
		42565,
		9
	],
	"./modules/lobby/components/Header/index.tsx": [
		52092,
		9
	],
	"./modules/lobby/components/NewUI/Checkbox": [
		34266,
		9,
		34266
	],
	"./modules/lobby/components/NewUI/Checkbox.tsx": [
		34266,
		9,
		34266
	],
	"./modules/lobby/components/NewUI/NewUIButton": [
		55749,
		9,
		55749
	],
	"./modules/lobby/components/NewUI/NewUIButton.tsx": [
		55749,
		9,
		55749
	],
	"./modules/lobby/components/NewUI/NewUIFloating": [
		31087,
		9
	],
	"./modules/lobby/components/NewUI/NewUIFloating.tsx": [
		31087,
		9
	],
	"./modules/lobby/components/NewUI/NewUIIcon": [
		25910,
		9
	],
	"./modules/lobby/components/NewUI/NewUIIcon.tsx": [
		25910,
		9
	],
	"./modules/lobby/components/NewUI/NewUIPopup": [
		26107,
		9
	],
	"./modules/lobby/components/NewUI/NewUIPopup.scss": [
		36188,
		9
	],
	"./modules/lobby/components/NewUI/NewUIPopup.tsx": [
		26107,
		9
	],
	"./modules/lobby/components/NewUI/PopupCloseIcon": [
		75320,
		9
	],
	"./modules/lobby/components/NewUI/PopupCloseIcon.tsx": [
		75320,
		9
	],
	"./modules/lobby/components/RefreshBalance": [
		77444,
		9,
		77444
	],
	"./modules/lobby/components/RefreshBalance/": [
		77444,
		9,
		77444
	],
	"./modules/lobby/components/RefreshBalance/index": [
		77444,
		9,
		77444
	],
	"./modules/lobby/components/RefreshBalance/index.scss": [
		23701,
		9,
		23701
	],
	"./modules/lobby/components/RefreshBalance/index.tsx": [
		77444,
		9,
		77444
	],
	"./modules/lobby/components/Roadmaps": [
		25300,
		9
	],
	"./modules/lobby/components/Roadmaps/": [
		25300,
		9
	],
	"./modules/lobby/components/Roadmaps/InGameRoadMap": [
		39761,
		9
	],
	"./modules/lobby/components/Roadmaps/InGameRoadMap.tsx": [
		39761,
		9
	],
	"./modules/lobby/components/Roadmaps/LobbyRoadMap": [
		34766,
		9
	],
	"./modules/lobby/components/Roadmaps/LobbyRoadMap.tsx": [
		34766,
		9
	],
	"./modules/lobby/components/Roadmaps/NewGameRoadMap": [
		4598,
		9
	],
	"./modules/lobby/components/Roadmaps/NewGameRoadMap.tsx": [
		4598,
		9
	],
	"./modules/lobby/components/Roadmaps/SwitchTableRoadMap": [
		36346,
		9
	],
	"./modules/lobby/components/Roadmaps/SwitchTableRoadMap.tsx": [
		36346,
		9
	],
	"./modules/lobby/components/Roadmaps/index": [
		25300,
		9
	],
	"./modules/lobby/components/Roadmaps/index.tsx": [
		25300,
		9
	],
	"./modules/lobby/constants": [
		80042,
		9
	],
	"./modules/lobby/constants.ts": [
		80042,
		9
	],
	"./modules/lobby/index": [
		76981,
		9
	],
	"./modules/lobby/index.scss": [
		23118,
		9
	],
	"./modules/lobby/index.tsx": [
		76981,
		9
	],
	"./modules/lobby/selector": [
		86334,
		9
	],
	"./modules/lobby/selector.ts": [
		86334,
		9
	],
	"./modules/lobby/slice": [
		65353,
		9
	],
	"./modules/lobby/slice.ts": [
		65353,
		9
	],
	"./modules/lobbyw": [
		44780,
		9
	],
	"./modules/lobbyw/": [
		44780,
		9
	],
	"./modules/lobbyw/index": [
		44780,
		9
	],
	"./modules/lobbyw/index.tsx": [
		44780,
		9
	],
	"./modules/locales/components/LanguageSelector": [
		42122,
		9
	],
	"./modules/locales/components/LanguageSelector.tsx": [
		42122,
		9
	],
	"./modules/locales/i18n": [
		22946,
		9
	],
	"./modules/locales/i18n.ts": [
		22946,
		9
	],
	"./modules/main/selector": [
		3175,
		9
	],
	"./modules/main/selector.ts": [
		3175,
		9
	],
	"./modules/main/slice": [
		30117,
		9
	],
	"./modules/main/slice/": [
		30117,
		9
	],
	"./modules/main/slice/gift": [
		61591,
		9
	],
	"./modules/main/slice/gift.ts": [
		61591,
		9
	],
	"./modules/main/slice/index": [
		30117,
		9
	],
	"./modules/main/slice/index.ts": [
		30117,
		9
	],
	"./modules/main/slice/landing": [
		38650,
		9
	],
	"./modules/main/slice/landing.ts": [
		38650,
		9
	],
	"./modules/main/slice/limitRed": [
		12099,
		9
	],
	"./modules/main/slice/limitRed.ts": [
		12099,
		9
	],
	"./modules/main/slice/player": [
		65700,
		9
	],
	"./modules/main/slice/player.ts": [
		65700,
		9
	],
	"./modules/main/slice/promotiontool/promotionTool": [
		43454,
		9
	],
	"./modules/main/slice/promotiontool/promotionTool.ts": [
		43454,
		9
	],
	"./modules/main/slice/result": [
		22488,
		9
	],
	"./modules/main/slice/result.ts": [
		22488,
		9
	],
	"./modules/main/slice/user": [
		5378,
		9
	],
	"./modules/main/slice/user.ts": [
		5378,
		9
	],
	"./modules/multibet": [
		3531,
		9
	],
	"./modules/multibet/": [
		3531,
		9
	],
	"./modules/multibet/GameMessage/MultiBetGameResult": [
		35340,
		9
	],
	"./modules/multibet/GameMessage/MultiBetGameResult.tsx": [
		35340,
		9
	],
	"./modules/multibet/GameMessage/MultiBetResultPanel": [
		86242,
		9
	],
	"./modules/multibet/GameMessage/MultiBetResultPanel.tsx": [
		86242,
		9
	],
	"./modules/multibet/GameTables/MultiBetTableCell": [
		87395,
		9
	],
	"./modules/multibet/GameTables/MultiBetTableCell.tsx": [
		87395,
		9
	],
	"./modules/multibet/baccarat": [
		34761,
		9
	],
	"./modules/multibet/baccarat/": [
		34761,
		9
	],
	"./modules/multibet/baccarat/MultiBetBaccaratBetArea": [
		1318,
		9
	],
	"./modules/multibet/baccarat/MultiBetBaccaratBetArea.tsx": [
		1318,
		9
	],
	"./modules/multibet/baccarat/MultiBetSuperSixBetArea": [
		83354,
		9
	],
	"./modules/multibet/baccarat/MultiBetSuperSixBetArea.tsx": [
		83354,
		9
	],
	"./modules/multibet/baccarat/betAreaInfo": [
		88617,
		9
	],
	"./modules/multibet/baccarat/betAreaInfo.ts": [
		88617,
		9
	],
	"./modules/multibet/baccarat/index": [
		34761,
		9
	],
	"./modules/multibet/baccarat/index.tsx": [
		34761,
		9
	],
	"./modules/multibet/index": [
		3531,
		9
	],
	"./modules/multibet/index.scss": [
		54136,
		9
	],
	"./modules/multibet/index.tsx": [
		3531,
		9
	],
	"./modules/popup": [
		14932,
		9
	],
	"./modules/popup/": [
		14932,
		9
	],
	"./modules/popup/inGameSlice": [
		50956,
		9
	],
	"./modules/popup/inGameSlice.ts": [
		50956,
		9
	],
	"./modules/popup/index": [
		14932,
		9
	],
	"./modules/popup/index.tsx": [
		14932,
		9
	],
	"./modules/popup/promotiontool/PromotionUtil": [
		43884,
		9
	],
	"./modules/popup/promotiontool/PromotionUtil.ts": [
		43884,
		9
	],
	"./modules/popup/promotiontool/components/PromotionAnimation": [
		82511,
		9
	],
	"./modules/popup/promotiontool/components/PromotionAnimation.tsx": [
		82511,
		9
	],
	"./modules/popup/promotiontool/components/PromotionButton": [
		57421,
		9
	],
	"./modules/popup/promotiontool/components/PromotionButton.tsx": [
		57421,
		9
	],
	"./modules/popup/promotiontool/components/PromotionDialog": [
		81501,
		9
	],
	"./modules/popup/promotiontool/components/PromotionDialog.tsx": [
		81501,
		9
	],
	"./modules/popup/promotiontool/components/PromotionGacha": [
		98999,
		9
	],
	"./modules/popup/promotiontool/components/PromotionGacha.tsx": [
		98999,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRanking": [
		59051,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRanking.tsx": [
		59051,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRankingCell": [
		85791,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRankingCell.tsx": [
		85791,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRecord": [
		5790,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRecord.tsx": [
		5790,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRecordCell": [
		18274,
		9
	],
	"./modules/popup/promotiontool/components/PromotionRecordCell.tsx": [
		18274,
		9
	],
	"./modules/popup/promotiontool/components/PromotionScratchCard": [
		14513,
		9
	],
	"./modules/popup/promotiontool/components/PromotionScratchCard.tsx": [
		14513,
		9
	],
	"./modules/popup/promotiontool/components/PromotionSplash": [
		30660,
		9
	],
	"./modules/popup/promotiontool/components/PromotionSplash.tsx": [
		30660,
		9
	],
	"./modules/popup/promotiontool/components/index.scss": [
		21759,
		9
	],
	"./modules/popup/selector": [
		6992,
		9
	],
	"./modules/popup/selector.ts": [
		6992,
		9
	],
	"./modules/popup/slice": [
		72095,
		9
	],
	"./modules/popup/slice.ts": [
		72095,
		9
	],
	"./modules/progress": [
		73642,
		9
	],
	"./modules/progress/": [
		73642,
		9
	],
	"./modules/progress/LoadingProgress": [
		84663,
		9
	],
	"./modules/progress/LoadingProgress.tsx": [
		84663,
		9
	],
	"./modules/progress/index": [
		73642,
		9
	],
	"./modules/progress/index.scss": [
		51967,
		9
	],
	"./modules/progress/index.tsx": [
		73642,
		9
	],
	"./modules/progress/readme.md": [
		76637,
		1,
		76637
	],
	"./modules/progress/selector": [
		58921,
		9
	],
	"./modules/progress/selector.ts": [
		58921,
		9
	],
	"./modules/progress/slice": [
		40259,
		9
	],
	"./modules/progress/slice/": [
		40259,
		9
	],
	"./modules/progress/slice/index": [
		40259,
		9
	],
	"./modules/progress/slice/index.ts": [
		40259,
		9
	],
	"./modules/progress/slice/loading": [
		12739,
		9
	],
	"./modules/progress/slice/loading.ts": [
		12739,
		9
	],
	"./modules/progress/slice/result": [
		94742,
		9
	],
	"./modules/progress/slice/result.ts": [
		94742,
		9
	],
	"./modules/progress/slice/status": [
		61753,
		9
	],
	"./modules/progress/slice/status.ts": [
		61753,
		9
	],
	"./modules/progress/slice/time": [
		14214,
		9
	],
	"./modules/progress/slice/time.ts": [
		14214,
		9
	],
	"./modules/reconnectLayer": [
		25929,
		9
	],
	"./modules/reconnectLayer/": [
		25929,
		9
	],
	"./modules/reconnectLayer/index": [
		25929,
		9
	],
	"./modules/reconnectLayer/index.tsx": [
		25929,
		9
	],
	"./modules/report/components/DateRangePicker": [
		96889,
		9
	],
	"./modules/report/components/DateRangePicker.scss": [
		27130,
		9
	],
	"./modules/report/components/DateRangePicker.tsx": [
		96889,
		9
	],
	"./modules/report/selector": [
		7706,
		9
	],
	"./modules/report/selector.ts": [
		7706,
		9
	],
	"./modules/report/slice": [
		17390,
		9
	],
	"./modules/report/slice/": [
		17390,
		9
	],
	"./modules/report/slice/betRecord": [
		40444,
		9
	],
	"./modules/report/slice/betRecord.ts": [
		40444,
		9
	],
	"./modules/report/slice/betStatistics": [
		28866,
		9
	],
	"./modules/report/slice/betStatistics.ts": [
		28866,
		9
	],
	"./modules/report/slice/index": [
		17390,
		9
	],
	"./modules/report/slice/index.ts": [
		17390,
		9
	],
	"./modules/roadmap/andarBahar": [
		82366,
		9
	],
	"./modules/roadmap/andarBahar/": [
		82366,
		9
	],
	"./modules/roadmap/andarBahar/andarBahar.scss": [
		6043,
		9
	],
	"./modules/roadmap/andarBahar/cells/BeadRoadCell": [
		75040,
		9
	],
	"./modules/roadmap/andarBahar/cells/BeadRoadCell.tsx": [
		75040,
		9
	],
	"./modules/roadmap/andarBahar/cells/BigRoadCell": [
		24740,
		9
	],
	"./modules/roadmap/andarBahar/cells/BigRoadCell.tsx": [
		24740,
		9
	],
	"./modules/roadmap/andarBahar/cells/PointRoadCell": [
		56676,
		9
	],
	"./modules/roadmap/andarBahar/cells/PointRoadCell.tsx": [
		56676,
		9
	],
	"./modules/roadmap/andarBahar/hook": [
		40625,
		9
	],
	"./modules/roadmap/andarBahar/hook.tsx": [
		40625,
		9
	],
	"./modules/roadmap/andarBahar/index": [
		82366,
		9
	],
	"./modules/roadmap/andarBahar/index.tsx": [
		82366,
		9
	],
	"./modules/roadmap/andarBahar/util": [
		37632,
		9
	],
	"./modules/roadmap/andarBahar/util.ts": [
		37632,
		9
	],
	"./modules/roadmap/baccarat/cells/BeadRoadCell": [
		32067,
		9
	],
	"./modules/roadmap/baccarat/cells/BeadRoadCell.tsx": [
		32067,
		9
	],
	"./modules/roadmap/baccarat/cells/BigEyeAnimatedCell": [
		85515,
		9
	],
	"./modules/roadmap/baccarat/cells/BigEyeAnimatedCell.tsx": [
		85515,
		9
	],
	"./modules/roadmap/baccarat/cells/BigEyeCell": [
		50236,
		9
	],
	"./modules/roadmap/baccarat/cells/BigEyeCell.tsx": [
		50236,
		9
	],
	"./modules/roadmap/baccarat/cells/BigRoadCell": [
		58309,
		9
	],
	"./modules/roadmap/baccarat/cells/BigRoadCell.tsx": [
		58309,
		9
	],
	"./modules/roadmap/baccarat/cells/CockroachRoadAnimatedCell": [
		50991,
		9
	],
	"./modules/roadmap/baccarat/cells/CockroachRoadAnimatedCell.tsx": [
		50991,
		9
	],
	"./modules/roadmap/baccarat/cells/CockroachRoadCell": [
		46408,
		9
	],
	"./modules/roadmap/baccarat/cells/CockroachRoadCell.tsx": [
		46408,
		9
	],
	"./modules/roadmap/baccarat/cells/EmptyCell": [
		71946,
		9,
		71946
	],
	"./modules/roadmap/baccarat/cells/EmptyCell.tsx": [
		71946,
		9,
		71946
	],
	"./modules/roadmap/baccarat/cells/PointRoadCell": [
		22869,
		9
	],
	"./modules/roadmap/baccarat/cells/PointRoadCell.tsx": [
		22869,
		9
	],
	"./modules/roadmap/baccarat/cells/SmallRoadAnimatedCell": [
		99717,
		9
	],
	"./modules/roadmap/baccarat/cells/SmallRoadAnimatedCell.tsx": [
		99717,
		9
	],
	"./modules/roadmap/baccarat/cells/SmallRoadCell": [
		88570,
		9
	],
	"./modules/roadmap/baccarat/cells/SmallRoadCell.tsx": [
		88570,
		9
	],
	"./modules/roadmap/baccarat/hook": [
		33554,
		9
	],
	"./modules/roadmap/baccarat/hook.tsx": [
		33554,
		9
	],
	"./modules/roadmap/baccarat/map": [
		20640,
		9
	],
	"./modules/roadmap/baccarat/map/": [
		20640,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratInGameMap": [
		58010,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratInGameMap.tsx": [
		58010,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratMultiBetMap": [
		80831,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratMultiBetMap.tsx": [
		80831,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratRoadMap": [
		14405,
		9
	],
	"./modules/roadmap/baccarat/map/BaccaratRoadMap.tsx": [
		14405,
		9
	],
	"./modules/roadmap/baccarat/map/SwitchTableMap": [
		90992,
		9
	],
	"./modules/roadmap/baccarat/map/SwitchTableMap.tsx": [
		90992,
		9
	],
	"./modules/roadmap/baccarat/map/index": [
		20640,
		9
	],
	"./modules/roadmap/baccarat/map/index.scss": [
		58413,
		9
	],
	"./modules/roadmap/baccarat/map/index.ts": [
		20640,
		9
	],
	"./modules/roadmap/baccarat/svg": [
		41678,
		9
	],
	"./modules/roadmap/baccarat/svg/": [
		41678,
		9
	],
	"./modules/roadmap/baccarat/svg/BigBankerBankerPair.svg": [
		96806,
		1,
		96806
	],
	"./modules/roadmap/baccarat/svg/BigBankerBothPair.svg": [
		11956,
		1,
		11956
	],
	"./modules/roadmap/baccarat/svg/BigBankerPlayerPair.svg": [
		11942,
		1,
		11942
	],
	"./modules/roadmap/baccarat/svg/BigBankerTie.svg": [
		79321,
		1,
		79321
	],
	"./modules/roadmap/baccarat/svg/BigBankerWin.svg": [
		63641,
		1,
		63641
	],
	"./modules/roadmap/baccarat/svg/BigEyeBankerWin.svg": [
		9980,
		1,
		9980
	],
	"./modules/roadmap/baccarat/svg/BigEyePlayerWin.svg": [
		71612,
		1,
		71612
	],
	"./modules/roadmap/baccarat/svg/BigPlayerBankerPair.svg": [
		5950,
		1,
		5950
	],
	"./modules/roadmap/baccarat/svg/BigPlayerBothPair.svg": [
		14828,
		1,
		14828
	],
	"./modules/roadmap/baccarat/svg/BigPlayerPlayerPair.svg": [
		64446,
		1,
		64446
	],
	"./modules/roadmap/baccarat/svg/BigPlayerTie.svg": [
		31137,
		1,
		31137
	],
	"./modules/roadmap/baccarat/svg/BigPlayerWin.svg": [
		241,
		1,
		241
	],
	"./modules/roadmap/baccarat/svg/CockroachBankerWin.svg": [
		53994,
		1,
		53994
	],
	"./modules/roadmap/baccarat/svg/CockroachPlayerWin.svg": [
		62806,
		1,
		62806
	],
	"./modules/roadmap/baccarat/svg/Empty.svg": [
		73927,
		1,
		73927
	],
	"./modules/roadmap/baccarat/svg/SmallBankerWin.svg": [
		55908,
		1,
		55908
	],
	"./modules/roadmap/baccarat/svg/SmallPlayerWin.svg": [
		11364,
		1,
		11364
	],
	"./modules/roadmap/baccarat/svg/index": [
		41678,
		9
	],
	"./modules/roadmap/baccarat/svg/index.ts": [
		41678,
		9
	],
	"./modules/roadmap/baccarat/util": [
		43253,
		9
	],
	"./modules/roadmap/baccarat/util.ts": [
		43253,
		9
	],
	"./modules/roadmap/blackjack": [
		14256,
		9
	],
	"./modules/roadmap/blackjack/": [
		14256,
		9
	],
	"./modules/roadmap/blackjack/cell/CardCell": [
		5965,
		9
	],
	"./modules/roadmap/blackjack/cell/CardCell.tsx": [
		5965,
		9
	],
	"./modules/roadmap/blackjack/cell/PointCell": [
		11413,
		9
	],
	"./modules/roadmap/blackjack/cell/PointCell.tsx": [
		11413,
		9
	],
	"./modules/roadmap/blackjack/index": [
		14256,
		9
	],
	"./modules/roadmap/blackjack/index.scss": [
		40133,
		9
	],
	"./modules/roadmap/blackjack/index.tsx": [
		14256,
		9
	],
	"./modules/roadmap/dragonTiger": [
		22794,
		9
	],
	"./modules/roadmap/dragonTiger/": [
		22794,
		9
	],
	"./modules/roadmap/dragonTiger/cell/DTBeadRoadCell": [
		58783,
		9
	],
	"./modules/roadmap/dragonTiger/cell/DTBeadRoadCell.tsx": [
		58783,
		9
	],
	"./modules/roadmap/dragonTiger/dragonTiger.scss": [
		83525,
		9
	],
	"./modules/roadmap/dragonTiger/hook": [
		5997,
		9
	],
	"./modules/roadmap/dragonTiger/hook.tsx": [
		5997,
		9
	],
	"./modules/roadmap/dragonTiger/index": [
		22794,
		9
	],
	"./modules/roadmap/dragonTiger/index.tsx": [
		22794,
		9
	],
	"./modules/roadmap/dragonTiger/util": [
		79228,
		9
	],
	"./modules/roadmap/dragonTiger/util.ts": [
		79228,
		9
	],
	"./modules/roadmap/index.scss": [
		46158,
		9
	],
	"./modules/roadmap/pokdeng": [
		77562,
		9
	],
	"./modules/roadmap/pokdeng/": [
		77562,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengRoadmapGrid": [
		38868,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengRoadmapGrid.tsx": [
		38868,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengSingleCell": [
		79062,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengSingleCell.tsx": [
		79062,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengStatisticPanel": [
		6114,
		9
	],
	"./modules/roadmap/pokdeng/cells/PokDengStatisticPanel.tsx": [
		6114,
		9
	],
	"./modules/roadmap/pokdeng/hook": [
		55549,
		9
	],
	"./modules/roadmap/pokdeng/hook.tsx": [
		55549,
		9
	],
	"./modules/roadmap/pokdeng/index": [
		77562,
		9
	],
	"./modules/roadmap/pokdeng/index.tsx": [
		77562,
		9
	],
	"./modules/roadmap/pokdeng/pokdeng.scss": [
		99753,
		9
	],
	"./modules/roadmap/pokdeng/util": [
		52188,
		9
	],
	"./modules/roadmap/pokdeng/util.tsx": [
		52188,
		9
	],
	"./modules/roadmap/roulette": [
		64992,
		9
	],
	"./modules/roadmap/roulette/": [
		64992,
		9
	],
	"./modules/roadmap/roulette/cell/BeadRoadCell": [
		66417,
		9
	],
	"./modules/roadmap/roulette/cell/BeadRoadCell.tsx": [
		66417,
		9
	],
	"./modules/roadmap/roulette/cell/BigSmallRoadCell": [
		38290,
		9
	],
	"./modules/roadmap/roulette/cell/BigSmallRoadCell.tsx": [
		38290,
		9
	],
	"./modules/roadmap/roulette/cell/EvenOddRoadCell": [
		4046,
		9
	],
	"./modules/roadmap/roulette/cell/EvenOddRoadCell.tsx": [
		4046,
		9
	],
	"./modules/roadmap/roulette/cell/RedBlackRoadCell": [
		60243,
		9
	],
	"./modules/roadmap/roulette/cell/RedBlackRoadCell.tsx": [
		60243,
		9
	],
	"./modules/roadmap/roulette/hook": [
		96455,
		9
	],
	"./modules/roadmap/roulette/hook.tsx": [
		96455,
		9
	],
	"./modules/roadmap/roulette/index": [
		64992,
		9
	],
	"./modules/roadmap/roulette/index.scss": [
		49673,
		9
	],
	"./modules/roadmap/roulette/index.tsx": [
		64992,
		9
	],
	"./modules/roadmap/roulette/util": [
		92246,
		9
	],
	"./modules/roadmap/roulette/util.ts": [
		92246,
		9
	],
	"./modules/roadmap/sedie": [
		27478,
		9
	],
	"./modules/roadmap/sedie/": [
		27478,
		9
	],
	"./modules/roadmap/sedie/cells/BeadRoadCell": [
		4472,
		9
	],
	"./modules/roadmap/sedie/cells/BeadRoadCell.tsx": [
		4472,
		9
	],
	"./modules/roadmap/sedie/cells/BigSmallRoadCell": [
		3027,
		9
	],
	"./modules/roadmap/sedie/cells/BigSmallRoadCell.tsx": [
		3027,
		9
	],
	"./modules/roadmap/sedie/cells/EvenOddRoadCell": [
		14521,
		9
	],
	"./modules/roadmap/sedie/cells/EvenOddRoadCell.tsx": [
		14521,
		9
	],
	"./modules/roadmap/sedie/cells/PointRoadCell": [
		84284,
		9
	],
	"./modules/roadmap/sedie/cells/PointRoadCell.tsx": [
		84284,
		9
	],
	"./modules/roadmap/sedie/hook": [
		81897,
		9
	],
	"./modules/roadmap/sedie/hook.tsx": [
		81897,
		9
	],
	"./modules/roadmap/sedie/index": [
		27478,
		9
	],
	"./modules/roadmap/sedie/index.scss": [
		16183,
		9
	],
	"./modules/roadmap/sedie/index.tsx": [
		27478,
		9
	],
	"./modules/roadmap/sedie/util": [
		2328,
		9
	],
	"./modules/roadmap/sedie/util.ts": [
		2328,
		9
	],
	"./modules/roadmap/sicbo": [
		11266,
		9
	],
	"./modules/roadmap/sicbo/": [
		11266,
		9
	],
	"./modules/roadmap/sicbo/cell/HistoryCell": [
		82233,
		9
	],
	"./modules/roadmap/sicbo/cell/HistoryCell.tsx": [
		82233,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoBigSmallRoadCell": [
		53082,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoBigSmallRoadCell.tsx": [
		53082,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoOddEvenRoadCell": [
		89974,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoOddEvenRoadCell.tsx": [
		89974,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoPointRoadCell": [
		64611,
		9
	],
	"./modules/roadmap/sicbo/cell/SicBoPointRoadCell.tsx": [
		64611,
		9
	],
	"./modules/roadmap/sicbo/hook": [
		28773,
		9
	],
	"./modules/roadmap/sicbo/hook.tsx": [
		28773,
		9
	],
	"./modules/roadmap/sicbo/index": [
		11266,
		9
	],
	"./modules/roadmap/sicbo/index.tsx": [
		11266,
		9
	],
	"./modules/roadmap/sicbo/sicbo.scss": [
		33693,
		9
	],
	"./modules/roadmap/sicbo/util": [
		73972,
		9
	],
	"./modules/roadmap/sicbo/util.ts": [
		73972,
		9
	],
	"./modules/roadmap/slice": [
		78606,
		9
	],
	"./modules/roadmap/slice/": [
		78606,
		9
	],
	"./modules/roadmap/slice/index": [
		78606,
		9
	],
	"./modules/roadmap/slice/index.ts": [
		78606,
		9
	],
	"./modules/roadmap/teenpatti": [
		33998,
		9
	],
	"./modules/roadmap/teenpatti/": [
		33998,
		9
	],
	"./modules/roadmap/teenpatti/cells/BeadRoadCell": [
		70672,
		9
	],
	"./modules/roadmap/teenpatti/cells/BeadRoadCell.tsx": [
		70672,
		9
	],
	"./modules/roadmap/teenpatti/cells/BigRoadCell": [
		14292,
		9
	],
	"./modules/roadmap/teenpatti/cells/BigRoadCell.tsx": [
		14292,
		9
	],
	"./modules/roadmap/teenpatti/hook": [
		12385,
		9
	],
	"./modules/roadmap/teenpatti/hook.tsx": [
		12385,
		9
	],
	"./modules/roadmap/teenpatti/index": [
		33998,
		9
	],
	"./modules/roadmap/teenpatti/index.scss": [
		4591,
		9
	],
	"./modules/roadmap/teenpatti/index.tsx": [
		33998,
		9
	],
	"./modules/roadmap/teenpatti/util": [
		11984,
		9
	],
	"./modules/roadmap/teenpatti/util.ts": [
		11984,
		9
	],
	"./modules/routeController": [
		57966,
		9
	],
	"./modules/routeController/": [
		57966,
		9
	],
	"./modules/routeController/index": [
		57966,
		9
	],
	"./modules/routeController/index.tsx": [
		57966,
		9
	],
	"./modules/routeController/selector": [
		82287,
		9
	],
	"./modules/routeController/selector.tsx": [
		82287,
		9
	],
	"./modules/routeController/slice": [
		29888,
		9
	],
	"./modules/routeController/slice.tsx": [
		29888,
		9
	],
	"./modules/setting": [
		87725,
		9
	],
	"./modules/setting/": [
		87725,
		9
	],
	"./modules/setting/components/BetRecord": [
		77146,
		9
	],
	"./modules/setting/components/BetRecord.tsx": [
		77146,
		9
	],
	"./modules/setting/components/CancelButton": [
		73192,
		9
	],
	"./modules/setting/components/CancelButton.tsx": [
		73192,
		9
	],
	"./modules/setting/components/MemberReport": [
		83682,
		9
	],
	"./modules/setting/components/MemberReport.tsx": [
		83682,
		9
	],
	"./modules/setting/components/NestedDialog": [
		38688,
		9
	],
	"./modules/setting/components/NestedDialog.tsx": [
		38688,
		9
	],
	"./modules/setting/components/ReportDivider": [
		45461,
		9
	],
	"./modules/setting/components/ReportDivider.tsx": [
		45461,
		9
	],
	"./modules/setting/components/SettingMenu": [
		69264,
		9
	],
	"./modules/setting/components/SettingMenu.tsx": [
		69264,
		9
	],
	"./modules/setting/components/TickButton": [
		86993,
		9
	],
	"./modules/setting/components/TickButton.tsx": [
		86993,
		9
	],
	"./modules/setting/components/UserSetting": [
		71799,
		9
	],
	"./modules/setting/components/UserSetting.tsx": [
		71799,
		9
	],
	"./modules/setting/components/UsernameGrid": [
		57050,
		9
	],
	"./modules/setting/components/UsernameGrid.tsx": [
		57050,
		9
	],
	"./modules/setting/components/betRecord/BaccGameResultRecordPanel": [
		6924,
		9
	],
	"./modules/setting/components/betRecord/BaccGameResultRecordPanel.tsx": [
		6924,
		9
	],
	"./modules/setting/components/betRecord/BetRecordDetailsReport": [
		82213,
		9
	],
	"./modules/setting/components/betRecord/BetRecordDetailsReport.tsx": [
		82213,
		9
	],
	"./modules/setting/components/betRecord/BetRecordReport": [
		23555,
		9
	],
	"./modules/setting/components/betRecord/BetRecordReport.tsx": [
		23555,
		9
	],
	"./modules/setting/components/betRecord/BlackjackDetailContentRemark": [
		90657,
		9
	],
	"./modules/setting/components/betRecord/BlackjackDetailContentRemark.tsx": [
		90657,
		9
	],
	"./modules/setting/components/betRecord/BlackjackResultRecordPanel": [
		12681,
		9
	],
	"./modules/setting/components/betRecord/BlackjackResultRecordPanel.tsx": [
		12681,
		9
	],
	"./modules/setting/components/betRecord/Details": [
		70267,
		9
	],
	"./modules/setting/components/betRecord/Details.tsx": [
		70267,
		9
	],
	"./modules/setting/components/betRecord/DragonTigerResultRecordPanel": [
		86555,
		9
	],
	"./modules/setting/components/betRecord/DragonTigerResultRecordPanel.tsx": [
		86555,
		9
	],
	"./modules/setting/components/betRecord/GameTypeSelector": [
		49953,
		9
	],
	"./modules/setting/components/betRecord/GameTypeSelector.tsx": [
		49953,
		9
	],
	"./modules/setting/components/betRecord/PokDengGameResultRecordPanel": [
		67989,
		9
	],
	"./modules/setting/components/betRecord/PokDengGameResultRecordPanel.tsx": [
		67989,
		9
	],
	"./modules/setting/components/betRecord/RouletteGameResultRecordPanel": [
		98291,
		9
	],
	"./modules/setting/components/betRecord/RouletteGameResultRecordPanel.tsx": [
		98291,
		9
	],
	"./modules/setting/components/betRecord/SedieGameResultRecordPanel": [
		45453,
		9
	],
	"./modules/setting/components/betRecord/SedieGameResultRecordPanel.tsx": [
		45453,
		9
	],
	"./modules/setting/components/betRecord/SicBoResultRecordPanel": [
		60923,
		9
	],
	"./modules/setting/components/betRecord/SicBoResultRecordPanel.tsx": [
		60923,
		9
	],
	"./modules/setting/components/betRecord/Summary": [
		74755,
		9
	],
	"./modules/setting/components/betRecord/Summary.tsx": [
		74755,
		9
	],
	"./modules/setting/components/betRecord/TeenPattiResultRecordPanel": [
		88851,
		9
	],
	"./modules/setting/components/betRecord/TeenPattiResultRecordPanel.tsx": [
		88851,
		9
	],
	"./modules/setting/components/betRecord/andarBahar/AndarBaharResultDetailPanel": [
		42144,
		9
	],
	"./modules/setting/components/betRecord/andarBahar/AndarBaharResultDetailPanel.tsx": [
		42144,
		9
	],
	"./modules/setting/components/betRecord/andarBahar/AndarBaharResultRecordPanel": [
		49020,
		9
	],
	"./modules/setting/components/betRecord/andarBahar/AndarBaharResultRecordPanel.tsx": [
		49020,
		9
	],
	"./modules/setting/components/changePassword": [
		27873,
		9
	],
	"./modules/setting/components/changePassword/": [
		27873,
		9
	],
	"./modules/setting/components/changePassword/components/PasswordScoreBar": [
		26823,
		9
	],
	"./modules/setting/components/changePassword/components/PasswordScoreBar.tsx": [
		26823,
		9
	],
	"./modules/setting/components/changePassword/index": [
		27873,
		9
	],
	"./modules/setting/components/changePassword/index.scss": [
		98605,
		9
	],
	"./modules/setting/components/changePassword/index.tsx": [
		27873,
		9
	],
	"./modules/setting/components/feedbackForm": [
		99333,
		9
	],
	"./modules/setting/components/feedbackForm/": [
		99333,
		9
	],
	"./modules/setting/components/feedbackForm/components/FeedbackRating": [
		7861,
		9
	],
	"./modules/setting/components/feedbackForm/components/FeedbackRating.tsx": [
		7861,
		9
	],
	"./modules/setting/components/feedbackForm/components/RatingRadio": [
		44334,
		9
	],
	"./modules/setting/components/feedbackForm/components/RatingRadio.tsx": [
		44334,
		9
	],
	"./modules/setting/components/feedbackForm/index": [
		99333,
		9
	],
	"./modules/setting/components/feedbackForm/index.scss": [
		18513,
		9
	],
	"./modules/setting/components/feedbackForm/index.tsx": [
		99333,
		9
	],
	"./modules/setting/components/gameRules": [
		52338,
		9
	],
	"./modules/setting/components/gameRules/": [
		52338,
		9
	],
	"./modules/setting/components/gameRules/index": [
		52338,
		9
	],
	"./modules/setting/components/gameRules/index.tsx": [
		52338,
		9
	],
	"./modules/setting/components/member/GameCategorySelector": [
		61540,
		9
	],
	"./modules/setting/components/member/GameCategorySelector.tsx": [
		61540,
		9
	],
	"./modules/setting/components/promotionBubble": [
		95728,
		9
	],
	"./modules/setting/components/promotionBubble/": [
		95728,
		9
	],
	"./modules/setting/components/promotionBubble/index": [
		95728,
		9
	],
	"./modules/setting/components/promotionBubble/index.tsx": [
		95728,
		9
	],
	"./modules/setting/components/promotionDetail": [
		83349,
		9
	],
	"./modules/setting/components/promotionDetail/": [
		83349,
		9
	],
	"./modules/setting/components/promotionDetail/index": [
		83349,
		9
	],
	"./modules/setting/components/promotionDetail/index.tsx": [
		83349,
		9
	],
	"./modules/setting/components/promotionIndicator": [
		29989,
		9
	],
	"./modules/setting/components/promotionIndicator/": [
		29989,
		9
	],
	"./modules/setting/components/promotionIndicator/index": [
		29989,
		9
	],
	"./modules/setting/components/promotionIndicator/index.tsx": [
		29989,
		9
	],
	"./modules/setting/components/settingDialog": [
		89241,
		9
	],
	"./modules/setting/components/settingDialog/": [
		89241,
		9
	],
	"./modules/setting/components/settingDialog/index": [
		89241,
		9
	],
	"./modules/setting/components/settingDialog/index.tsx": [
		89241,
		9
	],
	"./modules/setting/components/userInformation": [
		92336,
		9
	],
	"./modules/setting/components/userInformation/": [
		92336,
		9
	],
	"./modules/setting/components/userInformation/index": [
		92336,
		9
	],
	"./modules/setting/components/userInformation/index.scss": [
		59625,
		9
	],
	"./modules/setting/components/userInformation/index.tsx": [
		92336,
		9
	],
	"./modules/setting/components/userSetting/MusicSelector": [
		98468,
		9,
		98468
	],
	"./modules/setting/components/userSetting/MusicSelector.tsx": [
		98468,
		9,
		98468
	],
	"./modules/setting/components/userSetting/VoiceSelector": [
		93855,
		9
	],
	"./modules/setting/components/userSetting/VoiceSelector.tsx": [
		93855,
		9
	],
	"./modules/setting/components/userSetting/VolumeSlider": [
		83283,
		9
	],
	"./modules/setting/components/userSetting/VolumeSlider.scss": [
		90930,
		9
	],
	"./modules/setting/components/userSetting/VolumeSlider.tsx": [
		83283,
		9
	],
	"./modules/setting/index": [
		87725,
		9
	],
	"./modules/setting/index.scss": [
		87886,
		9
	],
	"./modules/setting/index.tsx": [
		87725,
		9
	],
	"./modules/setting/selector": [
		16302,
		9
	],
	"./modules/setting/selector.ts": [
		16302,
		9
	],
	"./modules/setting/slice": [
		35874,
		9
	],
	"./modules/setting/slice/": [
		35874,
		9
	],
	"./modules/setting/slice/index": [
		35874,
		9
	],
	"./modules/setting/slice/index.ts": [
		35874,
		9
	],
	"./modules/setting/slice/sound": [
		36373,
		9
	],
	"./modules/setting/slice/sound.ts": [
		36373,
		9
	],
	"./modules/setting/slice/volume": [
		31542,
		9
	],
	"./modules/setting/slice/volume.ts": [
		31542,
		9
	],
	"./modules/thanksForPlaying": [
		45653,
		9
	],
	"./modules/thanksForPlaying/": [
		45653,
		9
	],
	"./modules/thanksForPlaying/index": [
		45653,
		9
	],
	"./modules/thanksForPlaying/index.tsx": [
		45653,
		9
	],
	"./modules/totalBet/slice": [
		48725,
		9
	],
	"./modules/totalBet/slice/": [
		48725,
		9
	],
	"./modules/totalBet/slice/index": [
		48725,
		9
	],
	"./modules/totalBet/slice/index.ts": [
		48725,
		9
	],
	"./modules/videoPlayer": [
		98823,
		9
	],
	"./modules/videoPlayer/": [
		98823,
		9
	],
	"./modules/videoPlayer/components/liveEmojiButton": [
		2042,
		9
	],
	"./modules/videoPlayer/components/liveEmojiButton.scss": [
		20987,
		9
	],
	"./modules/videoPlayer/components/liveEmojiButton.tsx": [
		2042,
		9
	],
	"./modules/videoPlayer/components/videoControlPanel": [
		87412,
		9
	],
	"./modules/videoPlayer/components/videoControlPanel.tsx": [
		87412,
		9
	],
	"./modules/videoPlayer/components/videoQualityButton": [
		57556,
		9
	],
	"./modules/videoPlayer/components/videoQualityButton.tsx": [
		57556,
		9
	],
	"./modules/videoPlayer/components/videoZoomButton": [
		81102,
		9
	],
	"./modules/videoPlayer/components/videoZoomButton.tsx": [
		81102,
		9
	],
	"./modules/videoPlayer/index": [
		98823,
		9
	],
	"./modules/videoPlayer/index.tsx": [
		98823,
		9
	],
	"./override": [
		85528,
		9
	],
	"./override.ts": [
		85528,
		9
	],
	"./react-app-env.d": [
		26319,
		7,
		26319
	],
	"./react-app-env.d.ts": [
		26319,
		7,
		26319
	],
	"./reportWebVitals": [
		12153,
		9
	],
	"./reportWebVitals.ts": [
		12153,
		9
	],
	"./serviceWorkerRegistration": [
		398,
		9
	],
	"./serviceWorkerRegistration.ts": [
		398,
		9
	],
	"./store/rootEpic": [
		61923,
		9
	],
	"./store/rootEpic.ts": [
		61923,
		9
	],
	"./store/rootReducer": [
		74332,
		9
	],
	"./store/rootReducer.ts": [
		74332,
		9
	],
	"./store/store": [
		81881,
		9
	],
	"./store/store.ts": [
		81881,
		9
	],
	"./theme": [
		73359,
		9
	],
	"./theme.ts": [
		73359,
		9
	],
	"./types/MultiPlayer.d": [
		30298,
		7,
		30298
	],
	"./types/MultiPlayer.d.ts": [
		30298,
		7,
		30298
	],
	"./types/interface": [
		98475,
		9,
		98475
	],
	"./types/interface.ts": [
		98475,
		9,
		98475
	],
	"./types/webaudio.d": [
		48612,
		7,
		48612
	],
	"./types/webaudio.d.ts": [
		48612,
		7,
		48612
	],
	"./utils/bitwiseUtil": [
		1271,
		9
	],
	"./utils/bitwiseUtil.ts": [
		1271,
		9
	],
	"./utils/commonFunc": [
		86731,
		9
	],
	"./utils/commonFunc.tsx": [
		86731,
		9
	],
	"./utils/formatter": [
		66502,
		9
	],
	"./utils/formatter.tsx": [
		66502,
		9
	],
	"./utils/ga": [
		2457,
		9
	],
	"./utils/ga/": [
		2457,
		9
	],
	"./utils/ga/command": [
		10396,
		9
	],
	"./utils/ga/command.ts": [
		10396,
		9
	],
	"./utils/ga/index": [
		2457,
		9
	],
	"./utils/ga/index.ts": [
		2457,
		9
	],
	"./utils/games/andarBahar": [
		28992,
		9
	],
	"./utils/games/andarBahar.ts": [
		28992,
		9
	],
	"./utils/games/baccarat": [
		67511,
		9
	],
	"./utils/games/baccarat.ts": [
		67511,
		9
	],
	"./utils/games/blackjack": [
		97052,
		9
	],
	"./utils/games/blackjack.ts": [
		97052,
		9
	],
	"./utils/games/dragonTiger": [
		74298,
		9
	],
	"./utils/games/dragonTiger.tsx": [
		74298,
		9
	],
	"./utils/games/pokdeng": [
		75958,
		9
	],
	"./utils/games/pokdeng.tsx": [
		75958,
		9
	],
	"./utils/games/roulette": [
		99602,
		9
	],
	"./utils/games/roulette.ts": [
		99602,
		9
	],
	"./utils/games/sedie": [
		99650,
		9
	],
	"./utils/games/sedie.ts": [
		99650,
		9
	],
	"./utils/games/sicbo": [
		7422,
		9
	],
	"./utils/games/sicbo.ts": [
		7422,
		9
	],
	"./utils/games/teenpatti": [
		61262,
		9
	],
	"./utils/games/teenpatti.ts": [
		61262,
		9
	],
	"./utils/pokerCount": [
		32970,
		9
	],
	"./utils/pokerCount.ts": [
		32970,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;